import $76EG6$babelruntimehelpersdefineProperty from "@babel/runtime/helpers/defineProperty";
import { onCleanup as $76EG6$onCleanup, createEffect as $76EG6$createEffect, createSignal as $76EG6$createSignal } from "solid-js";
import $76EG6$babelruntimehelpersclassPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import $76EG6$babelruntimehelpersclassPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import { template as $76EG6$template, getNextElement as $76EG6$getNextElement, className as $76EG6$className, insert as $76EG6$insert, setAttribute as $76EG6$setAttribute, spread as $76EG6$spread, mergeProps as $76EG6$mergeProps, runHydrationEvents as $76EG6$runHydrationEvents, addEventListener as $76EG6$addEventListener, getNextMarker as $76EG6$getNextMarker, delegateEvents as $76EG6$delegateEvents, effect as $76EG6$effect, style as $76EG6$style, createComponent as $76EG6$createComponent } from "solid-js/web";
import { register_es_version } from "../multi_import_deduplicator.mjs";
register_es_version("utilishared", "ES10");
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $b9e07ce3c67aa344$export$83d89fbfd8236492 = "2.6.0";
const $a5a2bdb4ae93374b$export$55fe61489d2c7417 = /*@__PURE__*/((_globalThis$document, _globalThis$document$, _globalThis$document$2, _globalThis$localStor, _globalThis$localStor2) => process.env.STRIP_DEBUG === "true" ? false : process.env.DEBUG === "true" || process.env.NODE_ENV === "development" || process.env.BUILD_TARGET !== "node" && ((globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : (_globalThis$document$ = _globalThis$document.currentScript) === null || _globalThis$document$ === void 0 ? void 0 : (_globalThis$document$2 = _globalThis$document$.dataset) === null || _globalThis$document$2 === void 0 ? void 0 : _globalThis$document$2.debug) === "true" || (globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$localStor = globalThis.localStorage) === null || _globalThis$localStor === void 0 ? void 0 : (_globalThis$localStor2 = _globalThis$localStor.getItem) === null || _globalThis$localStor2 === void 0 ? void 0 : _globalThis$localStor2.call(_globalThis$localStor, "debug")) === "true"))();
const $241f2f02cc612a49$var$browser_prefix_styling = "color: #fff;";
let $241f2f02cc612a49$var$browser_prefix = "[Depict]";
const $241f2f02cc612a49$export$2dd75a6b038dc8cb = str => {
  $241f2f02cc612a49$var$browser_prefix = str;
};
function $241f2f02cc612a49$var$decorated_log(console_command) {
  if (0, $a5a2bdb4ae93374b$export$55fe61489d2c7417) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
    console_command(...(process.env.BUILD_TARGET === "node" ? [new Date().toISOString()] : ["%c".concat($241f2f02cc612a49$var$browser_prefix), $241f2f02cc612a49$var$browser_prefix_styling]), ...args);
  }
}
function $241f2f02cc612a49$export$de56f1198d121036() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
  /* eslint-disable no-console */
  $241f2f02cc612a49$var$decorated_log(console.log.bind(console), ...args);
}
function $241f2f02cc612a49$export$c2363754d4758444() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) args[_key3] = arguments[_key3];
  /* eslint-disable no-console */
  $241f2f02cc612a49$var$decorated_log(console.warn.bind(console), ...args);
}
function $241f2f02cc612a49$export$997143d41f6a0c9b() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
  /* eslint-disable no-console */
  $241f2f02cc612a49$var$decorated_log(console.error.bind(console), ...args);
}
const $ea5707b8e7b350cf$export$60d1d0e3cfc8b9ed = {};
function $ea5707b8e7b350cf$export$2cefb7e61fcbae00(package_name, version) {
  $241f2f02cc612a49$export$de56f1198d121036("@depict-ai/" + package_name + " version", version);
  $ea5707b8e7b350cf$export$60d1d0e3cfc8b9ed[package_name] = version;
}
function $ea5707b8e7b350cf$export$fe609f0216e4ebef(url) {
  const got_url_object = url instanceof URL;
  const url_object = got_url_object ? url : new URL(url, location.origin);
  for (const [key, value] of Object.entries($ea5707b8e7b350cf$export$60d1d0e3cfc8b9ed)) url_object.searchParams.set(key, value);
  return got_url_object ? url_object.href : url_object;
}
class $449d6683cecfa078$export$e2c811ae0eb35313 {
  constructor() {
    $76EG6$babelruntimehelpersdefineProperty(this, "subscribers_", []);
    $76EG6$babelruntimehelpersdefineProperty(this, "waiting_for_update_", 0);
    $76EG6$babelruntimehelpersdefineProperty(this, "queue_", []);
    $76EG6$babelruntimehelpersdefineProperty(this, "last_processed_value_", void 0);
    $76EG6$babelruntimehelpersdefineProperty(this, "has_had_value_", false);
    $76EG6$babelruntimehelpersdefineProperty(this, "push_value_", value => {
      this.queue_.push(value);
      this.call_subscribers_();
    });
    $76EG6$babelruntimehelpersdefineProperty(this, "call_subscribers_", () => {
      // intentionally arrow fn so it doesn't matter what .this is when being called
      if (this.waiting_for_update_ <= 0 && this.queue_.length) {
        // shift value
        const next_value = this.queue_.shift();
        this.last_processed_value_ = next_value;
        this.has_had_value_ || (this.has_had_value_ = true);
        for (let i = 0; i < this.subscribers_.length; i++) {
          this.waiting_for_update_++;
          this.subscribers_[i](next_value);
        }
      }
    });
    $76EG6$babelruntimehelpersdefineProperty(this, "subscriber_done_", () => {
      this.waiting_for_update_--;
      this.call_subscribers_();
    });
  }
}
function $449d6683cecfa078$export$3e42f5078e3abfc0(state) {
  const asyncIterable = {
    [Symbol.asyncIterator]() {
      let resolve_value_promise;
      let value_promise;
      let subscribed_fn_is_processing = false;
      const update_promises = () => {
        value_promise = new Promise(r => resolve_value_promise = r);
      };
      const current_subscribed_fn = value => {
        subscribed_fn_is_processing = true;
        resolve_value_promise({
          value: value,
          done: false
        });
      };
      const set_processs_done = () => {
        if (subscribed_fn_is_processing) {
          subscribed_fn_is_processing = false;
          state.subscriber_done_();
        }
      };
      update_promises();
      state.subscribers_.push(current_subscribed_fn);
      return {
        next() {
          update_promises(); // do this first
          set_processs_done(); // will lead to new resolving of promises
          return value_promise;
        },
        return() {
          // This will be reached if the consumer called 'break' or 'return' early in the loop.
          const index = state.subscribers_.indexOf(current_subscribed_fn);
          if (index >= 0) state.subscribers_.splice(index, 1);
          set_processs_done(); // this will trigger subscribers to run again so we want to have removed ourselves first
          return Promise.resolve({
            done: true
          }); // typescript goes nuts otherwise lol
        }
      };
    }
  };

  return Object.assign(function () {
    for (let i = 0; i < arguments.length; i++) state.push_value_(i < 0 || arguments.length <= i ? undefined : arguments[i]);
  }, asyncIterable);
}

/**
 * You know how you can write `break` inside of a `for await` loop to exit it? Well, this lets you break the loop from outside. Pass any async iterable that never throws and you will get back a function and a specially proxied async iterable. Whenever you call the function all for await loops iterating the returned iterable will break. Note: This will add some extra ticks because awaiting thenable objects takes more ticks than awaiting promises.
 * @param  async_iterable               The async iterable you want to make exitable
 * @return                                                                 An array containing a function, the exit function, and a wrapped async iterable
 */
function $fee212025270d5b9$export$927664b47117acb0(async_iterable) {
  const promise_result_setting_functions = new Map();
  const exit_function = () => {
    const exit_iterator_object = {
      done: true,
      value: undefined
    };
    for (const [iterator, on_resolve_or_on_finally] of promise_result_setting_functions) {
      var _iterator$return;
      if (!on_resolve_or_on_finally) throw new Error("Got no resolve fn");
      on_resolve_or_on_finally((iterator === null || iterator === void 0 ? void 0 : (_iterator$return = iterator["return"]) === null || _iterator$return === void 0 ? void 0 : _iterator$return.call(iterator)) || exit_iterator_object);
    }
    promise_result_setting_functions.clear();
  };
  const modified_async_iterable = {
    [Symbol.asyncIterator]: () => {
      const orig_iterator = async_iterable[Symbol.asyncIterator]();
      return new Proxy(orig_iterator, {
        get(target, property) {
          if (property === "next") return () => {
            const orig_next_result = orig_iterator.next();
            return {
              then: (fulfill, reject) => {
                promise_result_setting_functions.set(orig_iterator, fulfill);
                return orig_next_result.then(value => {
                  promise_result_setting_functions.delete(orig_iterator);
                  return fulfill(value);
                }, reject);
              }
            };
          };
          return target[property];
        }
      });
    }
  };
  return [exit_function, modified_async_iterable];
}

// source: https://fettblog.eu/typescript-assertion-signatures/
function $56f6527795ab68e8$export$8df876135bad6d96(obj, prop, val) {
  Object.defineProperty(obj, prop, val);
}
const $7ca6fdc721083788$var$compat_layer_to_info = /*@__PURE__*/new WeakMap();
function $7ca6fdc721083788$export$e806c6c1615a59ae() {
  let async_iterator_should_return_state_on_first_call = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  let state_obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new (0, $449d6683cecfa078$export$e2c811ae0eb35313)();
  // @ts-ignore
  $7ca6fdc721083788$var$on_async_iterator_next_called({}); // work around https://github.com/swc-project/swc/issues/5530
  const ai = $449d6683cecfa078$export$3e42f5078e3abfc0(state_obj);
  const [exit, exitable] = $fee212025270d5b9$export$927664b47117acb0({
    ...ai
  });
  const obj = Object.assign(exitable, {
    exit: exit
  });
  if (async_iterator_should_return_state_on_first_call) {
    const orig_iterator = {
      [Symbol.asyncIterator]: obj[Symbol.asyncIterator]
    };
    obj[Symbol.asyncIterator] = () => {
      let was_exited = false;
      let should_unblock_state_obj_after_next_called = false;
      let stock_return_function;
      const unblock_state_obj = () => {
        if (should_unblock_state_obj_after_next_called) {
          should_unblock_state_obj_after_next_called = false;
          state_obj.waiting_for_update_--;
          state_obj.call_subscribers_();
        }
      };
      const async_generator = async function* () {
        if (was_exited) return; // just in case
        if (state_obj.has_had_value_) {
          state_obj.waiting_for_update_++; // block RawObservableInformation from changing a value while we feed this to our for-await loop, this makes so that values can't be missed if they are pushed as a result by below yield
          should_unblock_state_obj_after_next_called = true;
          yield state_obj.last_processed_value_;
          // if we have resolved with a value before info.last_processed_valuestate should no longer be undefined (unless T is undefined) so we can assert this being non-null
          if (was_exited) {
            // only once we're at `yield* exitable_for_async_generator;` exit_async_generator will be able to make the async generator stop and return, we add this check so that it also works before
            unblock_state_obj();
            return;
          }
        }
        yield* $7ca6fdc721083788$var$on_async_iterator_next_called(exitable_for_async_generator, unblock_state_obj, fn => stock_return_function = fn);
      };
      const iterator = async_generator();
      const [exit_async_generator, exitable_for_async_generator] = $fee212025270d5b9$export$927664b47117acb0(orig_iterator);
      // we can't use a normal async generator since it can't be "quit" from the outside (by calling .return on the AsyncIterator) while being awaited apparently
      // therefore we make the async iterable that it's (soon) passing control onto exitable by calling .return() (even if a .next() promise is being currently awaited)
      iterator.return = () => {
        var _stock_return_functio;
        (_stock_return_functio = stock_return_function) === null || _stock_return_functio === void 0 || _stock_return_functio();
        unblock_state_obj();
        exit_async_generator();
        was_exited = true;
        return Promise.resolve({
          done: true,
          value: undefined
        });
      };
      return iterator;
    };
  }
  const callable_obj_with_everything = Object.assign(ai, obj);
  $56f6527795ab68e8$export$8df876135bad6d96(callable_obj_with_everything, "state", {
    get: () => state_obj.last_processed_value_,
    enumerable: true
  });
  $56f6527795ab68e8$export$8df876135bad6d96(callable_obj_with_everything, "latest_call_value", {
    get: () => {
      var _state_obj$queue_;
      return (_state_obj$queue_ = state_obj.queue_[state_obj.queue_.length - 1]) !== null && _state_obj$queue_ !== void 0 ? _state_obj$queue_ : callable_obj_with_everything.state;
    },
    enumerable: true
  });
  $7ca6fdc721083788$var$compat_layer_to_info.set(callable_obj_with_everything, new WeakRef(state_obj));
  return callable_obj_with_everything;
}
function $7ca6fdc721083788$var$on_async_iterator_next_called(async_iterable, before_next_return, set_stock_return_function) {
  return new Proxy(async_iterable, {
    get(target, property) {
      return new Proxy(target[property], {
        apply(target, this_arg, arg_list) {
          const iterator = target.apply(this_arg, arg_list);
          const {
            return: return_fn
          } = iterator;
          if (return_fn) set_stock_return_function === null || set_stock_return_function === void 0 || set_stock_return_function(return_fn);
          return new Proxy(iterator, {
            get(inner_target, inner_property) {
              const value = inner_target[inner_property];
              if (inner_property === "next") return new Proxy(value, {
                apply(next_target, next_this_arg, next_arg_list) {
                  const retval = next_target.apply(next_this_arg, next_arg_list);
                  before_next_return();
                  return retval;
                }
              });
              return value;
            }
          });
        }
      });
    }
  });
}
function $7ca6fdc721083788$export$90740b5bc9c2b3b7(ipns) {
  var _compat_layer_to_info, _compat_layer_to_info2;
  const internal_state_obj = (_compat_layer_to_info = $7ca6fdc721083788$var$compat_layer_to_info.get(ipns)) === null || _compat_layer_to_info === void 0 ? void 0 : (_compat_layer_to_info2 = _compat_layer_to_info.deref) === null || _compat_layer_to_info2 === void 0 ? void 0 : _compat_layer_to_info2.call(_compat_layer_to_info);
  if (!internal_state_obj) throw new Error("Couldn't get state obj");
  return $7ca6fdc721083788$export$e806c6c1615a59ae(false, internal_state_obj);
}
function $7ca6fdc721083788$export$10c3e52ef388b81b(ipns) {
  var _compat_layer_to_info3, _compat_layer_to_info4;
  const internal_state_obj = (_compat_layer_to_info3 = $7ca6fdc721083788$var$compat_layer_to_info.get(ipns)) === null || _compat_layer_to_info3 === void 0 ? void 0 : (_compat_layer_to_info4 = _compat_layer_to_info3.deref) === null || _compat_layer_to_info4 === void 0 ? void 0 : _compat_layer_to_info4.call(_compat_layer_to_info3);
  if (!internal_state_obj) throw new Error("Couldn't get state obj");
  return $7ca6fdc721083788$export$e806c6c1615a59ae(true, internal_state_obj);
}
const $17bb552dedcd526c$export$af2e17a20c2ea3c5 = !(process.env.SENTRY === "true" || process.env.DEPICT_ERROR_REPORTING === "true" || process.env.NEXT_PUBLIC_DEPICT_ERROR_REPORTING === "true") && (process.env.SENTRY === "false" || process.env.DEPICT_ERROR_REPORTING === "false" || process.env.NEXT_PUBLIC_DEPICT_ERROR_REPORTING === "false" || (0, $a5a2bdb4ae93374b$export$55fe61489d2c7417)) ? /*@__PURE__*/$17bb552dedcd526c$var$fakesentry() : /*@__PURE__*/$e5da8b4d1e6c12b3$export$2e2bcd8739ae039(process.env.TENANT || "unknown", undefined, (0, $241f2f02cc612a49$export$de56f1198d121036));
function $17bb552dedcd526c$var$fakesentry() {
  // // source: https://docs.sentry.io/platforms/javascript/troubleshooting/#dealing-with-ad-blockers
  // const handler = {
  //   get: function (_, key) {
  //     return new Proxy(function (cb) {
  //       if (key === "flush" || key === "close") return Promise.resolve();
  //       if (typeof cb === "function") return cb(fake_sentry);
  //       return fake_sentry;
  //     }, handler);
  //   },
  // };
  // var fake_sentry = new Proxy({ captureException: () => {}, captureMessage: () => {}, withScope: () => {} }, handler);
  // the magical proxy stuff has infinite looped for me on rp, old fashioned NOOP functions will have to make do
  const fake_sentry = {
    captureException: () => {},
    captureMessage: () => {},
    withScope: () => {}
  };
  return fake_sentry;
}
function $b000f5ef6ce456d9$export$8048b892d651b310(exception, error_for_stack) {
  $241f2f02cc612a49$export$de56f1198d121036(exception);
  if (0, $a5a2bdb4ae93374b$export$55fe61489d2c7417) /* eslint-disable no-console */console.trace();
  if (process.env.BUILD_TARGET !== "node") {
    const {
      stack: stack
    } = error_for_stack instanceof Error ? error_for_stack : new Error();
    const msg_is_error = exception instanceof Error;
    (0, $17bb552dedcd526c$export$af2e17a20c2ea3c5).withScope(function (scope) {
      if (msg_is_error) scope.setExtra("primary_stack", exception.stack);
      scope.setExtra(msg_is_error ? "secondary_stack" : "stack", stack);
      scope.setLevel("error");
      this.captureMessage(exception);
    });
  }
  return undefined;
}
async function $2da62df28669a48a$export$2fc1a072736ae2f6(obj, property) {
  let value;
  if (typeof obj[property] === "undefined") value = await $2da62df28669a48a$var$wait_for_variable_in_object(property, obj).catch((0, $b000f5ef6ce456d9$export$8048b892d651b310));else value = obj[property];
  for (var _len = arguments.length, sub_objects_to_wait_for = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) sub_objects_to_wait_for[_key - 2] = arguments[_key];
  if (value && sub_objects_to_wait_for !== null && sub_objects_to_wait_for !== void 0 && sub_objects_to_wait_for.length) return $2da62df28669a48a$export$2fc1a072736ae2f6(value, ...sub_objects_to_wait_for).catch((0, $b000f5ef6ce456d9$export$8048b892d651b310));else return value;
}
async function $2da62df28669a48a$var$wait_for_variable_in_object(variable, obj) {
  const start = new Date().getTime();
  $241f2f02cc612a49$export$de56f1198d121036("waiting for definition of variable", variable, "in", obj);
  let var_behind_the_scenes;
  let resolve_variable_definition;
  let was_defined = false;
  const definition_of_var = new Promise(r => resolve_variable_definition = r);
  const previous_descriptor = $2da62df28669a48a$export$d5062f468a0454f3(obj, variable);
  const get = typeof (previous_descriptor === null || previous_descriptor === void 0 ? void 0 : previous_descriptor.get) == "function" ? previous_descriptor.get : () => var_behind_the_scenes;
  const set = typeof (previous_descriptor === null || previous_descriptor === void 0 ? void 0 : previous_descriptor.set) == "function" ? new Proxy(previous_descriptor.set, {
    apply(target, this_arg, arguments_list) {
      if (!was_defined) {
        was_defined = true;
        resolve_variable_definition(arguments_list[0]);
      }
      return target.apply(this_arg, arguments_list);
    }
  }) : value => {
    if (!was_defined) {
      was_defined = true;
      resolve_variable_definition(value);
    }
    return var_behind_the_scenes = value;
  };
  Object.defineProperty(obj, variable, {
    configurable: true,
    enumerable: true,
    get: get,
    set: set
  });
  $241f2f02cc612a49$export$de56f1198d121036("everything's set up, waiting for promise by setter to resolve");
  const result = await definition_of_var;
  $241f2f02cc612a49$export$de56f1198d121036("Promise resolved, ", result, " is here. We waited", new Date().getTime() - start, "ms");
  return result;
}
function $2da62df28669a48a$export$d5062f468a0454f3(obj, prop) {
  // https://stackoverflow.com/a/38802602/10659982
  if (obj != null) return Object.hasOwnProperty.call(obj, prop) ? Object.getOwnPropertyDescriptor(obj, prop) : $2da62df28669a48a$export$d5062f468a0454f3(Object.getPrototypeOf(obj), prop);
}
function $2da62df28669a48a$export$79f910a98828378d(obj, variable, async_iterator_should_return_state_on_first_call) {
  const definition_ipns = $7ca6fdc721083788$export$e806c6c1615a59ae(async_iterator_should_return_state_on_first_call);
  let var_behind_the_scenes = obj[variable];
  definition_ipns(var_behind_the_scenes); // resolve with initial value
  const previous_descriptor = $2da62df28669a48a$export$d5062f468a0454f3(obj, variable);
  const get = typeof (previous_descriptor === null || previous_descriptor === void 0 ? void 0 : previous_descriptor.get) == "function" ? previous_descriptor.get : () => var_behind_the_scenes;
  const set = typeof (previous_descriptor === null || previous_descriptor === void 0 ? void 0 : previous_descriptor.set) == "function" ? new Proxy(previous_descriptor.set, {
    apply(target, this_arg, arguments_list) {
      definition_ipns(arguments_list[0]);
      return target.apply(this_arg, arguments_list);
    }
  }) : value => {
    definition_ipns(value);
    var_behind_the_scenes = value;
  };
  Object.defineProperty(obj, variable, {
    configurable: true,
    enumerable: true,
    get: get,
    set: set
  });
  return definition_ipns;
}
let $e5da8b4d1e6c12b3$var$overrideEnvironment;
const $e5da8b4d1e6c12b3$export$a13bb02a27aaa5e6 = env => $e5da8b4d1e6c12b3$var$overrideEnvironment = env;
function $e5da8b4d1e6c12b3$export$2e2bcd8739ae039(TENANT, more_options, dlog, extra_sentry_url, script_integrity) {
  const sentry_object = {};
  if (process.env.BUILD_TARGET !== "modern" && Proxy.toString().indexOf("[native code]") === -1) {
    // Proxy polyfill needs defined things to work. If any other sentry function is desired to be used, please add it to the array below for ie11 compatibility
    const known_keys = ["isOlderThan", "bindClient", "pushScope", "popScope", "withScope", "getClient", "getScope", "getStack", "getStackTop", "captureException", "captureMessage", "captureEvent", "lastEventId", "addBreadcrumb", "setUser", "setTags", "setExtras", "setTag", "setExtra", "setContext", "configureScope", "run", "getIntegration", "startSpan", "startTransaction", "traceHeaders", "captureSession", "endSession", "startSession", "_sendSessionUpdate", "_invokeClient", "_callExtensionMethod", "_version", "_stack", "_lastEventId"];
    known_keys.forEach(fn => sentry_object[fn] = () => {});
  }
  // the sentry "hub" we usually use only has functions - except for "_version", "_stack" and "_lastEventId"
  // for all these functions we will push the arguments to a stack which we go through once sentry has loaded
  // we will return a promise that resolves to the eventual result of the function result
  // meaning a fictional Sentry.returnsauce will return a promise that resolves to "sauce", given that sentry.returnsauce usually returns "sauce"
  // for the things that are not a function we will return a promise resolving to its value once sentry has loaded - sorry lazy loaded sentry users, you'll have to adapt your code to deal with it
  // i don't expect anyone ever having to do that tho because when's the last time you accessed Sentry._stack ???
  const not_functions = ["_version", "_stack", "_lastEventId"];
  const function_backlog = {};
  const getter_backlog = [];
  let actual_sentry;
  const sentry = new Proxy(sentry_object, {
    get(target, property) {
      if (property === "then")
        // browsers do thenable checks by calling .then on any returned object of an awaited function, ignore it (probably not needed because proxy implementation should be robust enough maybe I'll remove it later)
        return;
      let resolve_with_value;
      const value_promise = new Promise(r => resolve_with_value = r);
      const property_as_string = property.toString();
      if (property_as_string.includes("Symbol"))
        // if someone runs String(Sentry) they fail miserably without this check
        return target[property];else if (not_functions.includes(property_as_string)) {
        getter_backlog.push([property, resolve_with_value]);
        process_calls();
        return value_promise;
      } else return function () {
        if (!Array.isArray(function_backlog[property]))
          // this check needs to be like this so that functions of an object - i.e. toString get replaced
          function_backlog[property] = [];
        const stack_for_fn = function_backlog[property];
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
        stack_for_fn.push({
          args: args,
          resolve: resolve_with_value
        });
        process_calls();
        return value_promise;
      };
    }
  });
  return sentry;
  async function process_calls() {
    let sentry;
    /* eslint-disable no-console */
    const err = console.log.bind(console); // we can't feed errors from here into sentry - it might create an infinite loop
    dlog || (dlog = process.env.DEBUG == "true" ? err : () => {});
    let attempt = 0;
    while (!(sentry = await actual_sentry)) {
      // retry if fails for some reason
      if (++attempt > 3) {
        // hopefully this code will never be reached but if loading fails thrice we do nothing and leave everthing how it was
        actual_sentry = false;
        return;
      }
      // we define it as promise so that not multiple functions load it when started at the same time
      actual_sentry = $e5da8b4d1e6c12b3$var$load_sentry(TENANT, more_options, extra_sentry_url, script_integrity).catch(err);
    }
    // we now for sure have sentry and can start processing the events
    // call functions and resolve results
    for (const fn in function_backlog) {
      const backlog_for_fn = function_backlog[fn];
      backlog_for_fn.forEach((backlog_obj, index) => {
        const {
          args: args,
          resolve: resolve
        } = backlog_obj;
        try {
          sentry.run(current_hub => {
            if (typeof current_hub[fn] == "function") {
              // quick hack to be able to get actual hub to make withScope work
              const bound_args = args.map(arg => {
                if (typeof arg == "function") return arg.bind(current_hub);else return arg;
              });
              resolve(current_hub[fn](...bound_args));
            } else resolve(undefined);
          });
        } catch (e) {
          err(e);
        }
        backlog_for_fn.splice(index, 1);
      });
    }
    getter_backlog.forEach((getter, index) => {
      const [property, resolve_with_value] = getter;
      resolve_with_value && resolve_with_value(sentry[property]);
      getter_backlog.splice(index, 1);
    });
  }
}
async function $e5da8b4d1e6c12b3$var$load_sentry(TENANT) {
  let more_options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let extra_sentry_url = arguments.length > 2 ? arguments[2] : undefined;
  let script_integrity = arguments.length > 3 ? arguments[3] : undefined;
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  if (script_integrity) {
    script.integrity = script_integrity;
    script.setAttribute("crossorigin", "anonymous");
  }
  script.src = extra_sentry_url || "https://cdn.depict.ai/lazy_sentry/depict-ai.js";
  document.head.appendChild(script);
  const global_var_name = "_depict_ai_sentry";
  const {
    BrowserClient: BrowserClient,
    Hub: Hub,
    defaultIntegrations: defaultIntegrations
  } = await $2da62df28669a48a$export$2fc1a072736ae2f6(window, global_var_name);
  delete window[global_var_name];
  if (process.env.SENTRY_SAMPLE_RATE) {
    var _more_options$sampleR;
    const sample_rate = parseFloat(process.env.SENTRY_SAMPLE_RATE);
    (_more_options$sampleR = more_options.sampleRate) !== null && _more_options$sampleR !== void 0 ? _more_options$sampleR : more_options.sampleRate = sample_rate;
  }
  const client = new BrowserClient({
    dsn: "https://1dd6c18a286b40a69dab1cdfe80bad9b@o464891.ingest.sentry.io/5476183",
    release: process.env.sentry_version,
    environment: $e5da8b4d1e6c12b3$var$overrideEnvironment || TENANT,
    // @ts-ignore - can't seem to get the typing to work
    integrations: defaultIntegrations,
    ...more_options
  });
  const hub = new Hub(client);
  hub.bindClient(client); // WHAT ARE YOU DOING SENTRY, WHY IS THIS CALL + the hub.run EQUIRED FOR INTEGRATIONS TO WORK? It's way too hard to figure out
  // related issues:
  // https://github.com/getsentry/sentry-javascript/issues/2622
  // https://github.com/getsentry/sentry-javascript/issues/2541
  // https://github.com/getsentry/sentry-javascript/issues/2541
  return hub;
}

/**
 * Finds most frequent item in an array, written by chatGPT with some nudging. Returns `undefined` if the array is empty.
 * @param arr array to find the most frequent item in
 */
function $c9b2d210d5bbc418$export$2d9dc2897d88588(arr) {
  const freqMap = arr.reduce((map, item) => map.set(item, (map.get(item) || 0) + 1), new Map());
  const maxFreq = Math.max(...freqMap.values());
  for (let [key, value] of freqMap) {
    if (value === maxFreq) return key;
  }
}

// Source: https://stackoverflow.com/a/30106551
/**
 * Encoding UTF8 ⇢ base64
 */
function $5c580d87c093cc47$export$a1893782a2a6be0d(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode(parseInt(p1, 16));
  }));
}
function $5c580d87c093cc47$export$a7e53ec3b3fdd030(str) {
  return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
}
function $5e1f45affc1d7def$export$b3bbfd758f11cfa9(fn, message) {
  let severity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "error";
  return function () {
    const report_w_severity = e => $5e1f45affc1d7def$export$f18d5b0af29128b7(message ? [e, message] : e, severity);
    try {
      var _fn$constructor;
      const return_value = Reflect.apply(fn, this, arguments);
      if ((fn === null || fn === void 0 ? void 0 : (_fn$constructor = fn.constructor) === null || _fn$constructor === void 0 ? void 0 : _fn$constructor.name) === "AsyncFunction" || typeof (return_value === null || return_value === void 0 ? void 0 : return_value.then) === "function") return return_value.catch(report_w_severity);
      return return_value;
    } catch (e) {
      report_w_severity(e);
    }
  };
}
function $5e1f45affc1d7def$export$f18d5b0af29128b7(msg, severity) {
  let input_data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const has_human_readable_name = Array.isArray(msg);
  if (0, $a5a2bdb4ae93374b$export$55fe61489d2c7417) /* eslint-disable no-console */console.info("[sentry-".concat(severity, "]:"), ...(has_human_readable_name ? msg.reverse() : [msg]), "\n", input_data);
  (0, $17bb552dedcd526c$export$af2e17a20c2ea3c5).withScope(function (scope) {
    const data_for_sending = {
      stack: has_human_readable_name ? msg[0] : msg,
      ...input_data,
      ...(has_human_readable_name ? {
        exception_message: msg[0].message
      } : {})
    };
    for (const key in data_for_sending) scope.setExtra(key, data_for_sending[key]);
    scope.setLevel(severity);
    this.captureException(has_human_readable_name ? new Proxy(msg[0], {
      get(target, property) {
        if (property === "message") return msg[1];
        return target[property];
      }
    }) : msg);
  });
}

/**
 * Gives a random number between min and max (potentially including min and max).
 * @param min The minimum number.
 * @param max The maximum number.
 * @returns a random number
 */
function $1cd1e96fe31c935d$export$bb0a9c36cf454ea0(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $9c44a7238815fa47$export$535946eb77c946dd(the_function) {
  let busy = false;
  let current_promise;
  return $5e1f45affc1d7def$export$b3bbfd758f11cfa9(async function () {
    // Double awaits to make sure that if busy is true, it must also be true two ticks later.
    // This is a fix for when a promise that finalizes immediately is passed.
    // For context: https://javascript.info/microtask-queue
    if (!busy || !(await await busy, busy)) {
      busy = true;
      const to_finally = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(the_function)(...arguments);
      current_promise = to_finally.finally(() => busy = false);
    }
    return current_promise;
  });
}
function $9c44a7238815fa47$export$f241be8e610f5c77(the_function) {
  let busy = false;
  let queued;
  let current_promise;
  const wrapped_fn = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(async function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    // Double awaits to make sure that if busy is true, it must also be true two ticks later.
    // This is a fix for when a promise that finalizes immediately is passed.
    // For context: https://javascript.info/microtask-queue
    if (!busy || !(await await busy, busy)) {
      busy = true;
      const to_finally = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(the_function)(...args);
      current_promise = to_finally.finally(() => {
        busy = false;
        if (queued) {
          const q_val = queued;
          queued = undefined;
          wrapped_fn(...q_val);
        }
      });
    } else queued = args;
    return current_promise;
  });
  return wrapped_fn;
}
function $4c6e595091defcd9$var$_classPrivateMethodInitSpec(obj, privateSet) {
  $4c6e595091defcd9$var$_checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}
function $4c6e595091defcd9$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $4c6e595091defcd9$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $4c6e595091defcd9$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $4c6e595091defcd9$var$_classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
  return fn;
}
/**
 * @deprecated use async_iterable_ipns instead. It has a nicer API and more of an ecosystem.
 */
var $4c6e595091defcd9$var$_values_to_resolve_with = /*#__PURE__*/new WeakMap();
var $4c6e595091defcd9$var$_internal_resolve = /*#__PURE__*/new WeakMap();
var $4c6e595091defcd9$var$_previous_promise = /*#__PURE__*/new WeakMap();
var $4c6e595091defcd9$var$_work_queue_max_once = /*#__PURE__*/new WeakMap();
var $4c6e595091defcd9$var$_work_queue = /*#__PURE__*/new WeakSet();
class $4c6e595091defcd9$export$32ccf3a614c84258 {
  constructor() {
    $4c6e595091defcd9$var$_classPrivateMethodInitSpec(this, $4c6e595091defcd9$var$_work_queue);
    $4c6e595091defcd9$var$_classPrivateFieldInitSpec(this, $4c6e595091defcd9$var$_values_to_resolve_with, {
      writable: true,
      value: []
    });
    $4c6e595091defcd9$var$_classPrivateFieldInitSpec(this, $4c6e595091defcd9$var$_internal_resolve, {
      writable: true,
      value: void 0
    });
    $4c6e595091defcd9$var$_classPrivateFieldInitSpec(this, $4c6e595091defcd9$var$_previous_promise, {
      writable: true,
      value: Promise.resolve()
    });
    $76EG6$babelruntimehelpersdefineProperty(this, "promise", new Promise(r => $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $4c6e595091defcd9$var$_internal_resolve, r)));
    $4c6e595091defcd9$var$_classPrivateFieldInitSpec(this, $4c6e595091defcd9$var$_work_queue_max_once, {
      writable: true,
      value: $9c44a7238815fa47$export$535946eb77c946dd($4c6e595091defcd9$var$_classPrivateMethodGet(this, $4c6e595091defcd9$var$_work_queue, $4c6e595091defcd9$var$_work_queue2).bind(this))
    });
    $76EG6$babelruntimehelpersdefineProperty(this, "resolve", value => {
      $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $4c6e595091defcd9$var$_values_to_resolve_with).push(value);
      $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $4c6e595091defcd9$var$_work_queue_max_once).call(this);
    });
  }
}
async function $4c6e595091defcd9$var$_work_queue2() {
  const vtrw = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $4c6e595091defcd9$var$_values_to_resolve_with);
  for (let i = 0; i < vtrw.length; i++) {
    await $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $4c6e595091defcd9$var$_previous_promise);
    const oldresolve = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $4c6e595091defcd9$var$_internal_resolve);
    $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $4c6e595091defcd9$var$_previous_promise, this.promise);
    this.promise = new Promise(r => $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $4c6e595091defcd9$var$_internal_resolve, r));
    oldresolve(vtrw[i]);
  }
  while (vtrw.length) vtrw.pop();
}
function $f5a4b8e233f0e1cd$var$_classPrivateMethodInitSpec(obj, privateSet) {
  $f5a4b8e233f0e1cd$var$_checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}
function $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $f5a4b8e233f0e1cd$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $f5a4b8e233f0e1cd$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $f5a4b8e233f0e1cd$var$_classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
  return fn;
}
const $f5a4b8e233f0e1cd$var$ONE_MINUTE = 60000;
var $f5a4b8e233f0e1cd$var$_ws_constructor_options = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_possible_events = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_ons = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_try_again_in_ms = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_fails = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_max_fails = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_max_backoff_ms = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_initial_reconnect_delay = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_connect = /*#__PURE__*/new WeakSet();
var $f5a4b8e233f0e1cd$var$_setup_dot_on_event_support = /*#__PURE__*/new WeakSet();
var $f5a4b8e233f0e1cd$var$_ensure_connection = /*#__PURE__*/new WeakSet();
class $f5a4b8e233f0e1cd$export$1b28bc5c68cc4d77 extends EventTarget {
  // WHEN MAKING CHANGES, PLEASE KEEP IN MIND THAT THIS CLASS IS ALSO USED ON THE FRONTEND
  increase_fails() {
    var _this$fails, _this$fails2;
    $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_fails, (_this$fails = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_fails), _this$fails2 = _this$fails++, _this$fails)), _this$fails2;
    if ($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_fails) > $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_max_fails)) {
      this.restart_ws();
      $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_fails, 0);
    }
  }
  async send() {
    this.current_socket.send(...arguments);
  }
  constructor(url, protocols) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    super();
    $f5a4b8e233f0e1cd$var$_classPrivateMethodInitSpec(this, $f5a4b8e233f0e1cd$var$_ensure_connection);
    $f5a4b8e233f0e1cd$var$_classPrivateMethodInitSpec(this, $f5a4b8e233f0e1cd$var$_setup_dot_on_event_support);
    $f5a4b8e233f0e1cd$var$_classPrivateMethodInitSpec(this, $f5a4b8e233f0e1cd$var$_connect);
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_initial_reconnect_delay, {
      get: $f5a4b8e233f0e1cd$var$_get_initial_reconnect_delay,
      set: void 0
    });
    $76EG6$babelruntimehelpersdefineProperty(this, "current_socket", void 0);
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_ws_constructor_options, {
      writable: true,
      value: void 0
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_possible_events, {
      writable: true,
      value: ["close", "error", "message", "open"]
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_ons, {
      writable: true,
      value: {}
    });
    $76EG6$babelruntimehelpersdefineProperty(this, "restart_ws", void 0);
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_try_again_in_ms, {
      writable: true,
      value: $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_initial_reconnect_delay)
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_fails, {
      writable: true,
      value: 0
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_max_fails, {
      writable: true,
      value: 10
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_max_backoff_ms, {
      writable: true,
      value: $f5a4b8e233f0e1cd$var$ONE_MINUTE
    });
    $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_ws_constructor_options, [url, protocols]);
    const {
      max_backoff_ms: max_backoff_ms
    } = options;
    if (max_backoff_ms) $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_max_backoff_ms, max_backoff_ms);
    $f5a4b8e233f0e1cd$var$_classPrivateMethodGet(this, $f5a4b8e233f0e1cd$var$_setup_dot_on_event_support, $f5a4b8e233f0e1cd$var$_setup_dot_on_event_support2).call(this);
    $f5a4b8e233f0e1cd$var$_classPrivateMethodGet(this, $f5a4b8e233f0e1cd$var$_connect, $f5a4b8e233f0e1cd$var$_connect2).call(this);
    $f5a4b8e233f0e1cd$var$_classPrivateMethodGet(this, $f5a4b8e233f0e1cd$var$_ensure_connection, $f5a4b8e233f0e1cd$var$_ensure_connection2).call(this).catch(e => $5e1f45affc1d7def$export$f18d5b0af29128b7(e, "error"));
    this.addEventListener("open", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
      $241f2f02cc612a49$export$de56f1198d121036("Connection opened");
      $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_try_again_in_ms, $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_initial_reconnect_delay)); // reset exponential backoff
    }));
  }
}

function $f5a4b8e233f0e1cd$var$_get_initial_reconnect_delay() {
  return $1cd1e96fe31c935d$export$bb0a9c36cf454ea0(1, 1000);
}
function $f5a4b8e233f0e1cd$var$_connect2() {
  this.current_socket = typeof window === "object" || typeof WebSocket === "function" ? new WebSocket(...$76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_ws_constructor_options)) : {
    readyState: 0,
    addEventListener: () => {},
    send: () => {}
  };
  $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_possible_events).forEach(name => {
    this.current_socket.addEventListener(name, $5e1f45affc1d7def$export$b3bbfd758f11cfa9(original_event => {
      let fixed_event;
      if (!(original_event instanceof Event)) {
        var _fixed_event;
        // Node - the WS class uses a predecessor of EventTarget and doesn't fire actual events, which we need for dispatchEvent since we're an EventTarget
        fixed_event = new Event(name);
        delete original_event["target"];
        delete original_event["type"];
        Object.assign(fixed_event, original_event);
        // @ts-ignore
        (_fixed_event = fixed_event).data || (_fixed_event.data = original_event.data);
        // original_event can either be an event from the 'ws' npm package which is some custom made event for something that extends EventEmitter or an actual Event
        // the event will only have `.data` if it's a message or close event, but wdgaf because setting undefined = undefined is still undefined
        // ts-ignore because it would be very hard to teach typescript the situation
      } else try {
        // @ts-ignore
        fixed_event = new original_event.constructor(original_event.type, original_event); // modern browsers - clones an event as well as possible
      } catch (e) {
        // IE11 and the likes
        // dlog("Can't reconstruct event", e, original_event, "trying to make a CustomEvent instead");
        fixed_event = new CustomEvent(original_event.type, original_event);
        const intermediate = {};
        for (const key in original_event) intermediate[key] = original_event[key]; // for some reason Object.assign doesn't work because things like MessageEvent.data are not enumarable
        delete intermediate["target"];
        Object.assign(fixed_event, intermediate);
      }
      this.dispatchEvent(fixed_event);
    }));
  });
}
function $f5a4b8e233f0e1cd$var$_setup_dot_on_event_support2() {
  // the idea is to make AutoReconnectingWS usable just like a normal WebSocket
  // so that you can do .onmessage or .addEventListener("message", handler) on an AutoReconnectingWS. It basically abstracts away connections that can close and die to one big EventTarget where you don't need to care about the underlying connection
  // this is how we add .onmessage, .onclose, .onopen and .onerror support to our EventTarget (this class)
  for (const ev of $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_possible_events)) {
    Object.defineProperty(this, "on" + ev, {
      configurable: false,
      enumerable: true,
      get: () => $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_ons)[ev],
      set: v => $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_ons)[ev] = v
    });
    this.addEventListener(ev, e => {
      // e can be MessageEvent | CloseEvent | ErrorEvent I think
      const on_fn = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_ons)[ev];
      if (typeof on_fn === "function") $5e1f45affc1d7def$export$b3bbfd758f11cfa9(on_fn).call(ev, e);
    });
  }
}
async function $f5a4b8e233f0e1cd$var$_ensure_connection2() {
  while (true) {
    const error = await new Promise(resolve => {
      this.addEventListener("close", resolve);
      this.addEventListener("error", resolve);
      this.restart_ws = resolve;
    });
    this.removeEventListener("close", this.restart_ws);
    this.removeEventListener("error", this.restart_ws);
    // 4100 means server thinks this is a scraper bot that's ignoring robots.txt
    // @ts-ignore
    if ((error === null || error === void 0 ? void 0 : error.code) === 4100) {
      $241f2f02cc612a49$export$de56f1198d121036("Websocket connection rejected by server, won't reconnect", error);
      return;
    }
    $241f2f02cc612a49$export$de56f1198d121036("Somehow the websocket died", error, "message:", error === null || error === void 0 ? void 0 : error.message, "code:", error === null || error === void 0 ? void 0 : error.code, "reason:", error === null || error === void 0 ? void 0 : error.reason, "reconnecting in", $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_try_again_in_ms));
    await new Promise(r => {
      var _globalThis$addEventL;
      // "race" the timeout and getting an https://developer.mozilla.org/en-US/docs/Web/API/Window/online_event by the browser
      const handler = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(ev => {
        r();
        $241f2f02cc612a49$export$de56f1198d121036("Retrying due to 'online' event", ev);
        clearTimeout(timeout);
      });
      globalThis === null || globalThis === void 0 || (_globalThis$addEventL = globalThis.addEventListener) === null || _globalThis$addEventL === void 0 || _globalThis$addEventL.call(globalThis, "online", handler, {
        once: true
      });
      const timeout = setTimeout($5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
        var _globalThis$removeEve;
        $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_try_again_in_ms, $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_try_again_in_ms) * (1.5 + Math.random()));
        if ($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_try_again_in_ms) > $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_max_backoff_ms)) $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_try_again_in_ms, $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_max_backoff_ms) * (1 + Math.random() / 10));
        r();
        globalThis === null || globalThis === void 0 || (_globalThis$removeEve = globalThis.removeEventListener) === null || _globalThis$removeEve === void 0 || _globalThis$removeEve.call(globalThis, "online", handler);
      }), $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_try_again_in_ms));
    });
    $f5a4b8e233f0e1cd$var$_classPrivateMethodGet(this, $f5a4b8e233f0e1cd$var$_connect, $f5a4b8e233f0e1cd$var$_connect2).call(this);
  }
}
var $f5a4b8e233f0e1cd$var$_msg_ipns = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_initial_retry_ms = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_connection_last_active = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_reconnect_if_dead_for_ms = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_messages_queued = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_wait_for_open_and_send = /*#__PURE__*/new WeakSet();
var $f5a4b8e233f0e1cd$var$_start_reconnection_if_offline_process = /*#__PURE__*/new WeakMap();
var $f5a4b8e233f0e1cd$var$_periodic_send = /*#__PURE__*/new WeakSet();
class $f5a4b8e233f0e1cd$export$1d9c6fddbff3441f extends $f5a4b8e233f0e1cd$export$1b28bc5c68cc4d77 {
  // WHEN MAKING CHANGES, PLEASE KEEP IN MIND THAT THIS CLASS IS ALSO USED ON THE FRONTEND
  async ensure_sent(payload) {
    const json_payload = JSON.stringify(payload);
    const stop_sending = $f5a4b8e233f0e1cd$var$_classPrivateMethodGet(this, $f5a4b8e233f0e1cd$var$_periodic_send, $f5a4b8e233f0e1cd$var$_periodic_send2).call(this, json_payload);
    while (true) {
      const {
        data: data
      } = await $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_msg_ipns).promise;
      let reply;
      try {
        reply = JSON.parse(data);
      } catch (e) {
        const msg = "Got malformed message (ignoring, might cause memory leak)";
        $241f2f02cc612a49$export$de56f1198d121036(msg, data, e);
        $5e1f45affc1d7def$export$f18d5b0af29128b7([e, msg], "error", {
          data: data
        });
        continue;
      }
      if (reply.id == payload.id) {
        const {
          status: status
        } = reply;
        if (status == "ack") {
          stop_sending();
          continue;
        } else if (status == "not-ok") $241f2f02cc612a49$export$c2363754d4758444("Got reply not-ok reply from server for event!", payload, reply);else if (status == "ok") {
          if (process.env.BUILD_TARGET !== "node") {
            var _payload$event;
            $241f2f02cc612a49$export$de56f1198d121036("Successfully sent ".concat(payload === null || payload === void 0 ? void 0 : (_payload$event = payload.event) === null || _payload$event === void 0 ? void 0 : _payload$event.type, " (WS)"), payload, reply);
          }
        } else $241f2f02cc612a49$export$c2363754d4758444("Strange reply from WSS server to", payload, ":", reply);
        stop_sending();
        return [reply, data];
      }
    }
  }
  constructor() {
    var _ref;
    super(...arguments);
    $f5a4b8e233f0e1cd$var$_classPrivateMethodInitSpec(this, $f5a4b8e233f0e1cd$var$_periodic_send);
    $f5a4b8e233f0e1cd$var$_classPrivateMethodInitSpec(this, $f5a4b8e233f0e1cd$var$_wait_for_open_and_send);
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_msg_ipns, {
      writable: true,
      value: new (0, $4c6e595091defcd9$export$32ccf3a614c84258)()
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_initial_retry_ms, {
      writable: true,
      value: 5000
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_connection_last_active, {
      writable: true,
      value: 0
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_reconnect_if_dead_for_ms, {
      writable: true,
      value: 20000
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_messages_queued, {
      writable: true,
      value: 0
    });
    $f5a4b8e233f0e1cd$var$_classPrivateFieldInitSpec(this, $f5a4b8e233f0e1cd$var$_start_reconnection_if_offline_process, {
      writable: true,
      value: $9c44a7238815fa47$export$535946eb77c946dd(async () => {
        await new Promise(r => setTimeout(r, $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_reconnect_if_dead_for_ms) + $1cd1e96fe31c935d$export$bb0a9c36cf454ea0(-2, 10)));
        // so if we are trying to send something and there's no activity ("error" which could mean the server is down or message or reconnection) we can safely assume that the internet connection is down. In that case we skip the exponential backoff since we want to know when we're connected again ASAP and just retry every like 20s
        if ($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_messages_queued) === 0) return;
        const now = +new Date();
        if (now - $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_connection_last_active) > $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_reconnect_if_dead_for_ms)) {
          const reason = "No activity in ".concat($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_reconnect_if_dead_for_ms), " ms");
          $241f2f02cc612a49$export$de56f1198d121036(reason, "reconnecting ws");
          this.restart_ws(reason);
        }
      })
    });
    const option_retry_ms = (_ref = arguments.length <= 2 ? undefined : arguments[2]) === null || _ref === void 0 ? void 0 : _ref.initial_retry_ms;
    if (option_retry_ms) $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_initial_retry_ms, option_retry_ms);
    this.addEventListener("message", $5e1f45affc1d7def$export$b3bbfd758f11cfa9($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_msg_ipns).resolve));
    ["open", "error", "message"].forEach(event => this.addEventListener(event, $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_connection_last_active, +new Date()))));
  }
}
async function $f5a4b8e233f0e1cd$var$_wait_for_open_and_send2(msg) {
  while (this.current_socket.readyState !== 1) await new Promise(resolve => {
    this.addEventListener("open", resolve, {
      once: true
    });
  });
  this.send(msg);
}
function $f5a4b8e233f0e1cd$var$_periodic_send2(msg) {
  var _this$messages_queued, _this$messages_queued2;
  let delay_to_next_send = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_initial_retry_ms);
  let quit = false;
  $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_messages_queued, (_this$messages_queued = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_messages_queued), _this$messages_queued2 = _this$messages_queued++, _this$messages_queued)), _this$messages_queued2;
  (async (_this$messages_queued3, _this$messages_queued4) => {
    while (!quit) {
      $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_start_reconnection_if_offline_process).call(this);
      await $f5a4b8e233f0e1cd$var$_classPrivateMethodGet(this, $f5a4b8e233f0e1cd$var$_wait_for_open_and_send, $f5a4b8e233f0e1cd$var$_wait_for_open_and_send2).call(this, msg);
      const waited = await new Promise(r => {
        const handler = () => {
          r(false);
          clearTimeout(resend_due_to_lost_message_timeout);
        };
        // wait the correct delay
        const resend_due_to_lost_message_timeout = setTimeout(
        // this might actually never be needed and be from when Daniel didn't understand WebSockets as well
        $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
          r(true);
          this.removeEventListener("open", handler);
        }), delay_to_next_send);
        // BUT if we new websocket opens (which means the internet connection works) try again immediately (shortcut the delay)
        this.addEventListener("open", handler, {
          once: true
        });
      });
      if (quit) break;
      delay_to_next_send *= 1.5 + Math.random();
      if (delay_to_next_send > $f5a4b8e233f0e1cd$var$ONE_MINUTE) delay_to_next_send = $f5a4b8e233f0e1cd$var$ONE_MINUTE * (Math.random() + 1);
      if (waited)
        // don't count the fail as fail if we're trying again due to a reconnect since that could make us kill the connection if many messages suddenly retry which we don't want
        // this is not a proven theory and might be wrong
        this.increase_fails();
    }
    $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $f5a4b8e233f0e1cd$var$_messages_queued, (_this$messages_queued3 = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $f5a4b8e233f0e1cd$var$_messages_queued), _this$messages_queued4 = _this$messages_queued3--, _this$messages_queued3)), _this$messages_queued4;
  })().catch(e => $5e1f45affc1d7def$export$f18d5b0af29128b7(e, "error"));
  return () => quit = true;
}

/**
 * Returns a random string
 * @return A random string, containing a-z, 0-9 and occasionally a dot (`.`)
 */
function $6cb4d83127e468ea$export$656831b7e9c341c3() {
  return (Math.random() * 2e17).toString(36);
}
function $6cb4d83127e468ea$export$a6db784f019668ba() {
  return "x" + $6cb4d83127e468ea$export$656831b7e9c341c3().replaceAll(".", "");
}
const $9e4bee2e3b4b5753$export$362abebb4b313340 = process.env.DEPICT_BASE_URL || "https://api.depict.ai";
const $814c3bf8e175fa59$var$c = (0, $5e1f45affc1d7def$export$b3bbfd758f11cfa9);
const $814c3bf8e175fa59$var$ws_instance = /*@__PURE__*/$814c3bf8e175fa59$var$c(() => new (0, $f5a4b8e233f0e1cd$export$1d9c6fddbff3441f)("wss://ws.depict.ai/ws/create-events"))();
const $814c3bf8e175fa59$var$allowed_keys = ["tenant", "market", "type", "session_id", "product_id", "entity_identifiers", "url", "entity_price", "currency", "document_referrer", "document_width", "attribution_id", "recommendation_id", "click_location", "ab_test_group", "variant_ids", "transaction_id", "error_type", "detail", "recommendation_type", "search_result_id", "product_listing_result_id"];
const $814c3bf8e175fa59$export$72036d950e1fae95 = /*@__PURE__*/$814c3bf8e175fa59$var$c(payload => {
  if (process.env.DEPICT === "false") return;
  return payload.map(body => Object.fromEntries(Object.entries(body).filter(_ref => {
    let [key, value] = _ref;
    return $814c3bf8e175fa59$var$allowed_keys.includes(key) && value != null;
  })));
});
const $814c3bf8e175fa59$export$aa26019042811d4f = /*@__PURE__*/$814c3bf8e175fa59$var$c(async bodies => {
  if (process.env.DEPICT === "false") return;
  for (let i = 0; i < bodies.length; i++) {
    const id = $6cb4d83127e468ea$export$656831b7e9c341c3();
    $814c3bf8e175fa59$var$ws_instance === null || $814c3bf8e175fa59$var$ws_instance === void 0 || $814c3bf8e175fa59$var$ws_instance.ensure_sent({
      id: id,
      event: bodies[i]
    }).catch(e => $5e1f45affc1d7def$export$f18d5b0af29128b7(e, "error"));
  }
});
const $814c3bf8e175fa59$export$608478473a3304a0 = /*@__PURE__*/$814c3bf8e175fa59$var$c(function (payload) {
  let use_ws = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (process.env.DEPICT === "false") return;
  if (use_ws && typeof WebSocket == "function" && typeof ($814c3bf8e175fa59$var$ws_instance === null || $814c3bf8e175fa59$var$ws_instance === void 0 ? void 0 : $814c3bf8e175fa59$var$ws_instance.ensure_sent) == "function") {
    $241f2f02cc612a49$export$de56f1198d121036("Sending to depict (ws)", payload);
    return $814c3bf8e175fa59$export$aa26019042811d4f(payload);
  }
  const url = (0, $9e4bee2e3b4b5753$export$362abebb4b313340) + "/create-events";
  return $814c3bf8e175fa59$export$cc3b6ddf805f6156(url, payload);
});
const $814c3bf8e175fa59$export$cc3b6ddf805f6156 = /*@__PURE__*/$814c3bf8e175fa59$var$c((url, payload) => {
  const payload_json = JSON.stringify(payload);
  let success = false;
  $241f2f02cc612a49$export$de56f1198d121036("Attempting to send (beacon)", payload);
  try {
    success = navigator.sendBeacon(url, new Blob([payload_json], {
      type: "application/json"
    }));
  } catch (first_error) {
    $241f2f02cc612a49$export$de56f1198d121036("Beacon has failed", first_error, "falling back to sending with wrong mime type which might work");
    try {
      success = navigator.sendBeacon(url, new Blob([payload_json], {
        type: "application/x-www-form-urlencoded"
      }));
    } catch (e) {
      $241f2f02cc612a49$export$de56f1198d121036("Beacon fallback has failed", e, "trying fetch");
      fetch(url, {
        "headers": {
          "content-type": "application/json"
        },
        "body": payload_json,
        "method": "POST",
        "mode": "cors",
        "credentials": "include"
      }).then(response => response.text()).then(text => $241f2f02cc612a49$export$de56f1198d121036("Beacon fallback fallback transmission result", text)).catch(fetch_error => {
        (0, $17bb552dedcd526c$export$af2e17a20c2ea3c5).withScope(function (scope) {
          scope.setExtra("stack", new Error().stack);
          scope.setExtra("url", url);
          scope.setExtra("payload", payload_json);
          scope.setExtra("first_error", first_error);
          scope.setExtra("second_error", e);
          scope.setTag("feature", "beacon");
          scope.setTag("approach", "fetch_fallback");
          scope.setLevel("error");
          this.captureMessage(fetch_error); // we can now do this - it's depict lazy sentry specific. `this` will refer to the actual hub with breadcrumbs and the scope activated
        });
      });
    }
  }

  return success;
});
const $814c3bf8e175fa59$export$28cacbd9b4306ffc = /*@__PURE__*/$814c3bf8e175fa59$var$c((payload, use_ws) => {
  if (process.env.DEPICT === "false") return;
  // filter_depict_payload will only return undefined if process.env.DEPICT === "false"
  return $814c3bf8e175fa59$export$608478473a3304a0($814c3bf8e175fa59$export$72036d950e1fae95(payload), use_ws);
});
let $d5f7352b58e0d737$export$61e7e1f11e96692f = () => {
  if (typeof document === "undefined") return "server";
  let id = "";
  let localstorage_error;
  let cookie_error;
  try {
    var _localStorage;
    // localStorage._dep_id also accessed directly by depict-purchase-tracking Shopify web pixel
    id = (_localStorage = localStorage)._dep_id || (_localStorage._dep_id = $6cb4d83127e468ea$export$656831b7e9c341c3());
  } catch (e) {
    $241f2f02cc612a49$export$de56f1198d121036("Can't use localStorage", e);
    localstorage_error = e;
  }
  if (!id) {
    try {
      const get_cookie_id = () => document.cookie.split(";").reduce((res, c) => {
        const [key, val] = c.trim().split("=").map(decodeURIComponent);
        return Object.assign(res, {
          [key]: val
        });
      }, {})._dep_id;
      id = get_cookie_id();
      if (!id) {
        document.cookie = "_dep_id=".concat($6cb4d83127e468ea$export$656831b7e9c341c3(), "; expires=Fri, 31 Dec 9999 23:59:59 GMT");
        id = get_cookie_id();
      }
    } catch (e) {
      $5e1f45affc1d7def$export$f18d5b0af29128b7(e, "warning");
      cookie_error = e;
    }
    (0, $17bb552dedcd526c$export$af2e17a20c2ea3c5).withScope(function (scope) {
      scope.setExtra("id", id);
      scope.setExtra("ls_error", localstorage_error);
      scope.setExtra("cookie_error", cookie_error);
      scope.setLevel("error");
      this.captureMessage("".concat(id ? "localStorage" : "cookie and localStorage", " failed to hold a value!"));
    });
  }
  if (!id) id = $6cb4d83127e468ea$export$656831b7e9c341c3();
  return id;
};
const $d5f7352b58e0d737$export$93ae15b1ae509334 = /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9(newfn => $d5f7352b58e0d737$export$61e7e1f11e96692f = newfn);
const $d5f7352b58e0d737$export$8c6f26a5b6921b95 = /*@__PURE__*/() => {
  var _document;
  return {
    session_id: $d5f7352b58e0d737$export$61e7e1f11e96692f(),
    url: document.location.href,
    document_width: window.innerWidth,
    document_referrer: (_document = document) === null || _document === void 0 ? void 0 : _document.referrer
  };
};
const $d5f7352b58e0d737$export$82badda1f9923310 = /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9((vars, use_ws) => {
  if (process.env.DEPICT === "false") return;
  const payload = [{
    ...$d5f7352b58e0d737$export$8c6f26a5b6921b95(),
    // Compatability mapping - TODO: refactor & remove
    tenant: vars === null || vars === void 0 ? void 0 : vars.TENANT,
    market: vars === null || vars === void 0 ? void 0 : vars.MARKET,
    entity_price: vars === null || vars === void 0 ? void 0 : vars.sale_price,
    ...vars
  }];
  return $814c3bf8e175fa59$export$28cacbd9b4306ffc(payload, use_ws);
});
const $d5f7352b58e0d737$export$15f8a0cd5a8c0ebb = /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9(vars => {
  if (process.env.DEPICT === "false") return;
  const beacon_retval = $d5f7352b58e0d737$export$82badda1f9923310({
    ...vars,
    type: "click"
  }, false // don't send clicks over websockets because the page might unload
  );

  $d5f7352b58e0d737$export$82badda1f9923310({
    ...vars,
    type: "ws_click"
  }, true // explicitly send `ws-click` over websockets, this is an experiment to test the hypothesis of above - does unloading the page affect if this gets sent?
  );

  return beacon_retval;
});
const $d5f7352b58e0d737$export$9028351cb994757e = /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9(vars => {
  if (process.env.DEPICT === "false") return;
  return $d5f7352b58e0d737$export$82badda1f9923310({
    ...vars,
    type: "add_to_cart"
  });
});
function $d5f7352b58e0d737$export$622991c71a1f52b3(cookie_name) {
  var _document$cookie$matc;
  // https://stackoverflow.com/a/25490531
  return ((_document$cookie$matc = document.cookie.match("(^|;)\\s*" + cookie_name + "\\s*=\\s*([^;]+)")) === null || _document$cookie$matc === void 0 ? void 0 : _document$cookie$matc.pop()) || "";
}
function $3a96de5a459d34f9$export$c50e1901e8ed0615(callback) {
  // https://stackoverflow.com/a/61574326
  const channel = new MessageChannel();
  channel.port1.onmessage = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(callback);
  channel.port2.postMessage("");
}
function $5f4e0abe3139380e$export$6f051469dd676a8b(tenant, market, type) {
  let queued_sending = false;
  const current_displays = new Set();
  return function (display, info) {
    if (!display) return;
    info.set_on_index_change(() => {
      current_displays.add(display);
      $76EG6$onCleanup(() => current_displays.delete(display));
      if (!queued_sending) {
        queued_sending = true;
        $3a96de5a459d34f9$export$c50e1901e8ed0615(() => {
          $d5f7352b58e0d737$export$82badda1f9923310({
            tenant: tenant,
            market: market,
            recommendation_type: type,
            type: "recommendations_inserted"
          });
          queued_sending = false;
        });
      }
    });
  };
}

/**
 * @deprecated this was a stupid idea, it's much easier to read if one just does a quick arrow function that provides the wanted arguments
 */
function $cdf4691608b4019f$export$6e7454c733fa1fb2(fn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
  return function () {
    for (var _len2 = arguments.length, unimportant_args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) unimportant_args[_key2] = arguments[_key2];
    return fn.apply(this, [...args, ...unimportant_args]);
  };
}
const $bcc7b73f8b96a6f0$export$8582cf3716962dc2 = /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9(async _ref => {
  let {
    recs: recs,
    min_recs: min_recs,
    market: market,
    type: type,
    product_id: product_id,
    tenant: tenant
  } = _ref;
  if (type == "placeholder") return;
  if (typeof product_id === "function") product_id = product_id();
  product_id = await product_id;
  recs = await recs;
  if (typeof recs === "object") {
    if (!Array.isArray(recs)) {
      var _recs;
      recs = (_recs = recs) === null || _recs === void 0 ? void 0 : _recs.displays;
    }
    if (Array.isArray(recs)) {
      if (min_recs == undefined) min_recs = 10;
      if (recs.length < min_recs) {
        $241f2f02cc612a49$export$c2363754d4758444("Displays provided to check_displays is too short, it contains", recs.length, "displays which is less than", min_recs);
        return false;
      } else return true;
    } else $241f2f02cc612a49$export$c2363754d4758444(new Error("neither recs nor recs.displays are an array"));
  } else $241f2f02cc612a49$export$c2363754d4758444(new Error("Non object was passed to check_displays"));
});
const $a01cf8e3169d2af1$var$elem_track_id_map = /*@__PURE__*/new WeakMap();
function $a01cf8e3169d2af1$export$16d7c76794a38a4(element, event, track_id, func) {
  var _set_for_el$has;
  const set_for_el = $a01cf8e3169d2af1$var$elem_track_id_map.get(element);
  if (!(set_for_el !== null && set_for_el !== void 0 && (_set_for_el$has = set_for_el.has) !== null && _set_for_el$has !== void 0 && _set_for_el$has.call(set_for_el, track_id))) {
    if (!(set_for_el instanceof Set)) $a01cf8e3169d2af1$var$elem_track_id_map.set(element, new Set([track_id]));else set_for_el.add(track_id);
    element.addEventListener(event, func, true);
  }
}

/**
 * @deprecated use async_iterable_ipns instead. This can skip values which yields unexpected results.
 */
function $6a44fa3f1acf7693$export$55621c1ce3cd536b() {
  // the idea is to have a new promise available immediately before one resolves, so to say an infinite promise
  let internal_resolve; // copy and pasted from iconbeauty
  const cart_promise_object = {
    // I feel like Anton is not going to like this extremely awesome approach
    promise: new Promise(r => internal_resolve = r),
    // which is why I'm reluctant with making it a library
    internal_resolve: internal_resolve,
    // Edit from later on: I have realised that this is actually very useful, it just has a steep learning curve.
    resolve: argument => {
      // it allows both not having to call functions in a loop and instead just awaiting the promise from multiple places
      const oldresolve = cart_promise_object.internal_resolve; // and to effortlessly ensure a process is never running twice with 100% reliability
      cart_promise_object.promise = new Promise(r => cart_promise_object.internal_resolve = r); // it could be made a class, but I already know this works, so I'll leave it as is
      oldresolve(argument);
    }
  };
  return cart_promise_object;
}
function $e64690bc3a7de2b1$export$c7187bbd1a7a9244() {
  $e64690bc3a7de2b1$var$placeholder_worker(...arguments).catch((0, $b000f5ef6ce456d9$export$8048b892d651b310));
  return arguments.length <= 0 ? undefined : arguments[0];
}
async function $e64690bc3a7de2b1$var$placeholder_worker(placeholder_elements, final_elements, switching_trigger) {
  let state = false;
  let has_sanitized_elements = false;
  const sanit_el_if_needed = async () => {
    if (!has_sanitized_elements) {
      has_sanitized_elements = true;
      placeholder_elements = await $e64690bc3a7de2b1$var$convert_to_node_array(placeholder_elements);
      final_elements = await $e64690bc3a7de2b1$var$convert_to_node_array(final_elements);
    }
  };
  if (switching_trigger instanceof (0, $4c6e595091defcd9$export$32ccf3a614c84258)) while (true) {
    const new_state = await switching_trigger.promise;
    if (new_state != state) {
      await sanit_el_if_needed();
      await $e64690bc3a7de2b1$var$decide_direction_and_switch(placeholder_elements, final_elements, new_state);
      state = new_state;
    }
  } else if (switching_trigger instanceof Promise) {
    const new_state = await switching_trigger;
    if (state != new_state) {
      await sanit_el_if_needed();
      await $e64690bc3a7de2b1$var$decide_direction_and_switch(placeholder_elements, final_elements, new_state);
      state = new_state;
    }
  } else {
    await sanit_el_if_needed();
    placeholder_elements[0].addEventListener("placeholder_switch", $9c44a7238815fa47$export$535946eb77c946dd(async e => {
      const new_state = e.detail.state;
      if (state != new_state) {
        await sanit_el_if_needed();
        await $e64690bc3a7de2b1$var$decide_direction_and_switch(placeholder_elements, final_elements, new_state);
        state = new_state;
      }
    }));
  }
}
async function $e64690bc3a7de2b1$var$convert_to_node_array(elements) {
  if (typeof elements == "function") elements = elements();
  elements = await elements;
  if (typeof elements[Symbol.iterator] != "function") elements = [elements];
  return elements;
}
async function $e64690bc3a7de2b1$var$decide_direction_and_switch(placeholder_elements, final_elements, switch_to_final) {
  if (switch_to_final) $e64690bc3a7de2b1$var$switch_elements(placeholder_elements, final_elements);else $e64690bc3a7de2b1$var$switch_elements(final_elements, placeholder_elements);
}
function $e64690bc3a7de2b1$var$switch_elements(from, to) {
  if (!from.length || !to.length) $241f2f02cc612a49$export$c2363754d4758444("Cannot switch elements as from or to is empty", from, to);
  from[0].replaceWith(...to);
  for (let i = 1; i < from.length; i++) from[i].remove();
}

// @ts-ignore
var $d58f55a8abd5e8fe$exports = {};
$d58f55a8abd5e8fe$exports = ".depict .rec_outer.noautospacing {\n  width: 6cm;\n  max-width: 46vw;\n  margin-left: 1%;\n  margin-right: 1%;\n}\n\n.depict .rec_outer.noautospacing:nth-child(1) {\n  margin-left: 0;\n}\n\n.depict .rec_outer.noautospacing:nth-last-child(1) {\n  margin-right: 0;\n}\n\n.depict-slider .slider_snap {\n  scroll-snap-type: x mandatory;\n}\n\n.depict-slider {\n  width: 100%;\n  position: relative;\n}\n\n.depict-slider .sliding::-webkit-scrollbar {\n  display: none;\n}\n\n.depict-slider .sliding {\n  scroll-behavior: smooth;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  flex-flow: row;\n  margin-top: -1%;\n  margin-bottom: -2%;\n  padding-top: 1%;\n  padding-bottom: 2%;\n  display: flex;\n  overflow-x: scroll;\n}\n\n.depict-slider .sliding > * {\n  box-sizing: border-box;\n  flex: none;\n}\n\n.depict-slider button.right {\n  right: 0;\n}\n\n.depict-slider button.left, .depict-slider button.right {\n  z-index: 2;\n  touch-action: manipulation;\n  width: 1cm;\n  height: 1cm;\n  cursor: pointer;\n  background: #fff;\n  border: none;\n  padding: .5%;\n  transition-duration: .2s;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.depict-slider button.left.hidden, .depict-slider button.right.hidden {\n  opacity: 0;\n  cursor: default;\n}\n\n.depict-slider button.left {\n  left: 0;\n  transform: translateY(-50%)rotate(180deg);\n}\n\n.depict-slider button.left img, .depict-slider button.right img {\n  width: 100%;\n  height: 100%;\n}\n\n.depict-slider .rec_outer {\n  margin-top: 0 !important;\n}\n\n";
let $2c3b8e0102339cd6$var$has_queued_microtask = false;
const $2c3b8e0102339cd6$var$queued_callbacks = /*@__PURE__*/new Map();
const $2c3b8e0102339cd6$var$catchified_deduplicate_and_dispatch = /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9($2c3b8e0102339cd6$var$deduplicate_and_dispatch, "error in observer event processing", "error");
function $2c3b8e0102339cd6$export$2b08e30396270f0b(callback, ev) {
  $2c3b8e0102339cd6$var$queued_callbacks.set(ev, callback);
  if (!$2c3b8e0102339cd6$var$has_queued_microtask) queueMicrotask($2c3b8e0102339cd6$var$catchified_deduplicate_and_dispatch);
}
function $2c3b8e0102339cd6$var$deduplicate_and_dispatch() {
  $2c3b8e0102339cd6$var$has_queued_microtask = false;
  const deduplication_map = new Map();
  // event_name -> [selector -> [element -> [function, eoe]]]
  for (const [eoe, callback] of $2c3b8e0102339cd6$var$queued_callbacks) {
    // put events into structure of maps and sets where they can only exist once
    $2c3b8e0102339cd6$var$queued_callbacks.delete(eoe);
    const {
      event: event_name,
      selector: selector,
      element: element
    } = eoe;
    if (!event_name) {
      // it's an ifexists callback, doesnt' need deduplication
      $2c3b8e0102339cd6$var$call_callback(callback, eoe);
      continue;
    }
    let l2_map = deduplication_map.get(event_name);
    if (!l2_map) {
      l2_map = new Map();
      deduplication_map.set(event_name, l2_map);
    }
    let l3_map = l2_map.get(selector);
    if (!l3_map) {
      l3_map = new Map();
      l2_map.set(selector, l3_map);
    }
    let l4_map = l3_map.get(element);
    if (!l4_map) {
      l4_map = new Map();
      l3_map.set(element, l4_map);
    }
    l4_map.set(callback, eoe);
  }
  // go through structure and call callbacks that are left
  for (const [_event_name, l2_map] of deduplication_map) for (const [_selector, l3_map] of l2_map) {
    for (const [_element, callback_set] of l3_map) for (const [callback, eoe] of callback_set) $2c3b8e0102339cd6$var$call_callback(callback, eoe);
  }
}
function $2c3b8e0102339cd6$var$call_callback(callback, ev) {
  $5e1f45affc1d7def$export$b3bbfd758f11cfa9(callback, "Error in observer callback")(ev);
}
class $4f10cdcba0efac85$export$ea60432919e69303 {
  constructor(opts) {
    this.element = opts.element_;
    this.selector = opts.selector_;
    this.disconnector = opts.disconnector_;
    opts.mutation_record_ && (this.mutation_record = opts.mutation_record_);
    opts.event_ && (this.event = opts.event_);
  }
}
const $914c6f35222c820d$var$needs_patching = typeof window === "object" ? /*@__PURE__*/$914c6f35222c820d$var$check_if_querySelectorAll_needs_patching() : false;
function $914c6f35222c820d$export$33f937d741e49339(element, selector) {
  if (!(element instanceof Element) || !$914c6f35222c820d$var$needs_patching || !selector.includes("#") || !selector.includes("+")) {
    var _element$querySelecto;
    // covers most cases, we don't need patching or don't hit the bug
    return element === null || element === void 0 ? void 0 : (_element$querySelecto = element.querySelectorAll) === null || _element$querySelecto === void 0 ? void 0 : _element$querySelecto.call(element, selector);
  }
  const result = [];
  const elements_to_check = [];
  // intentionally not recursive since it's possible to have deeper nested elements than max stack size
  for (let i = element.children.length; i--;) elements_to_check.push(element.children[i]);
  while (elements_to_check.length) {
    const child_element = elements_to_check.pop();
    if (child_element.matches(selector)) result.push(child_element);
    for (let i = child_element.children.length; i--;)
    // kudos to Karl for algorithm help
    elements_to_check.push(child_element.children[i]);
  }
  return result;
}
function $914c6f35222c820d$var$check_if_querySelectorAll_needs_patching() {
  const id_div = document.createElement("div");
  const element = document.createElement("section");
  const selector = "#a+*";
  id_div.id = "a";
  document.documentElement.append(id_div, element);
  try {
    return element === element.querySelectorAll(selector)[0];
  } finally {
    id_div.remove();
    element.remove();
  }
}
function $7d82513db34b5d27$var$_classPrivateMethodInitSpec(obj, privateSet) {
  $7d82513db34b5d27$var$_checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}
function $7d82513db34b5d27$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $7d82513db34b5d27$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $7d82513db34b5d27$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $7d82513db34b5d27$var$_classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
  return fn;
}
var $7d82513db34b5d27$var$_the_mutation_observer = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_observing = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_self_proxied = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_observer_callback_running = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_execute_after_callback_ran = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_attribute_attribution_map_object = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_territories = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_listeners = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_weakref_finalization_registry = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_verbs = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_kickstart_observer = /*#__PURE__*/new WeakSet();
var $7d82513db34b5d27$var$_disconnect_fn = /*#__PURE__*/new WeakSet();
var $7d82513db34b5d27$var$_observer_callback = /*#__PURE__*/new WeakMap();
var $7d82513db34b5d27$var$_check_observer_args = /*#__PURE__*/new WeakSet();
var $7d82513db34b5d27$var$_add_listener = /*#__PURE__*/new WeakSet();
var $7d82513db34b5d27$var$_cleanup_weakref_when_refd_el_gcd = /*#__PURE__*/new WeakSet();
var $7d82513db34b5d27$var$_finalization_registry_callback = /*#__PURE__*/new WeakSet();
var $7d82513db34b5d27$var$_call_callbacks = /*#__PURE__*/new WeakSet();
var $7d82513db34b5d27$var$_get = /*#__PURE__*/new WeakSet();
class $7d82513db34b5d27$export$12e07a2a9f87578a {
  constructor() {
    let {
      territory: territory
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $7d82513db34b5d27$var$_classPrivateMethodInitSpec(this, $7d82513db34b5d27$var$_get);
    $7d82513db34b5d27$var$_classPrivateMethodInitSpec(this, $7d82513db34b5d27$var$_call_callbacks);
    $7d82513db34b5d27$var$_classPrivateMethodInitSpec(this, $7d82513db34b5d27$var$_finalization_registry_callback);
    $7d82513db34b5d27$var$_classPrivateMethodInitSpec(this, $7d82513db34b5d27$var$_cleanup_weakref_when_refd_el_gcd);
    $7d82513db34b5d27$var$_classPrivateMethodInitSpec(this, $7d82513db34b5d27$var$_add_listener);
    $7d82513db34b5d27$var$_classPrivateMethodInitSpec(this, $7d82513db34b5d27$var$_check_observer_args);
    $7d82513db34b5d27$var$_classPrivateMethodInitSpec(this, $7d82513db34b5d27$var$_disconnect_fn);
    $7d82513db34b5d27$var$_classPrivateMethodInitSpec(this, $7d82513db34b5d27$var$_kickstart_observer);
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_the_mutation_observer, {
      writable: true,
      value: void 0
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_observing, {
      writable: true,
      value: {}
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_self_proxied, {
      writable: true,
      value: void 0
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_observer_callback_running, {
      writable: true,
      value: false
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_execute_after_callback_ran, {
      writable: true,
      value: []
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_attribute_attribution_map_object, {
      writable: true,
      value: {}
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_territories, {
      writable: true,
      value: typeof document === "object" ? [document.documentElement] : []
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_listeners, {
      writable: true,
      value: ["exists", "creation", "removed", "change"]
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_weakref_finalization_registry, {
      writable: true,
      value: typeof FinalizationRegistry === "function" && new FinalizationRegistry($5e1f45affc1d7def$export$b3bbfd758f11cfa9($7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_finalization_registry_callback, $7d82513db34b5d27$var$_finalization_registry_callback2).bind(this)))
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_verbs, {
      writable: true,
      value: {
        // add "normal" functions for the class that can be used as i.e. observer.ifexists() here
        ifexists: (selector, callback) => {
          var _classPrivateFieldGet2, _ref;
          const territories = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_territories);
          $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_check_observer_args, $7d82513db34b5d27$var$_check_observer_args2).call(this, selector, callback, true);
          if (typeof document === "undefined") return; // SSR
          const our_set = (_classPrivateFieldGet2 = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_attribute_attribution_map_object))[_ref = selector] || (_classPrivateFieldGet2[_ref] = new WeakSet());
          if (selector instanceof Node) {
            let node_is_contained = false;
            for (let i = 0; i < territories.length; i++) {
              if (!territories[i].contains(selector)) continue;
              node_is_contained = true;
              break;
            }
            if (node_is_contained) {
              our_set.add(selector); // Add element to set, so we don't dispatch two onexists events for it if it matches the selector and an attribute changes in the same go
              // When the selector is a node the selector and the element are the same, dunno how we could reflect that in the typing though
              $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_call_callbacks, $7d82513db34b5d27$var$_call_callbacks2).call(this, [callback], callback_ => ({
                element_: selector,
                selector_: selector,
                // ts is being stupid here because it doesn't understand that everything in string | Text | Element | Comment that's a node is Text | Element | Comment
                disconnector_: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(this, {
                  event_: "exists",
                  selector_: new WeakRef(selector),
                  callback_: callback_
                })
              }));
            }
            return;
          }
          for (let i = 0; i < territories.length; i++) {
            const found = $914c6f35222c820d$export$33f937d741e49339(territories[i], selector);
            if (!found) continue;
            for (let j = 0; j < found.length; j++) {
              const element = found[j];
              our_set.add(element);
              $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_call_callbacks, $7d82513db34b5d27$var$_call_callbacks2).call(this, [callback], callback_ => ({
                element_: element,
                selector_: selector,
                disconnector_: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(this, {
                  event_: "exists",
                  selector_: selector,
                  callback_: callback_
                })
              }));
            }
          }
        },
        wait_for_element: (selector, timeout) => {
          return $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_self_proxied).wait_for_listener("exists", selector, timeout);
        },
        wait_for_listener: (listener, selector, timeout) => {
          $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_check_observer_args, $7d82513db34b5d27$var$_check_observer_args2).call(this, listener, () => {}, false);
          // console.log("waiting for listener", listener, "selector", selector, "timeout", timeout);
          return new Promise($5e1f45affc1d7def$export$b3bbfd758f11cfa9(r => {
            const stop_observing = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_self_proxied)["on" + listener](selector, _ref2 => {
              let {
                element: element,
                disconnector: disconnector
              } = _ref2;
              r(element);
              disconnector();
              if (timeout) clearTimeout(obs_timeout);
            });
            if (timeout) var obs_timeout = setTimeout(() => {
              stop_observing();
              r(undefined);
            }, timeout);
          }));
        },
        add_territory: what => {
          var _classPrivateFieldGet3;
          $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_territories).push(what);
          // If mutation observer was already started, add element to what it observes
          (_classPrivateFieldGet3 = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_the_mutation_observer)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.observe(what, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeOldValue: true,
            characterData: true,
            characterDataOldValue: true
          });
        },
        remove_territory: what => {
          var _classPrivateFieldGet4;
          const new_value = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_territories).filter(item => item !== what);
          $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $7d82513db34b5d27$var$_territories, []);
          // There's no .unobserve so disconnect the whole observer and then re-add everything except the removed territory
          (_classPrivateFieldGet4 = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_the_mutation_observer)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.disconnect();
          for (let i = 0; i < new_value.length; i++) $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_verbs).add_territory(new_value[i]);
        }
      }
    });
    $7d82513db34b5d27$var$_classPrivateFieldInitSpec(this, $7d82513db34b5d27$var$_observer_callback, {
      writable: true,
      value: records => {
        // this is the function which needs to be as fast as possible because it is called on EVERY mutation in the DOM
        try {
          $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $7d82513db34b5d27$var$_observer_callback_running, true);
          const steps_to_restore_observing_cache = [];
          try {
            const observing = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_observing); // Currently observing elements. Please make sure they don't get mutated by anything except this function during the running of this function (use observer_callback_running and #execute_after_callback_ran to check for and schedule your mutations for after the run of this function). We previously cloned these on every run but that's super slow.
            const attribute_attribution_map_object = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_attribute_attribution_map_object);
            for (let j = 0; j < records.length; j++) {
              const record = records[j];
              const {
                addedNodes: addedNodes,
                removedNodes: removedNodes,
                target: target
              } = record;
              const events_for_discovery = [];
              let nodes_to_check;
              // code for handling a record containing wanted elements in addedNodes or the children of added nodes and attribute changes that make an existing node match a selector, mainly for oncreation and onexists, but it will fire onchange if someone is listening if an attribute change makes an element match a selector
              if (!addedNodes.length && !removedNodes.length) nodes_to_check = [target];else {
                nodes_to_check = addedNodes;
                if (observing["creation"]) events_for_discovery.push("creation");
              }
              if (observing["exists"]) events_for_discovery.push("exists");
              if (observing["change"]) events_for_discovery.push("change");
              for (let n = 0; n < events_for_discovery.length; n++) {
                const event = events_for_discovery[n];
                const event_is_creation_or_exists_with_tree_change = event === "creation" || event === "exists" && addedNodes.length;
                const selector_map = observing[event];
                const selectors = [...selector_map.keys()]; // we can only iterate over a MapIterator once, so we need to spread it
                if (event === "change" && (addedNodes.length || removedNodes.length)) {
                  // we check the selectors first because I'm DUMB and already have come so far
                  for (let selectors_i = 0; selectors_i < selectors.length; selectors_i++) {
                    var _target$matches;
                    const selector = selectors[selectors_i];
                    // @ts-ignore
                    if (target !== null && target !== void 0 && (_target$matches = target.matches) !== null && _target$matches !== void 0 && _target$matches.call(target, selector)) {
                      // we WANT change event and there are children to an element that interests us - act on it
                      const callbacks = selector_map.get(selector);
                      $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_call_callbacks, $7d82513db34b5d27$var$_call_callbacks2).call(this, callbacks, callback => ({
                        element_: target,
                        // it has to be an *Element* since it has
                        // the selector is a string since the event is change
                        // @ts-ignore
                        selector_: selector,
                        event_: event,
                        mutation_record_: record,
                        disconnector_: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(this, {
                          event_: event,
                          selector_: selector,
                          callback_: callback
                        })
                      }));
                      selector_map.delete(selector);
                      steps_to_restore_observing_cache.push(() => selector_map.set(selector, callbacks));
                    }
                  }
                  break;
                }
                for (let i = 0; i < nodes_to_check.length; i++) {
                  const node = nodes_to_check[i];
                  for (let selectors_i = 0; selectors_i < selectors.length; selectors_i++) {
                    var _node$matches;
                    const selector = selectors[selectors_i];
                    const callbacks = selector_map.get(selector) || new Set();
                    if (typeof selector !== "string") {
                      // oncreation or onexists with node-selector
                      if (event_is_creation_or_exists_with_tree_change) {
                        const derefed_el = selector.deref();
                        if (!derefed_el) {
                          selector_map.delete(selector);
                          continue;
                        }
                        if (node === derefed_el || node.contains(derefed_el))
                          // node is node or node is child of added node
                          $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_call_callbacks, $7d82513db34b5d27$var$_call_callbacks2).call(this, callbacks, callback => ({
                            element_: derefed_el,
                            selector_: derefed_el,
                            event_: event,
                            mutation_record_: record,
                            disconnector_: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(this, {
                              event_: event,
                              selector_: selector,
                              callback_: callback
                            })
                          }));
                      }
                      continue;
                    }
                    // @ts-ignore
                    const matches_now = node === null || node === void 0 ? void 0 : (_node$matches = node.matches) === null || _node$matches === void 0 ? void 0 : _node$matches.call(node, selector);
                    let our_set;
                    if (event == "exists") {
                      // we want the change event to trigger to any change (exists only if it makes an element match a selector that didn't previously match)
                      our_set = attribute_attribution_map_object[selector] || (attribute_attribution_map_object[selector] = new WeakSet());
                      if (record.type === "attributes" && matches_now != null) {
                        const matched_last = our_set.has(node);
                        if (matched_last && matches_now) continue;
                      }
                      if (matches_now) our_set.add(node);else our_set.delete(node);
                    }
                    if (matches_now) $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_call_callbacks, $7d82513db34b5d27$var$_call_callbacks2).call(this, callbacks, callback => ({
                      element_: node,
                      selector_: selector,
                      event_: event,
                      mutation_record_: record,
                      disconnector_: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(this, {
                        event_: event,
                        selector_: selector,
                        callback_: callback
                      })
                    }));
                    if ((addedNodes.length || removedNodes.length) && node.hasChildNodes() &&
                    // @ts-ignore
                    node.querySelectorAll /* don't act on i.e. textnodes. Doing the check this way is actually faster than both `in` and instanceof */) {
                      const matching_children = $914c6f35222c820d$export$33f937d741e49339(node, selector);
                      for (let m = 0; m < matching_children.length; m++) {
                        // always use for loops because this can't be slow and forEach takes ages
                        if (event == "exists") our_set.add(matching_children[m]);
                        $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_call_callbacks, $7d82513db34b5d27$var$_call_callbacks2).call(this, callbacks, callback => ({
                          element_: matching_children[m],
                          selector_: selector,
                          event_: event,
                          mutation_record_: record,
                          disconnector_: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(this, {
                            event_: event,
                            selector_: selector,
                            callback_: callback
                          })
                        }));
                      }
                    }
                  }
                }
              }
              // code for handling changes to children of an observed element
              {
                const event = "change";
                const selector_map = observing[event];
                if (selector_map) {
                  let target_el = target;
                  while (target_el = (_target_el = target_el) === null || _target_el === void 0 ? void 0 : _target_el.parentNode) {
                    var _target_el, _target_el2;
                    // @ts-ignore
                    if ((_target_el2 = target_el) !== null && _target_el2 !== void 0 && _target_el2.matches) for (const selector of selector_map.keys()) {
                      var _matches, _ref3;
                      // selector is string because event is change
                      // @ts-ignore
                      if ((_matches = (_ref3 = target_el).matches) !== null && _matches !== void 0 && _matches.call(_ref3, selector)) {
                        const callbacks = selector_map.get(selector);
                        $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_call_callbacks, $7d82513db34b5d27$var$_call_callbacks2).call(this, callbacks, callback => ({
                          element_: target_el,
                          // @ts-ignore
                          selector_: selector,
                          event_: event,
                          mutation_record_: record,
                          disconnector_: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(this, {
                            event_: event,
                            selector_: selector,
                            callback_: callback
                          })
                        }));
                        // Since we now deduplicate
                        steps_to_restore_observing_cache.push(() => selector_map.set(selector, callbacks));
                      }
                    }
                  }
                }
              }
              // code for observing observed elements disappearing
              {
                const event = "removed";
                const removed_map = observing[event];
                if (removed_map && removedNodes !== null && removedNodes !== void 0 && removedNodes.length) {
                  const selectors = [...removed_map.keys()];
                  for (let t = 0; t < removedNodes.length; t++) for (let u = 0; u < selectors.length; u++) {
                    const selector = selectors[u];
                    const callbacks = removed_map.get(selector) || new Set();
                    const node = removedNodes[t];
                    if (typeof selector === "string") {
                      var _node$matches2;
                      const matching_nodes = [];
                      // @ts-ignore
                      if (node !== null && node !== void 0 && (_node$matches2 = node.matches) !== null && _node$matches2 !== void 0 && _node$matches2.call(node, selector)) matching_nodes.push(node);
                      matching_nodes.push(...($914c6f35222c820d$export$33f937d741e49339(node, selector) || []));
                      for (let v = 0; v < matching_nodes.length; v++) $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_call_callbacks, $7d82513db34b5d27$var$_call_callbacks2).call(this, callbacks, callback => ({
                        element_: matching_nodes[v],
                        selector_: selector,
                        event_: event,
                        mutation_record_: record,
                        disconnector_: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(this, {
                          event_: "removed",
                          selector_: selector,
                          callback_: callback
                        })
                      }));
                    } else {
                      const derefed_el = selector.deref();
                      if (derefed_el) {
                        if (node === derefed_el || node.contains(derefed_el)) $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_call_callbacks, $7d82513db34b5d27$var$_call_callbacks2).call(this, callbacks, callback => ({
                          element_: derefed_el,
                          mutation_record_: record,
                          selector_: derefed_el,
                          event_: event,
                          disconnector_: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(this, {
                            event_: event,
                            selector_: selector,
                            callback_: callback
                          })
                        }));
                      } else
                        // here it's also ok to mutate #observing since the WeakRef is empty
                        removed_map.delete(selector);
                    }
                  }
                }
              }
            }
            // const end = new Date().getTime();
            // console.log("procesed",records.length,"in", end-start, this.#observing);
          } finally {
            // ensure that we don't leave this.#observing in a broken state if we throw
            while (steps_to_restore_observing_cache.length) steps_to_restore_observing_cache.pop()();
            const execute_after_run = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_execute_after_callback_ran);
            // We need to execute these in order they were added because I'm afraid that things might rely on it
            for (let i = 0; i < execute_after_run.length; i++) try {
              execute_after_run[i]();
            } catch (e) {
              $5e1f45affc1d7def$export$f18d5b0af29128b7([e, "error in observer running queued function"], "error");
            }
            // Let the garbage collector empty the old array by creating a new one
            $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $7d82513db34b5d27$var$_execute_after_callback_ran, []);
            $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $7d82513db34b5d27$var$_observer_callback_running, false);
          }
        } catch (e) {
          $5e1f45affc1d7def$export$f18d5b0af29128b7([e, "error in observer"], "error");
        }
      }
    });
    if (process.env.BUILD_TARGET !== "modern" && Proxy.toString().indexOf("[native code]") === -1) {
      $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_listeners).forEach(listener => this["on" + listener] = () => {}); // define listeners, needed for IE11 proxy polyfill
      Object.keys($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_verbs)).forEach(listener => this[listener] = () => {});
    }
    if (territory) $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $7d82513db34b5d27$var$_territories, Array.isArray(territory) ? territory : [territory]);
    return $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $7d82513db34b5d27$var$_self_proxied, new Proxy(this, {
      get: $7d82513db34b5d27$var$_classPrivateMethodGet(this, $7d82513db34b5d27$var$_get, $7d82513db34b5d27$var$_get2)
    }));
  }
}
function $7d82513db34b5d27$var$_kickstart_observer2() {
  if (typeof document === "undefined") return;
  $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $7d82513db34b5d27$var$_the_mutation_observer, new MutationObserver($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_observer_callback)));
  const territories = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_territories);
  for (let i = 0; i < territories.length; i++) $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_the_mutation_observer).observe(territories[i], {
    attributes: true,
    childList: true,
    subtree: true,
    attributeOldValue: true,
    characterData: true,
    characterDataOldValue: true
  });
}
function $7d82513db34b5d27$var$_disconnect_fn2(_ref4) {
  let {
    event_: event_,
    selector_: selector_,
    callback_: callback_
  } = _ref4;
  return () => {
    const fn = () => {
      const observing = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_observing);
      const selector_to_callback_array_map = observing[event_];
      if (!selector_to_callback_array_map) return;
      const callbacks = selector_to_callback_array_map.get(selector_);
      callbacks === null || callbacks === void 0 || callbacks.delete(callback_);
      if ((callbacks === null || callbacks === void 0 ? void 0 : callbacks.size) === 0) selector_to_callback_array_map.delete(selector_);
      if (selector_to_callback_array_map.size === 0) delete observing[event_];
      if (!Object.keys(observing).length) {
        var _classPrivateFieldGet5;
        (_classPrivateFieldGet5 = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_the_mutation_observer)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.disconnect();
        $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $7d82513db34b5d27$var$_the_mutation_observer, undefined);
      }
    };
    // If the observer callback is running, we need to queue every function that mutates this.#observing since we can't clone it for performance reasons
    if ($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_observer_callback_running)) $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_execute_after_callback_ran).push(fn);else fn();
  };
}
function $7d82513db34b5d27$var$_check_observer_args2(selector, callback, allow_nodes) {
  if (!allow_nodes && typeof selector !== "string" || allow_nodes && !(selector instanceof Node) && typeof selector !== "string") throw new Error("no or invalid selector specified");
  if (typeof callback !== "function") throw new Error("no callback specified");
}
function $7d82513db34b5d27$var$_add_listener2(listener) {
  // called when observer.onsomethinglistener() is called, somethinglistener being something in this.#listeners
  const the_class = this;
  const function_for_listener = (selector, callback) => {
    if (typeof Node !== "function")
      // We are probably running on the server where we can't do anything anyway so we might just return
      return;
    if (!listener || !selector || !callback) {
      $241f2f02cc612a49$export$de56f1198d121036("listener, selector or callback is falsey", {
        listener: listener,
        selector: selector,
        callback: callback
      });
      return;
    }
    $7d82513db34b5d27$var$_classPrivateMethodGet(the_class, $7d82513db34b5d27$var$_check_observer_args, $7d82513db34b5d27$var$_check_observer_args2).call(the_class, selector, callback, listener != "change");
    if ($76EG6$babelruntimehelpersclassPrivateFieldGet(the_class, $7d82513db34b5d27$var$_observer_callback_running)) {
      // Can't mutate #observing right now, queue it for when we can
      $76EG6$babelruntimehelpersclassPrivateFieldGet(the_class, $7d82513db34b5d27$var$_execute_after_callback_ran).push(() => function_for_listener(selector, callback));
      return;
    }
    const observing = $76EG6$babelruntimehelpersclassPrivateFieldGet(the_class, $7d82513db34b5d27$var$_observing);
    observing[listener] || (observing[listener] = new Map());
    // create map for each listener, this is because the selectors can be objects for .onremoved, .oncreation and .onexists to take explicit nodes
    const selector_map = observing[listener];
    let disconnector;
    if (listener === "exists") $76EG6$babelruntimehelpersclassPrivateFieldGet(the_class, $7d82513db34b5d27$var$_verbs).ifexists(selector, callback);
    if (typeof selector === "string") {
      // simple code for string selectors
      let callback_set = selector_map.get(selector);
      if (!callback_set) {
        callback_set = new Set();
        selector_map.set(selector, callback_set);
      }
      callback_set.add(callback); // we make this a set since you're not supposed to be able to have the same function as listener twice, like you can't with addEventListener
      disconnector = $7d82513db34b5d27$var$_classPrivateMethodGet(the_class, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(the_class, {
        event_: listener,
        selector_: selector,
        callback_: callback
      });
    } else {
      // for an element "selector" we don't want to keep strong references to the nodes as that would prevent them from being garbage collected
      let callback_set_to_add_to;
      for (const [stored_selector, existing_callback_set] of selector_map) {
        // try finding an existing array of callbacks
        if (typeof stored_selector === "string") continue;
        const ref_contents = stored_selector.deref();
        if (!ref_contents) {
          // clean up listeners for selectors that have already been GC'd
          selector_map.delete(stored_selector);
          continue;
        }
        if (ref_contents === selector) {
          callback_set_to_add_to = existing_callback_set;
          disconnector = $7d82513db34b5d27$var$_classPrivateMethodGet(the_class, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(the_class, {
            event_: listener,
            selector_: stored_selector,
            callback_: callback
          });
          break;
        }
      }
      if (!callback_set_to_add_to) {
        callback_set_to_add_to = new Set();
        const weakref = new WeakRef(selector);
        $7d82513db34b5d27$var$_classPrivateMethodGet(the_class, $7d82513db34b5d27$var$_cleanup_weakref_when_refd_el_gcd, $7d82513db34b5d27$var$_cleanup_weakref_when_refd_el_gcd2).call(the_class, listener, weakref, selector);
        selector_map.set(weakref, callback_set_to_add_to);
        disconnector = $7d82513db34b5d27$var$_classPrivateMethodGet(the_class, $7d82513db34b5d27$var$_disconnect_fn, $7d82513db34b5d27$var$_disconnect_fn2).call(the_class, {
          event_: listener,
          selector_: weakref,
          callback_: callback
        });
      }
      callback_set_to_add_to.add(callback);
    }
    if (!$76EG6$babelruntimehelpersclassPrivateFieldGet(the_class, $7d82513db34b5d27$var$_the_mutation_observer)) $7d82513db34b5d27$var$_classPrivateMethodGet(the_class, $7d82513db34b5d27$var$_kickstart_observer, $7d82513db34b5d27$var$_kickstart_observer2).call(the_class);
    return disconnector;
  };
  return function_for_listener;
}
function $7d82513db34b5d27$var$_cleanup_weakref_when_refd_el_gcd2(listener, weakref, element) {
  // we don't want to keep references to elements used as "selectors" in oncreation and onremoved
  if (!$76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_weakref_finalization_registry)) return;
  $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_weakref_finalization_registry).register(element, [listener, weakref]);
}
function $7d82513db34b5d27$var$_finalization_registry_callback2(_ref5) {
  var _observing$listener, _observing$listener$g, _observing$listener2, _observing$listener3;
  let [listener, weak_ref] = _ref5;
  // element was GCd and the callbacks can never be called, remove them
  const observing = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_observing);
  (_observing$listener = observing[listener]) === null || _observing$listener === void 0 || (_observing$listener$g = _observing$listener.get(weak_ref)) === null || _observing$listener$g === void 0 || _observing$listener$g.clear(); // just in case something still has a reference to this set and does something with it, clear it
  (_observing$listener2 = observing[listener]) === null || _observing$listener2 === void 0 || _observing$listener2.delete(weak_ref);
  if (((_observing$listener3 = observing[listener]) === null || _observing$listener3 === void 0 ? void 0 : _observing$listener3.size) === 0) delete observing[listener];
  if (Object.keys(observing).length === 0) {
    var _classPrivateFieldGet6;
    (_classPrivateFieldGet6 = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $7d82513db34b5d27$var$_the_mutation_observer)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.disconnect();
    $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $7d82513db34b5d27$var$_the_mutation_observer, undefined);
  }
}
function $7d82513db34b5d27$var$_call_callbacks2(callbacks, make_ev_data) {
  for (const callback of callbacks) $2c3b8e0102339cd6$export$2b08e30396270f0b(callback, new (0, $4f10cdcba0efac85$export$ea60432919e69303)(make_ev_data(callback)));
}
function $7d82513db34b5d27$var$_get2(target, verb) {
  // @ts-ignore
  const is_listener = $76EG6$babelruntimehelpersclassPrivateFieldGet(target, $7d82513db34b5d27$var$_listeners).includes(verb.slice(2));
  const is_verb = Object.keys($76EG6$babelruntimehelpersclassPrivateFieldGet(target, $7d82513db34b5d27$var$_verbs)).includes(verb);
  if (is_verb) return $76EG6$babelruntimehelpersclassPrivateFieldGet(target, $7d82513db34b5d27$var$_verbs)[verb];else if (is_listener) return $7d82513db34b5d27$var$_classPrivateMethodGet(target, $7d82513db34b5d27$var$_add_listener, $7d82513db34b5d27$var$_add_listener2).call(target, verb.slice(2));else throw new Error("Property " + verb + " is not valid. Valid listeners: " + $76EG6$babelruntimehelpersclassPrivateFieldGet(target, $7d82513db34b5d27$var$_listeners).join(", ") + "; valid verbs: " + Object.keys($76EG6$babelruntimehelpersclassPrivateFieldGet(target, $7d82513db34b5d27$var$_verbs)).join(", "));
}
const $90fa633a9564f115$export$b6ae1bc530f4c149 = /*@__PURE__*/$90fa633a9564f115$var$make_default_observer();
function $90fa633a9564f115$var$make_default_observer() {
  try {
    return new (0, $7d82513db34b5d27$export$12e07a2a9f87578a)();
  } catch (error) {
    $5e1f45affc1d7def$export$f18d5b0af29128b7([error, "error starting ElementObserver"], "error");
  }
}

/**
 * Useful for the `thresholds` option of IntersectionObserver - if you want to be notified at a 10% change, call this and set num_steps to 10. Pls see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/thresholds
 * @param  numSteps               How many steps (notifications) there should be between 0 and 100% intersection
 * @return          Stuff to give to IntersectionObserver
 */
function $ab9c3dbf2bb2fbf7$export$f8ea2e7b15b5d129(numSteps) {
  const thresholds = [];
  for (let i = 1.0; i <= numSteps; i++) {
    const ratio = i / numSteps;
    thresholds.push(ratio);
  }
  thresholds.push(0);
  return thresholds;
}
function $652300c6621d5500$export$925772df9b4d16e5(url, param, value) {
  const url_object = new URL(url),
    search_params = new URLSearchParams(url_object.search);
  search_params.set(param, value);
  return url_object.origin + url_object.pathname + "?" + search_params.toString();
}
function $652300c6621d5500$export$785f04709990c4ec(element, selector) {
  let result = null;
  while (!result && element) {
    var _element, _element2, _element3;
    element = (_element = element) === null || _element === void 0 ? void 0 : _element.parentNode;
    result = ((_element2 = element) === null || _element2 === void 0 ? void 0 : _element2.querySelector(selector)) || ((_element3 = element) !== null && _element3 !== void 0 && _element3.matches ? element.matches(selector) ? element : null : null);
  }
  return result;
}
function $652300c6621d5500$export$44951404cb8d0583(html) {
  var _DOMParser$parseFromS, _DOMParser$parseFromS2;
  // need to wrap the HTML into a <body> tag because the browser otherwise automatically puts <style> into head and we can't return it
  return (_DOMParser$parseFromS = new DOMParser().parseFromString("<body>".concat(html, "</body>"), "text/html")) === null || _DOMParser$parseFromS === void 0 ? void 0 : (_DOMParser$parseFromS2 = _DOMParser$parseFromS.body) === null || _DOMParser$parseFromS2 === void 0 ? void 0 : _DOMParser$parseFromS2.childNodes;
}
function $652300c6621d5500$export$d3e2a0560cbf4787(html) {
  var _DOMParser$parseFromS3, _DOMParser$parseFromS4;
  return (_DOMParser$parseFromS3 = new DOMParser().parseFromString("<body>".concat(html, "</body>"), "text/html")) === null || _DOMParser$parseFromS3 === void 0 ? void 0 : (_DOMParser$parseFromS4 = _DOMParser$parseFromS3.body) === null || _DOMParser$parseFromS4 === void 0 ? void 0 : _DOMParser$parseFromS4.firstElementChild;
}
function $652300c6621d5500$export$d4bd03f19260ef1c(url) {
  let also_onchange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let override_dev_url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "demo.depict.ai";
  let stfu = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  let also_in_all_shadow_roots = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (process.env.DEBUG === "true" && location.href.includes(override_dev_url)) {
    const relativ_callback = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(event => {
      const anchor = event.element;
      if (typeof url === "string") {
        if (anchor.href.includes(url)) {
          if (!stfu) $241f2f02cc612a49$export$de56f1198d121036("RUNNING RELATIVIFY on", event);
          anchor.href = anchor.href.replaceAll(url, "/");
        }
      } else if (url.test(anchor.href)) {
        if (!stfu) $241f2f02cc612a49$export$de56f1198d121036("RUNNING RELATIVIFY on", event);
        anchor.href = anchor.href.replace(url, "/");
      }
    });
    const link_sel = "a[href]";
    (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists(link_sel, relativ_callback);
    if (also_onchange) (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onchange(link_sel, relativ_callback);
    if (also_in_all_shadow_roots && typeof ShadowRoot == "function") (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists("*", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(_ref => {
      let {
        element: element
      } = _ref;
      if ((element === null || element === void 0 ? void 0 : element.shadowRoot) instanceof ShadowRoot) {
        const local_observer = new (0, $7d82513db34b5d27$export$12e07a2a9f87578a)({
          territory: element.shadowRoot
        });
        local_observer.onexists(link_sel, relativ_callback);
      }
    }));
  }
}
function $652300c6621d5500$export$5e63aea0cac01fa0(elements, selector) {
  const matches = [];
  for (const element of elements) {
    var _element$matches;
    if ("querySelectorAll" in element) matches.push(...$914c6f35222c820d$export$33f937d741e49339(element, selector));
    if ("matches" in element && (_element$matches = element.matches) !== null && _element$matches !== void 0 && _element$matches.call(element, selector)) matches.push(element);
  }
  return matches;
}
function $652300c6621d5500$export$cfef5d5c9ac09253(price) {
  let places_after_comma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  let decimal_delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ",";
  let thousands_delimiter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : String.fromCharCode(160);
  if (!price && price !== 0) return "";
  if (typeof price === "string") {
    if (!isNaN(price)) {
      $5e1f45affc1d7def$export$f18d5b0af29128b7(new Error("standard_price_format did not expect price as a string"), "warning", {
        price: price
      });
      price = parseFloat(price);
    } else {
      $5e1f45affc1d7def$export$f18d5b0af29128b7(new Error("standard_price_format cannot handle price string"), "error", {
        price: price
      });
      return "";
    }
  }
  if (places_after_comma == "auto") places_after_comma = price % 1 ? 2 : 0;
  // Generalized rounding for any value of places_after_comma.
  const multiplier = Math.pow(10, places_after_comma);
  price = Math.round(price * multiplier) / multiplier;
  const fixed = places_after_comma < 0 ? price.toString().split(".") : price.toFixed(places_after_comma).split("."),
    [...chars] = fixed[0],
    reversed = chars.reverse();
  let j,
    reversed_formatted = [];
  for (let i = 0; i < reversed.length; i++) if (!(i % 3)) j = reversed_formatted.push([reversed[i]]) - 1;else reversed_formatted[j].push(reversed[i]);
  fixed[0] = reversed_formatted.map(v => v.reverse().join("")).reverse().join(thousands_delimiter);
  return fixed.join(decimal_delimiter);
}
function $652300c6621d5500$export$f124e3ee16e6b45d(bcp47_country_code, number, numberformat_options) {
  var _window, _window$Intl;
  const numfmt = (_window = window) === null || _window === void 0 ? void 0 : (_window$Intl = _window.Intl) === null || _window$Intl === void 0 ? void 0 : _window$Intl.NumberFormat;
  if (numfmt) {
    var _numfmt, _numfmt$format;
    return (_numfmt = new numfmt(bcp47_country_code, numberformat_options), _numfmt === void 0) ? void 0 : (_numfmt$format = _numfmt.format) === null || _numfmt$format === void 0 ? void 0 : _numfmt$format.call(_numfmt, number);
  }
  return $652300c6621d5500$export$cfef5d5c9ac09253(number, "auto");
}
function $652300c6621d5500$export$9590700a594aef08(obj, step1) {
  if (typeof obj[step1] === "undefined") obj[step1] = {};
  for (var _len = arguments.length, path = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) path[_key - 2] = arguments[_key];
  if (path.length) return $652300c6621d5500$export$9590700a594aef08(obj[step1], ...path);else return obj[step1];
}
function $5f31622ffb78bc10$var$_classPrivateMethodInitSpec(obj, privateSet) {
  $5f31622ffb78bc10$var$_checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}
function $5f31622ffb78bc10$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $5f31622ffb78bc10$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $5f31622ffb78bc10$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $5f31622ffb78bc10$var$_classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
  return fn;
}
var $5f31622ffb78bc10$var$_verbose = /*#__PURE__*/new WeakMap();
var $5f31622ffb78bc10$var$_images_on_first_page = /*#__PURE__*/new WeakMap();
var $5f31622ffb78bc10$var$_default_lazyfinder = /*#__PURE__*/new WeakMap();
var $5f31622ffb78bc10$var$_initiate_new_image = /*#__PURE__*/new WeakSet();
var $5f31622ffb78bc10$var$_add_load_event_listener = /*#__PURE__*/new WeakSet();
var $5f31622ffb78bc10$var$_unload_images_and_add_load_listeners = /*#__PURE__*/new WeakSet();
var $5f31622ffb78bc10$var$_start_observer = /*#__PURE__*/new WeakSet();
var $5f31622ffb78bc10$var$_check_if_first_page_has_loaded = /*#__PURE__*/new WeakSet();
class $5f31622ffb78bc10$export$3be7054c61590ee3 {
  start_observing_for_new_children_(override_container) {
    // should ONLY run on our "stock" elements array and is therefore called if "elements" is get in it - which means it's being used
    // it allows us to just add elements to the observed container and have them added to the elements array if they or their children match the selector
    if (!this.container && !override_container) return;
    const container = override_container !== null && override_container !== void 0 ? override_container : this.container;
    const mutation_observer = new MutationObserver($5e1f45affc1d7def$export$b3bbfd758f11cfa9(mutations => {
      for (let i = 0; i < mutations.length; i++) {
        const matching_added_els = $652300c6621d5500$export$5e63aea0cac01fa0(mutations[i].addedNodes, this.selector);
        if (matching_added_els.length) {
          if ($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $5f31622ffb78bc10$var$_verbose)) $241f2f02cc612a49$export$de56f1198d121036("New elements", matching_added_els, " matching selector", this.selector, "were aded to", container, "lazyloading\u2026");
          this.lazyfinder.elements.push(...matching_added_els);
          matching_added_els.forEach($5f31622ffb78bc10$var$_classPrivateMethodGet(this, $5f31622ffb78bc10$var$_initiate_new_image, $5f31622ffb78bc10$var$_initiate_new_image2).bind(this));
        }
      }
    }));
    (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists(container, _ref => {
      var _element$querySelecto;
      let {
        element: element
      } = _ref;
      const new_els = (element === null || element === void 0 ? void 0 : (_element$querySelecto = element.querySelectorAll) === null || _element$querySelecto === void 0 ? void 0 : _element$querySelecto.call(element, this.selector)) || [];
      this.lazyfinder.elements.push(...new_els);
      new_els.forEach($5f31622ffb78bc10$var$_classPrivateMethodGet(this, $5f31622ffb78bc10$var$_initiate_new_image, $5f31622ffb78bc10$var$_initiate_new_image2).bind(this));
      mutation_observer.observe(element, {
        subtree: true,
        childList: true
      });
    });
    (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onremoved(container, _ref2 => {
      let {
        element: element
      } = _ref2;
      if (!document.documentElement.contains(element)) mutation_observer.disconnect();
    });
  }
  constructor(_ref3) {
    var _lazyfinder, _lazyfinder2;
    let {
      container: container,
      lazyfinder: lazyfinder,
      selector = ["img", "source"].map(t => ":not(.d-navbutton) > ".concat(t, ":not(.filler):not(.nolazy)")).join(", "),
      wait_for_dominsertion = true,
      only_load_intersecting = false,
      ignore_data_urls = false,
      verbose: verbose
    } = _ref3;
    $5f31622ffb78bc10$var$_classPrivateMethodInitSpec(this, $5f31622ffb78bc10$var$_check_if_first_page_has_loaded);
    $5f31622ffb78bc10$var$_classPrivateMethodInitSpec(this, $5f31622ffb78bc10$var$_start_observer);
    $5f31622ffb78bc10$var$_classPrivateMethodInitSpec(this, $5f31622ffb78bc10$var$_unload_images_and_add_load_listeners);
    $5f31622ffb78bc10$var$_classPrivateMethodInitSpec(this, $5f31622ffb78bc10$var$_add_load_event_listener);
    $5f31622ffb78bc10$var$_classPrivateMethodInitSpec(this, $5f31622ffb78bc10$var$_initiate_new_image);
    $76EG6$babelruntimehelpersdefineProperty(this, "intersection_observer", void 0);
    $5f31622ffb78bc10$var$_classPrivateFieldInitSpec(this, $5f31622ffb78bc10$var$_verbose, {
      writable: true,
      value: false
    });
    $5f31622ffb78bc10$var$_classPrivateFieldInitSpec(this, $5f31622ffb78bc10$var$_images_on_first_page, {
      writable: true,
      value: []
    });
    $5f31622ffb78bc10$var$_classPrivateFieldInitSpec(this, $5f31622ffb78bc10$var$_default_lazyfinder, {
      writable: true,
      value: (() => {
        const class_this = this;
        return {
          unload(image) {
            for (const element of [image, ...$5f31622ffb78bc10$export$e4741190ccada479(image, "source")]) for (const attr of ["src", "srcset"]) {
              // I spent 30 minutes on debugging and it turns out IE11 always returns undefined for HTMLImageElementWithLoaded.srcset
              const attribute_value = element.getAttribute(attr);
              if (attribute_value !== null && attribute_value !== void 0 && attribute_value.length) {
                element.dataset[attr] = attribute_value;
                element.removeAttribute(attr);
              }
            }
          },
          load: $5e1f45affc1d7def$export$b3bbfd758f11cfa9(async image => {
            for (const element of [...$5f31622ffb78bc10$export$e4741190ccada479(image, "source"), image]) {
              var _document, _document$body, _document$body$contai, _document$body2, _element$dataset, _element$dataset$src, _element$dataset2, _element$dataset2$src;
              if ("loaded" in element) {
                if ($76EG6$babelruntimehelpersclassPrivateFieldGet(class_this, $5f31622ffb78bc10$var$_verbose)) $241f2f02cc612a49$export$de56f1198d121036(element, "is already loading, not loading again");
                continue;
              }
              if (((_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$contai = (_document$body2 = _document$body).contains) === null || _document$body$contai === void 0 ? void 0 : _document$body$contai.call(_document$body2, image)) === false) {
                if ($76EG6$babelruntimehelpersclassPrivateFieldGet(class_this, $5f31622ffb78bc10$var$_verbose)) $241f2f02cc612a49$export$de56f1198d121036(element, "has been removed from the DOM, can't load");
                const {
                  elements: elements
                } = class_this.lazyfinder;
                const index = elements.indexOf(image);
                if (index >= 0) elements.splice(index, 1);
                continue;
              }
              const has_src = (_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : (_element$dataset$src = _element$dataset.src) === null || _element$dataset$src === void 0 ? void 0 : _element$dataset$src.length;
              const has_srcset = (_element$dataset2 = element.dataset) === null || _element$dataset2 === void 0 ? void 0 : (_element$dataset2$src = _element$dataset2.srcset) === null || _element$dataset2$src === void 0 ? void 0 : _element$dataset2$src.length;
              if (has_src || has_srcset) {
                if ($76EG6$babelruntimehelpersclassPrivateFieldGet(class_this, $5f31622ffb78bc10$var$_verbose)) $241f2f02cc612a49$export$de56f1198d121036("Loading", element);
                element.loaded = false;
                // here it's of importance that we give the browser the srcset first, otherwise it (safari) might start loading the fallback src at first
                if (has_srcset) {
                  // in Safari for some reason sometimes the .sizes attribute isn't set yet, like in https://www.notion.so/depictai/Pictures-in-recommendations-are-not-displayed-88e30e0f98de421e94b9eb273aea21dc. In that case, wait up to one event loop execution for it
                  if (!element.sizes) await new Promise(resolve => {
                    const mo = new MutationObserver($5e1f45affc1d7def$export$b3bbfd758f11cfa9(_records => {
                      if (element.sizes) {
                        resolve();
                        mo.disconnect();
                      }
                    }));
                    mo.observe(element, {
                      attributes: true,
                      attributeFilter: ["sizes"]
                    });
                    setTimeout($5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
                      resolve(); // in case ResizeObserver doesn't set .sizes or something
                      mo.disconnect();
                    }));
                  });
                  element.setAttribute("srcset", element.dataset.srcset);
                  element.removeAttribute("data-srcset");
                }
                if (has_src) {
                  element.src = element.dataset.src;
                  element.removeAttribute("data-src");
                }
                class_this.intersection_observer.unobserve(element);
              } else {
                var _element$src, _element$src$startsWi, _element$src2;
                if ((_element$src = element.src) !== null && _element$src !== void 0 && (_element$src$startsWi = (_element$src2 = _element$src).startsWith) !== null && _element$src$startsWi !== void 0 && _element$src$startsWi.call(_element$src2, "data:")) continue;
                // This happens quite often for reasons unknown. One day we will figure out why, or replace this lazyloader with a new one/native.
                if ($76EG6$babelruntimehelpersclassPrivateFieldGet(class_this, $5f31622ffb78bc10$var$_verbose)) $241f2f02cc612a49$export$de56f1198d121036("Cannot load", element, "as it doesn't have a data-src or data-srcset attribute");
              }
            }
          }),
          get elements() {
            // define ourselves away with an array containing all elements we find. Said array is "listening" and calling unload and add_load_event_listener on every pushed element
            const lazyfinder_this = this;
            const currently_existing = [];
            Object.defineProperty(lazyfinder_this, "elements", {
              value: currently_existing
            });
            class_this.start_observing_for_new_children_();
            return currently_existing;
          }
        };
      })()
    });
    // store options in class so class instances can be looked at and their options are transparent
    this.container = container;
    this.selector = selector;
    this.only_load_intersecting = only_load_intersecting;
    this.ignore_data_urls = ignore_data_urls;
    if (verbose) $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $5f31622ffb78bc10$var$_verbose, true);
    // make sure we have a fully-fledged lazyfinder but still allow max customizability
    this.lazyfinder = lazyfinder || (lazyfinder = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $5f31622ffb78bc10$var$_default_lazyfinder));
    (_lazyfinder = lazyfinder).unload || (_lazyfinder.unload = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $5f31622ffb78bc10$var$_default_lazyfinder).unload);
    (_lazyfinder2 = lazyfinder).load || (_lazyfinder2.load = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $5f31622ffb78bc10$var$_default_lazyfinder).load);
    if (!("elements" in lazyfinder)) Object.defineProperty(lazyfinder, "elements", Object.getOwnPropertyDescriptor($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $5f31622ffb78bc10$var$_default_lazyfinder), "elements"));
    $5f31622ffb78bc10$var$_classPrivateMethodGet(this, $5f31622ffb78bc10$var$_unload_images_and_add_load_listeners, $5f31622ffb78bc10$var$_unload_images_and_add_load_listeners2).call(this);
    // check if we need to branch off to an async function and wait for the elements being in the DOM
    if (wait_for_dominsertion) {
      const caught_start_obs = $5e1f45affc1d7def$export$b3bbfd758f11cfa9($5f31622ffb78bc10$var$_classPrivateMethodGet(this, $5f31622ffb78bc10$var$_start_observer, $5f31622ffb78bc10$var$_start_observer2)).bind(this);
      if (wait_for_dominsertion instanceof Promise) wait_for_dominsertion.then(caught_start_obs);else {
        var _lazyfinder3, _lazyfinder3$elements;
        const el_to_listen_on = container || ((_lazyfinder3 = lazyfinder) === null || _lazyfinder3 === void 0 ? void 0 : (_lazyfinder3$elements = _lazyfinder3.elements) === null || _lazyfinder3$elements === void 0 ? void 0 : _lazyfinder3$elements[0]);
        if (el_to_listen_on instanceof Node) (0, $90fa633a9564f115$export$b6ae1bc530f4c149).wait_for_element(el_to_listen_on).then(caught_start_obs);else $241f2f02cc612a49$export$de56f1198d121036("Could not find element to attach event listener to", () => {}); // right click function in inspector and select "jump to definition" to get here
      }
    } else $5f31622ffb78bc10$var$_classPrivateMethodGet(this, $5f31622ffb78bc10$var$_start_observer, $5f31622ffb78bc10$var$_start_observer2).call(this);
  }
}
function $5f31622ffb78bc10$var$_initiate_new_image2(image) {
  var _this$intersection_ob, _this$intersection_ob2;
  if (image.loaded === true || image.loaded === false) {
    if ($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $5f31622ffb78bc10$var$_verbose)) $241f2f02cc612a49$export$de56f1198d121036("Not lazyloading", image, "because it was loaded before or is loading");
    return;
  }
  $5e1f45affc1d7def$export$b3bbfd758f11cfa9(this.lazyfinder.unload)(image);
  $5f31622ffb78bc10$var$_classPrivateMethodGet(this, $5f31622ffb78bc10$var$_add_load_event_listener, $5f31622ffb78bc10$var$_add_load_event_listener2).call(this, image);
  (_this$intersection_ob = this.intersection_observer) === null || _this$intersection_ob === void 0 || (_this$intersection_ob2 = _this$intersection_ob.observe) === null || _this$intersection_ob2 === void 0 || _this$intersection_ob2.call(_this$intersection_ob, image); // observe if observer already exists, otherwise it won't and start_observer will do it
}

function $5f31622ffb78bc10$var$_add_load_event_listener2(element) {
  const handler = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(e => {
    // cookiebot triggers random "load" events on all elements which make the images load before the intersection observer has started
    if (!element.src.length) {
      $241f2f02cc612a49$export$de56f1198d121036("ignoring load event", e, "because image doesn't have a src");
      return;
    }
    if (this.ignore_data_urls && element.src.startsWith("data:")) {
      if ($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $5f31622ffb78bc10$var$_verbose)) $241f2f02cc612a49$export$de56f1198d121036("Ignoring load event", e, "because ignore_data_urls is truthy");
      return;
    }
    element.removeEventListener("load", handler);
    element.loaded = true;
    if (!this.only_load_intersecting) $5f31622ffb78bc10$var$_classPrivateMethodGet(this, $5f31622ffb78bc10$var$_check_if_first_page_has_loaded, $5f31622ffb78bc10$var$_check_if_first_page_has_loaded2).call(this);
  });
  element.addEventListener("load", handler);
}
function $5f31622ffb78bc10$var$_unload_images_and_add_load_listeners2() {
  const {
    elements: elements,
    unload: unload
  } = this.lazyfinder;
  const caught_unload = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(unload);
  for (let i = 0; i < elements.length; i++) {
    caught_unload(elements[i]);
    $5f31622ffb78bc10$var$_classPrivateMethodGet(this, $5f31622ffb78bc10$var$_add_load_event_listener, $5f31622ffb78bc10$var$_add_load_event_listener2).call(this, elements[i]);
  }
}
function $5f31622ffb78bc10$var$_start_observer2() {
  let observers_first_call = true;
  if (!this.intersection_observer) {
    this.intersection_observer = new IntersectionObserver($5e1f45affc1d7def$export$b3bbfd758f11cfa9(entries => {
      let any_intersected = false;
      for (let i = 0; i < entries.length; i++) {
        const entry = entries[i];
        const target = entry.target;
        if (entry.intersectionRatio > 0) {
          any_intersected = true;
          if (target.loaded == null)
            // if it's false it's already loading
            this.lazyfinder.load(target);
          if (observers_first_call) $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $5f31622ffb78bc10$var$_images_on_first_page).push(target);
        }
      }
      if (any_intersected) observers_first_call = false;
    }), {
      root: this.container,
      threshold: $ab9c3dbf2bb2fbf7$export$f8ea2e7b15b5d129(3)
    });
    const {
      elements: elements
    } = this.lazyfinder;
    for (let i = 0; i < elements.length; i++) this.intersection_observer.observe(elements[i]);
  }
}
function $5f31622ffb78bc10$var$_check_if_first_page_has_loaded2() {
  const loaded_images = [];
  const not_loaded_or_loading = [];
  const {
    elements: elements
  } = this.lazyfinder;
  for (let i = 0; i < ((_elements$length = elements === null || elements === void 0 ? void 0 : elements.length) !== null && _elements$length !== void 0 ? _elements$length : 0); i++) {
    var _elements$length;
    if (elements[i].loaded === true) loaded_images.push(elements[i]);else not_loaded_or_loading.push(elements[i]);
  }
  if ($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $5f31622ffb78bc10$var$_images_on_first_page).length >= loaded_images.length) {
    const caught_loading_fin = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(this.lazyfinder.load);
    for (let i = 0; i < not_loaded_or_loading.length; i++) caught_loading_fin(not_loaded_or_loading[i]);
  }
}
function $5f31622ffb78bc10$export$b87d7e0da8b5cbe3() {
  let supports = false;
  try {
    const proxied_array = new Proxy([], {
      set: () => supports = true
    });
    proxied_array.push(1);
  } catch (e) {}
  return supports;
}
function $5f31622ffb78bc10$export$e4741190ccada479(element, selector) {
  var _element$parentElemen;
  const result = [];
  // this is made to return things in the same order as the browser prioritises <source> elements
  const children = element === null || element === void 0 ? void 0 : (_element$parentElemen = element.parentElement) === null || _element$parentElemen === void 0 ? void 0 : _element$parentElemen.children;
  for (let i = 0; i < ((_children$length = children === null || children === void 0 ? void 0 : children.length) !== null && _children$length !== void 0 ? _children$length : 0); i++) {
    var _children$length, _selected_element$mat;
    const selected_element = children[i];
    if (selected_element !== null && selected_element !== void 0 && (_selected_element$mat = selected_element.matches) !== null && _selected_element$mat !== void 0 && _selected_element$mat.call(selected_element, selector)) result.push(selected_element);
  }
  return result;
}
var $be288a83d9eabf2a$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div class="depict-slider depict">`),
  $be288a83d9eabf2a$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<div class=sliding>`),
  $be288a83d9eabf2a$var$_tmpl$3 = /*#__PURE__*/$76EG6$template(`<button aria-label="Scroll left"class="left d-navbutton"type=button>`),
  $be288a83d9eabf2a$var$_tmpl$4 = /*#__PURE__*/$76EG6$template(`<button aria-label="Scroll right"class="right d-navbutton"type=button>`);
function $be288a83d9eabf2a$var$_classPrivateMethodInitSpec(obj, privateSet) {
  $be288a83d9eabf2a$var$_checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}
function $be288a83d9eabf2a$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $be288a83d9eabf2a$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $be288a83d9eabf2a$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $be288a83d9eabf2a$var$_classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
  return fn;
}
var $be288a83d9eabf2a$var$_mutation_plugins = /*#__PURE__*/new WeakMap();
var $be288a83d9eabf2a$var$_index_cache = /*#__PURE__*/new WeakMap();
var $be288a83d9eabf2a$var$_cached_visible_sizes = /*#__PURE__*/new WeakMap();
var $be288a83d9eabf2a$var$_observe_element = /*#__PURE__*/new WeakSet();
var $be288a83d9eabf2a$var$_observer_callback = /*#__PURE__*/new WeakSet();
var $be288a83d9eabf2a$var$_hide_buttons_if_needed = /*#__PURE__*/new WeakSet();
var $be288a83d9eabf2a$var$_distance_to = /*#__PURE__*/new WeakSet();
var $be288a83d9eabf2a$var$_visibility = /*#__PURE__*/new WeakSet();
var $be288a83d9eabf2a$var$_setup_buttons = /*#__PURE__*/new WeakSet();
var $be288a83d9eabf2a$var$_create_element_structure = /*#__PURE__*/new WeakSet();
var $be288a83d9eabf2a$var$_scroll_to = /*#__PURE__*/new WeakSet();
class $be288a83d9eabf2a$export$692b27c28639e5b9 {
  // this is just here because it's often needed together with the slider
  // array of functions called in the intersection observer, like #hide_buttons_if_needed
  get_index_of_element(target) {
    var _target$parentElement;
    const {
      el_to_number_: el_to_number_
    } = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_index_cache);
    const value_from_cache = el_to_number_.get(target);
    if (value_from_cache) return value_from_cache;
    const children = target === null || target === void 0 ? void 0 : (_target$parentElement = target.parentElement) === null || _target$parentElement === void 0 ? void 0 : _target$parentElement.children;
    if (children) {
      const children_as_array = [...children];
      const index = children_as_array.indexOf(target);
      el_to_number_.set(target, index);
      return index;
    }
  }
  first_intersecting_index() {
    let min_ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
    return parseInt(Object.keys(this.intersecting_items_object).find(i => this.intersecting_items_object[i].intersectionRatio > min_ratio) || "");
  }
  get first_intersecting() {
    return this.intersecting_items_object[this.first_intersecting_index()];
  }
  get index_of_last_element() {
    var _classPrivateFieldGet2, _classPrivateFieldGet3, _this$first_intersect, _this$first_intersect2, _this$first_intersect3, _this$first_intersect4, _this$first_intersect5, _this$elements_, _this$elements_$slidi, _this$elements_$slidi2;
    return (_classPrivateFieldGet3 = (_classPrivateFieldGet2 = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_index_cache)).last_el_) !== null && _classPrivateFieldGet3 !== void 0 ? _classPrivateFieldGet3 : _classPrivateFieldGet2.last_el_ = ((_this$first_intersect = (_this$first_intersect2 = this.first_intersecting) === null || _this$first_intersect2 === void 0 ? void 0 : (_this$first_intersect3 = _this$first_intersect2.target) === null || _this$first_intersect3 === void 0 ? void 0 : (_this$first_intersect4 = _this$first_intersect3.parentElement) === null || _this$first_intersect4 === void 0 ? void 0 : (_this$first_intersect5 = _this$first_intersect4.children) === null || _this$first_intersect5 === void 0 ? void 0 : _this$first_intersect5.length) !== null && _this$first_intersect !== void 0 ? _this$first_intersect : (_this$elements_ = this.elements_) === null || _this$elements_ === void 0 ? void 0 : (_this$elements_$slidi = _this$elements_.sliding_el_) === null || _this$elements_$slidi === void 0 ? void 0 : (_this$elements_$slidi2 = _this$elements_$slidi.children) === null || _this$elements_$slidi2 === void 0 ? void 0 : _this$elements_$slidi2.length) - 1;
  }
  get currently_selected() {
    // this tries to be what distance_to assumes is the current card when converting a relative offset into an absolute one, available for plugins
    if (this.center_target) {
      // try to find index of card under container center
      const {
        visible_sizes: visible_sizes
      } = this;
      let left_offset = 0;
      const rectangle_of_container = this.elements_.sliding_el_.getBoundingClientRect();
      const middle_of_container = rectangle_of_container.width / 2;
      for (const [element, info] of visible_sizes) {
        left_offset += info.total_visible;
        if (left_offset >= middle_of_container)
          // we found the card that's under the center!
          return this.get_index_of_element(element);
      }
    } else return this.first_intersecting_index(0.9);
  }
  get visible_sizes() {
    if ($76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_cached_visible_sizes)) return $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_cached_visible_sizes);
    const visible_sizes = new Map();
    const visible_cards = Object.keys(this.intersecting_items_object).map(key => +key);
    const to_calculate = [visible_cards[0] - 1, ...visible_cards, visible_cards[visible_cards.length - 1] + 1].map(index => this.element_by_index(+index)).filter(e => e);
    const root_el = this.elements_.sliding_el_;
    const root = root_el.getBoundingClientRect();
    const root_computed_style = getComputedStyle(root_el);
    const root_left = root.left - parseInt(root_computed_style.marginLeft);
    const root_right = root.right + parseInt(root_computed_style.marginRight);
    // const root_width = root_right - root_left;
    // this.#visualize(root_left + "px", "green");
    // this.#visualize(root_right + "px", "red");
    for (let i = 0; i < to_calculate.length; i++) {
      const element = to_calculate[i];
      if (!element) continue;
      const card = element.getBoundingClientRect();
      const card_computed_style = getComputedStyle(element);
      const marginLeft = parseInt(card_computed_style.marginLeft);
      const marginRight = parseInt(card_computed_style.marginRight);
      const card_left = card.left - marginLeft;
      const card_right = card.right + marginRight;
      // this.#visualize(card_left + "px", "rgba(255,0,0,0.5)");
      // this.#visualize(card_right + "px", "rgba(0,255,0,0.5)");
      const actual_left_diff = root_left - card_left;
      const left_diff = actual_left_diff > 0 ? actual_left_diff : 0;
      const actual_right_diff = card_right - root_right;
      const right_diff = actual_right_diff > 0 ? actual_right_diff : 0;
      const intersecting_line = card_right - card_left - left_diff - right_diff;
      if (intersecting_line < 0) continue;
      visible_sizes.set(element, {
        total_visible: intersecting_line,
        get ratio_visible() {
          const card_width = card_right - card_left;
          return intersecting_line / card_width;
        },
        margin_left: marginLeft,
        margin_right: marginRight,
        rect: card
      });
    }
    $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $be288a83d9eabf2a$var$_cached_visible_sizes, visible_sizes);
    // let's assume we can cache this for a tick since the slider scrolls smoothly so there's no point in reading it instantly again and assuming a different value
    queueMicrotask($5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $be288a83d9eabf2a$var$_cached_visible_sizes, undefined)));
    return visible_sizes;
  }
  get cards_fitting_in_viewport() {
    // we can't use intersectionRatio since it's a) also in the y-axis and b) doesn't contain borders and margins
    const visible_sizes = [...this.visible_sizes.values()].map(e => e.total_visible);
    const max = Math.max(...visible_sizes);
    const min1 = Math.min(...visible_sizes);
    visible_sizes.splice(visible_sizes.indexOf(min1), 1);
    const min2 = Math.min(...visible_sizes);
    visible_sizes.splice(visible_sizes.indexOf(min2), 1);
    if (min1 + min2 <= max) visible_sizes.push(min1 + min2);else visible_sizes.push(min1, min2);
    return visible_sizes.length;
  }
  // #visualize(left: string, color: string) {
  //   const div = document.createElement("div");
  //   div.style.position = "fixed";
  //   div.style.top = "50vh";
  //   div.style.left = left;
  //   div.style.width = "1px";
  //   div.style.height = "10cm";
  //   div.style.background = color;
  //   document.body.append(div);
  //   setTimeout(() => div.remove(), 1000);
  // }
  element_by_index(index) {
    var _ref;
    const from_cache = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_index_cache).number_to_el_.get(index);
    if (from_cache) return from_cache;
    const {
      sliding_el_: sliding_el_
    } = this.elements_;
    let maybe_el = (_ref = [...((sliding_el_ === null || sliding_el_ === void 0 ? void 0 : sliding_el_.children) || [])], _ref === void 0) ? void 0 : _ref[index];
    if (!maybe_el) {
      var _ref2, _this$first_intersect6, _this$first_intersect7, _this$first_intersect8;
      // this is for plantagen which has a double whammy slider
      maybe_el = (_ref2 = [...(((_this$first_intersect6 = this.first_intersecting) === null || _this$first_intersect6 === void 0 ? void 0 : (_this$first_intersect7 = _this$first_intersect6.target) === null || _this$first_intersect7 === void 0 ? void 0 : (_this$first_intersect8 = _this$first_intersect7.parentElement) === null || _this$first_intersect8 === void 0 ? void 0 : _this$first_intersect8.children) || [])], _ref2 === void 0) ? void 0 : _ref2[index];
    }
    $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_index_cache).number_to_el_.set(index, maybe_el);
    return maybe_el;
  }
  invalidate_cache() {
    // dlog("Invalidating index cache");
    $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_index_cache).number_to_el_.clear();
    $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_index_cache).el_to_number_.clear();
    $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_index_cache).last_el_ = undefined;
  }
  scroll_to_rel(offset) {
    let harsh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    $be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_scroll_to, $be288a83d9eabf2a$var$_scroll_to2).call(this, offset, false, undefined, harsh);
  }
  scroll_to_abs(offset) {
    let harsh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    $be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_scroll_to, $be288a83d9eabf2a$var$_scroll_to2).call(this, offset, true, undefined, harsh);
  }
  constructor(_ref3) {
    var _constructor_plugins$;
    let {
      dist_to_hide_left: dist_to_hide_left,
      dist_to_hide_right: dist_to_hide_right,
      stepstoslide: stepstoslide,
      center_target: center_target,
      mutation_plugins: _mutation_plugins2,
      constructor_plugins: constructor_plugins,
      correct_bs_targets: correct_bs_targets,
      button_contents: button_contents,
      button_elems: button_elems,
      autoinvalidate_cache: autoinvalidate_cache
    } = _ref3;
    $be288a83d9eabf2a$var$_classPrivateMethodInitSpec(this, $be288a83d9eabf2a$var$_scroll_to);
    $be288a83d9eabf2a$var$_classPrivateMethodInitSpec(this, $be288a83d9eabf2a$var$_create_element_structure);
    $be288a83d9eabf2a$var$_classPrivateMethodInitSpec(this, $be288a83d9eabf2a$var$_setup_buttons);
    $be288a83d9eabf2a$var$_classPrivateMethodInitSpec(this, $be288a83d9eabf2a$var$_visibility);
    $be288a83d9eabf2a$var$_classPrivateMethodInitSpec(this, $be288a83d9eabf2a$var$_distance_to);
    $be288a83d9eabf2a$var$_classPrivateMethodInitSpec(this, $be288a83d9eabf2a$var$_hide_buttons_if_needed);
    $be288a83d9eabf2a$var$_classPrivateMethodInitSpec(this, $be288a83d9eabf2a$var$_observer_callback);
    $be288a83d9eabf2a$var$_classPrivateMethodInitSpec(this, $be288a83d9eabf2a$var$_observe_element);
    $76EG6$babelruntimehelpersdefineProperty(this, "container", $76EG6$getNextElement($be288a83d9eabf2a$var$_tmpl$));
    $76EG6$babelruntimehelpersdefineProperty(this, "elements_", {
      sliding_el_: $76EG6$getNextElement($be288a83d9eabf2a$var$_tmpl$2),
      left_: $76EG6$getNextElement($be288a83d9eabf2a$var$_tmpl$3),
      right_: $76EG6$getNextElement($be288a83d9eabf2a$var$_tmpl$4)
    });
    $76EG6$babelruntimehelpersdefineProperty(this, "insert_here", this.elements_.sliding_el_);
    $76EG6$babelruntimehelpersdefineProperty(this, "intersecting_items_object", {});
    $be288a83d9eabf2a$var$_classPrivateFieldInitSpec(this, $be288a83d9eabf2a$var$_mutation_plugins, {
      writable: true,
      value: []
    });
    $76EG6$babelruntimehelpersdefineProperty(this, "stepstoslide", 2);
    $76EG6$babelruntimehelpersdefineProperty(this, "dist_to_hide_left", 10);
    $76EG6$babelruntimehelpersdefineProperty(this, "dist_to_hide_right", 10);
    $76EG6$babelruntimehelpersdefineProperty(this, "center_target", false);
    $76EG6$babelruntimehelpersdefineProperty(this, "correct_bs_targets", true);
    $76EG6$babelruntimehelpersdefineProperty(this, "snap_style", void 0);
    $76EG6$babelruntimehelpersdefineProperty(this, "on_elements_changed", [$be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_observe_element, $be288a83d9eabf2a$var$_observe_element2)]);
    $be288a83d9eabf2a$var$_classPrivateFieldInitSpec(this, $be288a83d9eabf2a$var$_index_cache, {
      writable: true,
      value: {
        last_el_: undefined,
        number_to_el_: new Map(),
        el_to_number_: new Map()
      }
    });
    $be288a83d9eabf2a$var$_classPrivateFieldInitSpec(this, $be288a83d9eabf2a$var$_cached_visible_sizes, {
      writable: true,
      value: void 0
    });
    $76EG6$babelruntimehelpersdefineProperty(this, "observer", new IntersectionObserver($be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_observer_callback, $be288a83d9eabf2a$var$_observer_callback2).bind(this), {
      root: this.elements_.sliding_el_,
      threshold: $ab9c3dbf2bb2fbf7$export$f8ea2e7b15b5d129(100)
    }));
    $76EG6$babelruntimehelpersdefineProperty(this, "observe", this.observer.observe.bind(this.observer));
    dist_to_hide_left && (this.dist_to_hide_left = dist_to_hide_left);
    dist_to_hide_right && (this.dist_to_hide_right = dist_to_hide_right);
    stepstoslide && (this.stepstoslide = stepstoslide);
    center_target && (this.center_target = true);
    _mutation_plugins2 && $76EG6$babelruntimehelpersclassPrivateFieldSet(this, $be288a83d9eabf2a$var$_mutation_plugins, _mutation_plugins2);
    correct_bs_targets == false && (this.correct_bs_targets = correct_bs_targets);
    if (button_elems) {
      this.elements_.right_ = button_elems.right;
      this.elements_.left_ = button_elems.left;
    }
    if (button_contents !== null && button_contents !== void 0 && button_contents.right) this.elements_.right_.append(...button_contents.right);
    if (button_contents !== null && button_contents !== void 0 && button_contents.left) this.elements_.left_.append(...button_contents.left);
    $5e1f45affc1d7def$export$b3bbfd758f11cfa9($be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_create_element_structure, $be288a83d9eabf2a$var$_create_element_structure2)).call(this, autoinvalidate_cache);
    // @ts-ignore
    this.elements_.sliding_el_.slider = this; // dunno if this is dumb? So far nordicagolf/kondomvaruhuset depend on it
    // plugin functionality i.e. for dots
    const constructor_args = arguments;
    constructor_plugins === null || constructor_plugins === void 0 || (_constructor_plugins$ = constructor_plugins.forEach) === null || _constructor_plugins$ === void 0 || _constructor_plugins$.call(constructor_plugins, mplugin => {
      $5e1f45affc1d7def$export$b3bbfd758f11cfa9(mplugin).call(this, constructor_args);
    });
  }
}
function $be288a83d9eabf2a$var$_observe_element2(records) {
  const {
    observer: observer
  } = this;
  const {
    sliding_el_: sliding_el_
  } = this.elements_;
  for (const record of records) {
    for (const node of record.addedNodes) if (node instanceof Element && node.parentElement === sliding_el_) observer.observe(node);
    for (const node of record.removedNodes) if (node instanceof Element && node.parentElement === sliding_el_) observer.unobserve(node);
  }
}
function $be288a83d9eabf2a$var$_observer_callback2(entries) {
  const intersecting_items = this.intersecting_items_object;
  for (let i = 0; i < entries.length; i++) {
    const entry = entries[i];
    const {
      target: target
    } = entry;
    const rec_idx = this.get_index_of_element(target);
    if (entry.intersectionRatio <= 0) {
      for (const key in intersecting_items) if (intersecting_items[key].target === target) delete intersecting_items[key];
    } else if (rec_idx != null) intersecting_items[rec_idx] = entry;else $241f2f02cc612a49$export$de56f1198d121036("Could not find index of", target, "ignoring observer record");
  }
  $5e1f45affc1d7def$export$b3bbfd758f11cfa9($be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_hide_buttons_if_needed, $be288a83d9eabf2a$var$_hide_buttons_if_needed2)).call(this);
  const mutation_plugins = $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $be288a83d9eabf2a$var$_mutation_plugins);
  for (let i = 0; i < mutation_plugins.length; i++) $5e1f45affc1d7def$export$b3bbfd758f11cfa9(mutation_plugins[i]).call(this, entries, intersecting_items);
}
function $be288a83d9eabf2a$var$_hide_buttons_if_needed2() {
  var _is$;
  // it should be correct that this routine is using sliding_el because for the buttons the position of the first and last element to the main container is relevant
  const cont = this.elements_.sliding_el_,
    lastel = this.index_of_last_element,
    cont_rect = cont.getBoundingClientRect(),
    is = this.intersecting_items_object;
  let dist_to_left;
  if (is[0] && ((_is$ = is[0]) === null || _is$ === void 0 ? void 0 : _is$.intersectionRatio) < 0.9)
    // the intersection observer won't trigger again FOR THE LEFT IMAGE when we're very far to the left, this works around that
    dist_to_left = is[0].boundingClientRect.left - cont_rect.left;else {
    const first_element = this.element_by_index(0);
    if (first_element) dist_to_left = first_element.getBoundingClientRect().left - cont_rect.left; // need to check anyways because some very violent scrolls will make the buttons go missing otherwise
    else
      // slider is empty
      dist_to_left = 0;
  }
  if (dist_to_left >= -this.dist_to_hide_left) $be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_visibility, $be288a83d9eabf2a$var$_visibility2).call(this, this.elements_.left_, 0);else $be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_visibility, $be288a83d9eabf2a$var$_visibility2).call(this, this.elements_.left_, 1);
  const rightmost_edge_of_last_card = Math.floor((this.element_by_index(lastel) || this.elements_.sliding_el_).getBoundingClientRect().right);
  const rightmost_edge_of_container = cont_rect.right,
    dist_to_right = rightmost_edge_of_last_card - rightmost_edge_of_container;
  // dlog("dist to right", dist_to_right, "dist to left", dist_to_left);
  if (dist_to_right <= this.dist_to_hide_right) $be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_visibility, $be288a83d9eabf2a$var$_visibility2).call(this, this.elements_.right_, 0);else $be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_visibility, $be288a83d9eabf2a$var$_visibility2).call(this, this.elements_.right_, 1);
}
function $be288a83d9eabf2a$var$_distance_to2(offset) {
  let is_absolute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const intersecting_items = this.intersecting_items_object; // the privateFieldGet babel polyfill isn't very fast so for extra snappyness I won't get it multiple times
  $241f2f02cc612a49$export$de56f1198d121036("intersecting_items", intersecting_items);
  // I know I could have made this.intersecting_items_object a simple array instead, but maybe someone needs the boundingrect information in it some day. Also I thought I could use it, but it isn't always up to date due to the intersection observer not triggering on every scrolling move.
  // Now, some months later: the triggering frequency can easily be adjusted, the problem is that the observer doesn't trigger on hidden elements, meaning when scrolling left we don't have information about the hidden element's position from the observer
  let target; // absolute index to focus on
  if (is_absolute) target = offset;else if (this.center_target) {
    const {
      currently_selected: currently_selected
    } = this;
    if (currently_selected == null) {
      // if for whatever reason we don't find a card, don't do anything
      $5e1f45affc1d7def$export$f18d5b0af29128b7(new Error("can't find card in center"), "error");
      return 0;
    }
    target = currently_selected + offset;
  } else {
    let index_of_first_intersecting;
    // we don't want the first one to count as intersecting just because it's 20% visible
    if (offset < 0) {
      index_of_first_intersecting = this.first_intersecting_index(0.9);
      if (isNaN(index_of_first_intersecting)) index_of_first_intersecting = this.first_intersecting_index(); // if this doesn't yield element, try to get all
    } else index_of_first_intersecting = this.first_intersecting_index();
    target = +index_of_first_intersecting + offset;
  }
  target = Math.floor(target);
  let dist;
  $241f2f02cc612a49$export$de56f1198d121036("trying to focus target", target);
  let target_element = this.element_by_index(target);
  if (!target_element) {
    if (this.correct_bs_targets) {
      if (isNaN(target)) {
        $241f2f02cc612a49$export$de56f1198d121036("target is not a number", target, "can't correct");
        return 0;
      } else if (target < 0) {
        $241f2f02cc612a49$export$de56f1198d121036("Target", target, "is < 0, correcting to 0 because correct_bs_targets is enabled");
        target = 0;
        target_element = this.element_by_index(target);
        if (!target_element) {
          $241f2f02cc612a49$export$de56f1198d121036("can't find element 0");
          return 0;
        }
      } else {
        $241f2f02cc612a49$export$de56f1198d121036("target", target, "does not exist, correcting to last sliding element \uD83E\uDD2D");
        target = this.index_of_last_element;
        target_element = this.element_by_index(target);
        if (!target_element) {
          $241f2f02cc612a49$export$de56f1198d121036("last element", target, "could not be found");
          return 0;
        }
      }
    } else {
      $241f2f02cc612a49$export$de56f1198d121036("target is bs, can't find", target, "by either data-index attribute or as child of", this.elements_.sliding_el_);
      return 0;
    }
  }
  const rectangle_of_target = target_element.getBoundingClientRect();
  const distance_of_li = rectangle_of_target.left + target % 1 * rectangle_of_target.width;
  const rectangle_of_container = this.elements_.sliding_el_.getBoundingClientRect();
  const distance_of_container = rectangle_of_container.left;
  dist = distance_of_li - distance_of_container;
  if (this.center_target) try {
    const {
      visible_sizes: visible_sizes
    } = this;
    const keys = [...visible_sizes.keys()];
    const middle_value_index = Math.floor(visible_sizes.size / 2);
    const target_card = keys[middle_value_index];
    const target_info = visible_sizes.get(target_card);
    const coords_of_container_center = distance_of_container + rectangle_of_container.width / 2;
    const coords_of_chosen_card_center = target_info.rect.left + target_info.rect.width / 2;
    dist = coords_of_chosen_card_center - coords_of_container_center;
    const num_cards_off_target = target - this.get_index_of_element(target_card);
    if (num_cards_off_target !== 0) {
      const biggest_card = Math.max(...[...visible_sizes.values()].map(s => s.total_visible));
      dist += biggest_card * num_cards_off_target;
    }
  } catch (e) {
    $b000f5ef6ce456d9$export$8048b892d651b310(e);
  }
  return dist;
}
function $be288a83d9eabf2a$var$_visibility2(element, should_be_visible) {
  const ishidden = element.classList.contains("hidden");
  if (should_be_visible && ishidden) element.classList.remove("hidden");else if (!should_be_visible && !ishidden) element.classList.add("hidden");
}
function $be288a83d9eabf2a$var$_setup_buttons2() {
  const goleft = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => $be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_scroll_to, $be288a83d9eabf2a$var$_scroll_to2).call(this, -this.stepstoslide, false, -510));
  const goright = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => $be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_scroll_to, $be288a83d9eabf2a$var$_scroll_to2).call(this, this.stepstoslide, false, 510));
  const {
    right_: right_,
    left_: left_
  } = this.elements_;
  left_.addEventListener("click", goleft);
  right_.addEventListener("click", goright);
  [left_, right_].forEach(button => {
    button.addEventListener("dragstart", e => (e.preventDefault(), false));
  });
}
function $be288a83d9eabf2a$var$_create_element_structure2() {
  let autoinvalidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const es = this.elements_;
  $be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_setup_buttons, $be288a83d9eabf2a$var$_setup_buttons2).call(this);
  this.container.append(es.left_, es.right_);
  this.container.append(es.sliding_el_);
  if (autoinvalidate) {
    const cache_mo = new MutationObserver($5e1f45affc1d7def$export$b3bbfd758f11cfa9(records => {
      this.invalidate_cache();
      for (const extra_fn of this.on_elements_changed) extra_fn.call(this, records);
    }));
    (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists(es.sliding_el_, _ref4 => {
      let {
        element: element
      } = _ref4;
      this.invalidate_cache();
      cache_mo.observe(element, {
        childList: true,
        subtree: true
      });
      for (const kid of element.children) this.observer.observe(kid);
      (0, $90fa633a9564f115$export$b6ae1bc530f4c149).wait_for_listener("removed", element).then(el => {
        if (document.documentElement.contains(el)) return; // Don't accidentally disconnect if we already got re-inserted
        cache_mo.disconnect();
      });
    });
  }
}
function $be288a83d9eabf2a$var$_scroll_to2(offset) {
  let is_absolute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let fallback_scroll_distance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  let harsh = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const left = $5e1f45affc1d7def$export$b3bbfd758f11cfa9($be288a83d9eabf2a$var$_classPrivateMethodGet(this, $be288a83d9eabf2a$var$_distance_to, $be288a83d9eabf2a$var$_distance_to2)).call(this, offset, is_absolute);
  const distance_after_fallback_applied = Math.round(left !== null && left !== void 0 ? left : fallback_scroll_distance);
  if (getComputedStyle(this.elements_.sliding_el_).scrollSnapType !== "none" && Math.abs(distance_after_fallback_applied) < 10) {
    $241f2f02cc612a49$export$de56f1198d121036("Not scrolling because snapping is enabled and distance not over threshold", distance_after_fallback_applied);
    return;
  }
  $241f2f02cc612a49$export$de56f1198d121036("Trying to scroll by", left, "px", "before fallback,", distance_after_fallback_applied, "after");
  this.elements_.sliding_el_.scrollBy({
    left: distance_after_fallback_applied,
    top: 0,
    behavior: harsh ? "auto" : "smooth"
  });
}
class $f340c415f2e1d03a$export$68babfc5be0de5da extends (0, $be288a83d9eabf2a$export$692b27c28639e5b9) {
  constructor(options, lazyfier_options) {
    super(options);
    const lazy_promise = new Promise(r => {
      (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists(this.insert_here, _ref => {
        let {
          element: element,
          disconnector: disconnector
        } = _ref;
        const i_o = new IntersectionObserver($5e1f45affc1d7def$export$b3bbfd758f11cfa9(records => {
          for (const record of records) if (record.intersectionRatio > 0) {
            r(true);
            i_o.disconnect();
            disconnector();
            return;
          }
        }),
        // Fixes https://gitlab.com/depict-ai/depict.ai/-/merge_requests/5816/diffs, don't understand why
        {
          threshold: $ab9c3dbf2bb2fbf7$export$f8ea2e7b15b5d129(10)
        });
        i_o.observe(element);
      });
    });
    this.lazyfier = new (0, $5f31622ffb78bc10$export$3be7054c61590ee3)({
      container: this.insert_here,
      wait_for_dominsertion: lazy_promise,
      ...(lazyfier_options || {})
    });
  }
}
const $0342f59060b8a196$var$default_image_src = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjYsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxNiAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTYgMTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwb2x5Z29uIHBvaW50cz0iOSwyLjYgOC4zLDMuNCAxMi40LDcuNSAxLjYsNy41IDEuNiw4LjUgMTIuNCw4LjUgOC4zLDEyLjYgOSwxMy40IDE0LjQsOCAiLz4NCjwvc3ZnPg0K";
class $0342f59060b8a196$export$4d41c6499d53639c extends (0, $f340c415f2e1d03a$export$68babfc5be0de5da) {
  constructor(static_options, override_lazyfier_options) {
    const options = {
      button_contents: Object.fromEntries(["left", "right"].map(side => [side, [(() => {
        const image = new Image();
        image.src = static_options.arrow_image || $0342f59060b8a196$var$default_image_src;
        image.alt = side + " arrow";
        return image;
      })()]])),
      ...static_options
    };
    super(options, {
      lazyfinder: {
        unload(image) {
          $5e1f45affc1d7def$export$b3bbfd758f11cfa9(async () => {
            var _image$dataset, _image$dataset$src;
            if (!(image !== null && image !== void 0 && (_image$dataset = image.dataset) !== null && _image$dataset !== void 0 && (_image$dataset$src = _image$dataset.src) !== null && _image$dataset$src !== void 0 && _image$dataset$src.length)) {
              image.dataset.src = image.src;
              image.removeAttribute("src");
            }
          })();
        }
      },
      ...(override_lazyfier_options || {})
    });
  }
}
function $0342f59060b8a196$export$f1b8b9fd75ddcab1(slider) {
  const style_elem = document.createElement("style");
  style_elem.type = "text/css";
  style_elem.append((0, /*@__PURE__*/$parcel$interopDefault($d58f55a8abd5e8fe$exports)));
  slider.container.appendChild(style_elem);
}

// not ideal but can help when debugging via sentry
/**
 * A function that attempts to "serialize" an object to a text representation that helps with debugging when using sentry
 * @param  anything               Something to try to serialize - this function is crappy and your mileage may vary
 * @param  depth                  How deep to go when recursing
 * @return          An object that is somehow closer to text (better serializable by sentry) or text
 */
function $d9aec442b12a1134$export$39d526a1194b6499(anything, depth) {
  var _depth;
  (_depth = depth) !== null && _depth !== void 0 ? _depth : depth = 0;
  depth++;
  if (depth > 30) return anything;
  const output = {};
  for (const key in anything) {
    const value = anything[key];
    let serialized_value;
    if (value instanceof Element) serialized_value = value.cloneNode(false).outerHTML;else if (value instanceof Headers) serialized_value = Object.fromEntries(value.entries());else if (typeof value == "object" && value != null && (typeof value[Symbol.iterator] === "function" || value instanceof Response)) serialized_value = $d9aec442b12a1134$export$39d526a1194b6499(value, depth);else {
      var _value$toString;
      serialized_value = value === null || value === void 0 ? void 0 : (_value$toString = value.toString) === null || _value$toString === void 0 ? void 0 : _value$toString.call(value);
    }
    output[key] = serialized_value;
  }
  return output;
}
var
/**
* @deprecated please use `fetch_retry()` instead
*
* Windows proof fetch factory: windows proof fetch is a utility which retries fetch requests 10 times when they fail. Reason for this is a certain windows 10 build where the network stack randomly breaks 20% of https connections
* (Note: this thing really should be rewritten with exponential backoff and a better API)
* @param  dlog                    logging function to use
* @param  error_log               an array to which errors will be pushed
* @return           a windows proof fetch function
*/
$03021b39f80fac4b$export$2e2bcd8739ae039 = (dlog, error_log) => {
  // https://sentry.io/organizations/depictai-0o/issues/2025371462/?project=5476183&query=is%3Aunresolved
  // https://stackoverflow.com/a/52947884
  const windows_proof_fetch = async function (url, body, headers, decode_json, fetch_options, attempt) {
    var _decode_json;
    attempt || (attempt = 1);
    (_decode_json = decode_json) !== null && _decode_json !== void 0 ? _decode_json : decode_json = true;
    const {
      stack: stack
    } = new Error();
    const elog = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
      if (Array.isArray(error_log)) error_log.push(args);
      return dlog(...args);
    };
    return await fetch(url, {
      ...(body ? {
        body: body
      } : {}),
      "method": "POST",
      ...(fetch_options ? fetch_options : {}),
      ...(headers ? {
        headers: headers
      } : {})
    }).then(async response => {
      if (!response || !response.ok || response.status !== 200) {
        if (response.status === 422) $5e1f45affc1d7def$export$b3bbfd758f11cfa9($03021b39f80fac4b$var$send_sentry_422)(response, body, stack);
        elog("Response not ok", response);
        return false;
      } else return await response[decode_json ? "json" : "text"]().catch(e => elog("error while decoding json", e));
    }).catch(e => {
      elog("Error while fetching", e, url, body);
      if ((e.name == "TypeError" || e.message == "Failed to fetch" || e.message == "Network request failed") && !e.message.includes("CORS") && !e.name.includes("CORS") && ++attempt < 10) return windows_proof_fetch(url, body, headers, decode_json, fetch_options, attempt);
      return false;
    });
  };
  return windows_proof_fetch;
};
async function $03021b39f80fac4b$var$send_sentry_422(response, body, stack) {
  const msg = "Validation error: got 422 from API";
  const text = await response.text();
  $241f2f02cc612a49$export$de56f1198d121036(msg, "body", body, "response", response, "text", text, "stack", stack);
  (0, $17bb552dedcd526c$export$af2e17a20c2ea3c5).withScope(function (scope) {
    scope.setExtra("stack", stack);
    scope.setExtra("request_body", body);
    scope.setExtra("response", response);
    scope.setExtra("serialized_response", $d9aec442b12a1134$export$39d526a1194b6499(response));
    scope.setExtra("response_text", text);
    scope.setLevel("error");
    this.captureException(new Error(msg));
  });
}
const $a285401a927e4306$export$eb0b9ed911409b57 = (callback, element) => ($5e1f45affc1d7def$export$b3bbfd758f11cfa9(callback)(element), element);
function $a285401a927e4306$export$f63fcc839cb0f734(event, handler, element) {
  element.addEventListener(event, $5e1f45affc1d7def$export$b3bbfd758f11cfa9(handler));
  return element;
}
const $a285401a927e4306$export$22a65337c1b43b1f = /* @PURE */classes => classes.filter(c => c !== undefined).join(" ");
const $0f650018c3cbc373$var$appendChild = (parent, child) => {
  if (!child) return; // null, undefined, false, "", etc should not create nodes
  if (!(child instanceof Node || typeof child === "string") && typeof child[Symbol.iterator] === "function") {
    if (child.length !== undefined)
      // it's array-like enough to be iterated with a normal for loop (for-of is 20% of that speed)
      for (let i = 0; i < child.length; i++) $0f650018c3cbc373$var$appendChild(parent, child[i]);else
      // fallback for things only implementing iterator interface
      for (const more_kids of child) $0f650018c3cbc373$var$appendChild(parent, more_kids);
    return;
  }
  parent.append(child);
};
const $0f650018c3cbc373$export$34b9dba7ce09269b = (tag, _ref, _unknown) => {
  let {
    children: children,
    ...props
  } = _ref;
  if (typeof tag === "function") return tag({
    children: children,
    ...props
  }, _unknown);
  // For partial SVG support
  // Exhaustive list (I think) for these checks should be ["svg","animate","animateMotion","animateTransform","circle","clipPath","defs","desc","ellipse","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","filter","foreignObject","g","image","line","linearGradient","marker","mask","metadata","path","pattern","polygon","polyline","radialGradient","rect","stop","switch","symbol","text","textPath","tspan","use","view"]
  const is_svg = (props === null || props === void 0 ? void 0 : props.xmlns) || tag == "defs" || tag == "filter" || tag == "fecolormatrix" || tag == "g" || tag == "circle" || tag == "circle" || tag == "svg" || tag == "path" || tag == "polygon";
  if (is_svg) var namespace = (props === null || props === void 0 ? void 0 : props.xmlns) || "http://www.w3.org/2000/svg";
  if (typeof document === "undefined") return {};
  const element = is_svg ? document.createElementNS(namespace, tag) : document.createElement(tag);
  for (const key in props) {
    const value = props[key];
    if (key === "onClick") element.addEventListener("click", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(value));else if (key.startsWith("xlink:"))
      // https://stackoverflow.com/a/23142447
      // https://developer.mozilla.org/en-US/docs/Web/SVG/Namespaces_Crash_Course
      element.setAttributeNS("http://www.w3.org/1999/xlink", key, value);else if (key == "xmlns" || key.startsWith("xmlns:")) element.setAttributeNS("http://www.w3.org/2000/xmlns/", key, value);else if (key.startsWith("xml:")) element.setAttributeNS("http://www.w3.org/XML/1998/namespace", key, value);else element.setAttribute(key, props[key]);
  }
  $0f650018c3cbc373$var$appendChild(element, children);
  return element;
};
const $0f650018c3cbc373$export$25062201e9e25d76 = $0f650018c3cbc373$export$34b9dba7ce09269b;
const $0f650018c3cbc373$export$ffb0004e005737fa = (_ref2, _unknown) => {
  let {
    children: children
  } = _ref2;
  if (typeof document === "undefined") return {};
  const df = document.createDocumentFragment();
  $0f650018c3cbc373$var$appendChild(df, children);
  return df;
};
var $c755e2b0d4b18501$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<svg xmlns=http://www.w3.org/2000/svg viewBox="0 0 320 512"><desc>Right arrow</desc><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z">`),
  $c755e2b0d4b18501$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<svg xmlns=http://www.w3.org/2000/svg viewBox="0 0 320 512"><desc>Left arrow</desc><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">`);
const $c755e2b0d4b18501$export$dc84183312f0c201 = /*@__PURE__*/(() => $76EG6$getNextElement($c755e2b0d4b18501$var$_tmpl$))();
const $c755e2b0d4b18501$export$6038895ac52bd044 = /*@__PURE__*/(() => $76EG6$getNextElement($c755e2b0d4b18501$var$_tmpl$2))();
const $0fe3923936d40f55$export$68c017fd93791405 = function () {
  let {
    duration = 500
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    duration: 500
  };
  const container = document.createElement("div");
  container.style.overflow = "hidden";
  container.style.height = "0";
  container.style.transition = "height 0.5s";
  const content = document.createElement("div");
  container.append(content);
  const expand = () => {
    container.style.height = content.clientHeight + "px";
    setTimeout($5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
      container.style.overflow = "unset";
      container.style.height = "auto";
    }), duration);
  };
  return {
    expand: expand,
    content: content,
    container: container
  };
};
const $20fe9624210ef635$export$deca40f48c0569f8 = typeof window === "undefined" ? false : /*@__PURE__*/localStorage.getItem("colorize-logics") === "true";
function $20fe9624210ef635$export$16501883f477737a(elements, display) {
  elements.forEach(elem => {
    if (elem.nodeType !== Node.TEXT_NODE) {
      var _elem$setAttribute, _elem$setAttribute2;
      // calc a hash for given string
      const hc = function () {
        let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        let hash = 0;
        if (str.length === 0) return hash;
        for (let i = 0; i < str.length; i++) {
          const chr = str.charCodeAt(i);
          hash = (hash << 5) - hash + chr;
          hash |= 0;
        }
        return hash;
      };
      const hash = hc(display.logic);
      // Change hue based on hash
      const color = "hsl(" + hash % 360 + ",100%,75%)";
      if ("style" in elem) elem.style.background = color;
      // @ts-ignore
      elem === null || elem === void 0 || (_elem$setAttribute = elem.setAttribute) === null || _elem$setAttribute === void 0 || _elem$setAttribute.call(elem, "data-logic", display.logic);
      // @ts-ignore
      elem === null || elem === void 0 || (_elem$setAttribute2 = elem.setAttribute) === null || _elem$setAttribute2 === void 0 || _elem$setAttribute2.call(elem, "title", "Logic: " + display.logic);
    }
  });
  return elements;
}
function $07beada135e5f5e8$export$f8913c8a18f7ca21(iterables) {
  const ourselves = $7ca6fdc721083788$export$e806c6c1615a59ae();
  const values = new Array(iterables.length);
  Promise.all(iterables.map($5e1f45affc1d7def$export$b3bbfd758f11cfa9(async (iterable, index) => {
    for await (const value of iterable) {
      values[index] = value;
      ourselves([...values]);
    }
  }))).then($5e1f45affc1d7def$export$b3bbfd758f11cfa9(ourselves.exit));
  return ourselves;
}
let $df6d080cba513381$var$_Symbol$iterator, $df6d080cba513381$var$_Symbol$toPrimitive;
var $df6d080cba513381$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<style type=text/css>`),
  $df6d080cba513381$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<div>`);
const $df6d080cba513381$export$717f13d9ba00ca19 = (min, max) => "@media ".concat(min ? "(min-width:".concat(min, ")") : "").concat(min && max ? " and " : "").concat(max ? "(max-width:".concat(max, ")") : "");
async function $df6d080cba513381$export$c84671f46d6a1ca(_ref) {
  let {
    rows: rows,
    container_element: container_element,
    cols_at_size: cols_at_size,
    grid_spacing: grid_spacing,
    layout: layout,
    disable_partial_rows: disable_partial_rows,
    override_vertical_spacing: override_vertical_spacing
  } = _ref;
  const rows_or_empty_object = typeof rows == "object" ? rows : {}; // this is to satisfy typescript
  const {
    start_rows = 1,
    button: button,
    max_rows = -1
  } = rows_or_empty_object;
  let {
    ipns: ipns
  } = rows_or_empty_object;
  const is_static = !ipns && !button;
  const our_style_el = $76EG6$getNextElement($df6d080cba513381$var$_tmpl$);
  const container_class = $6cb4d83127e468ea$export$a6db784f019668ba();
  const selector_beginning = ".depict .".concat(container_class, ">");
  const el_count_ipns = $7ca6fdc721083788$export$e806c6c1615a59ae();
  const set_length = () => el_count_ipns(container_element.children.length);
  const col_styling = $df6d080cba513381$export$17c3166a7ebd4688(selector_beginning, grid_spacing, cols_at_size, layout, override_vertical_spacing);
  let button_class;
  ipns || (ipns = $7ca6fdc721083788$export$e806c6c1615a59ae());
  container_element.after(our_style_el);
  container_element.classList.add(container_class);
  if (rows === "all") {
    // no view more functionality requested
    our_style_el.append(col_styling);
    return;
  }
  ipns(start_rows);
  set_length();
  const mutation_observer = new MutationObserver($5e1f45affc1d7def$export$b3bbfd758f11cfa9(set_length));
  (0, $90fa633a9564f115$export$b6ae1bc530f4c149).oncreation(container_element, _ref2 => {
    let {
      element: element
    } = _ref2;
    mutation_observer.observe(element, {
      childList: true
    });
    set_length(); // might have changed while we weren't in the DOM but no need to observe and update when we aren't
  });

  (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onremoved(container_element, _ref3 => {
    let {
      element: element
    } = _ref3;
    if (document.documentElement.contains(element)) return;
    mutation_observer.disconnect();
    el_count_ipns.exit();
    ipns.exit();
  });
  if (button) {
    button_class = $6cb4d83127e468ea$export$a6db784f019668ba();
    const button_container = (() => {
      var _el$2 = $76EG6$getNextElement($df6d080cba513381$var$_tmpl$2);
      $76EG6$className(_el$2, "load-more-container " + button_class);
      $76EG6$insert(_el$2, () => $a285401a927e4306$export$f63fcc839cb0f734("click", () => {
        var _rows_or_empty_object;
        return ipns(ipns.state + ((_rows_or_empty_object = rows_or_empty_object.rows_per_click) !== null && _rows_or_empty_object !== void 0 ? _rows_or_empty_object : 1));
      }, button));
      return _el$2;
    })();
    container_element.after(button_container);
  }
  (0, $90fa633a9564f115$export$b6ae1bc530f4c149).oncreation(container_element, async () => {
    for await (const [currently_showing_rows, number_of_els] of $07beada135e5f5e8$export$f8913c8a18f7ca21([
    // start for await loop when the container element gets inserted into the DOM
    // the loop is broken by an observer.onremoved above calling .exit on the IPNS this depends on
    // @ts-ignore
    ipns,
    // @ts-ignore too complicated to fix this IMO
    el_count_ipns])) {
      our_style_el.innerText = col_styling + cols_at_size.map(options => {
        const [, min, max] = options;
        let should_hide_button;
        let visible_recs;
        if (disable_partial_rows) {
          visible_recs = $df6d080cba513381$export$483bdd1f1186de13(currently_showing_rows, number_of_els, options);
          const visible_recs_next_show_more = $df6d080cba513381$export$483bdd1f1186de13(currently_showing_rows + (rows_or_empty_object.rows_per_click || 0), number_of_els, options);
          should_hide_button = visible_recs === visible_recs_next_show_more;
        } else {
          visible_recs = $df6d080cba513381$export$3dc5e2383c924ebf(currently_showing_rows, options);
          should_hide_button = visible_recs >= number_of_els;
        }
        const should_hide_button_final = button_class && (should_hide_button || max_rows !== -1 && currently_showing_rows >= max_rows);
        return "".concat($df6d080cba513381$export$717f13d9ba00ca19(min, max), "{").concat(selector_beginning, ":nth-child(n+").concat(visible_recs + 1, "){display:none}").concat(layout == "slider" ? "".concat(selector_beginning, ":nth-child(n+").concat(visible_recs, "){margin-right:0}") : "").concat(should_hide_button_final ? ".depict .".concat(button_class, "{display:none!important}") : "", "}");
      }).join("");
      if (is_static) break;
    }
  });
}
function $df6d080cba513381$export$3dc5e2383c924ebf(row, options) {
  const [default_cols,,,, override_obj] = options;
  const overrides = (override_obj === null || override_obj === void 0 ? void 0 : override_obj.overrides) || {};
  let total = 0;
  for (let current_r = 1; current_r <= row; current_r++) {
    const cols = overrides[current_r] || default_cols;
    total += cols;
  }
  return total;
}
function $df6d080cba513381$export$483bdd1f1186de13(rows, max_recs, options) {
  let visible_recs;
  while ((visible_recs = $df6d080cba513381$export$3dc5e2383c924ebf(rows--, options)) > max_recs);
  return visible_recs;
}
function $df6d080cba513381$export$17c3166a7ebd4688(selector_beginning, default_grid_spacing_text, cols_at_size, layout, override_vertical_spacing, only_generate_top_margins) {
  function get_width_of_middle_elements(n_cols, spacing) {
    return "width:".concat($df6d080cba513381$var$css_subtract($df6d080cba513381$var$css_divide(new $df6d080cba513381$var$CSSMeasurement("100%"), n_cols), $df6d080cba513381$var$css_divide($df6d080cba513381$var$css_multiply(n_cols * 2 - 2, spacing), n_cols)));
  }
  function get_width_css(n_cols, selector, spacing) {
    const width_css = get_width_of_middle_elements(n_cols, spacing);
    const margin_css = "margin-left:".concat(spacing, ";margin-right:").concat(spacing);
    return "".concat(selector, "{").concat(margin_css, ";").concat(width_css, "}");
  }
  function get_horizontal_spacing_css(start, end, selector, spacing) {
    const left_removed_css = "".concat(selector, ":nth-child(").concat(start, "){margin-left:0}");
    const right_removed_css = "".concat(selector, ":nth-child(").concat(end, "){margin-right:0}");
    return left_removed_css + right_removed_css;
  }
  function get_vertical_spacing_css(selector, spacing, options) {
    const shorten_top_row_by = only_generate_top_margins !== null && only_generate_top_margins !== void 0 ? only_generate_top_margins : 0;
    const top_row_selector = "".concat(selector, ":nth-child(n+1):nth-child(-n+").concat($df6d080cba513381$export$3dc5e2383c924ebf(1, options) - shorten_top_row_by, ")");
    const between_spacing_css = "".concat(selector, ":not(").concat(top_row_selector, "){margin-top:").concat(override_vertical_spacing !== null && override_vertical_spacing !== void 0 ? override_vertical_spacing : $df6d080cba513381$var$css_multiply(spacing, 2), "}");
    return between_spacing_css;
  }
  function get_left_right_0_spacing_rest_of_rows_css(n_cols, start, selector_beginning) {
    const right = "".concat(selector_beginning, ":nth-child(").concat(n_cols, "n+").concat(start, "){margin-left:0}");
    const left = "".concat(selector_beginning, ":nth-child(").concat(n_cols, "n+").concat(start + n_cols - 1, "){margin-right:0}");
    return right + left;
  }
  const half_default_spacing = $df6d080cba513381$var$css_divide(new $df6d080cba513381$var$CSSMeasurement(default_grid_spacing_text), 2);
  return cols_at_size.map(options => {
    const [n_cols, min, max, grid_spacing_for_size, override] = options;
    const half_spacing = grid_spacing_for_size ? $df6d080cba513381$var$css_divide(new $df6d080cba513381$var$CSSMeasurement(grid_spacing_for_size), 2) : half_default_spacing;
    let media_query_body = "";
    if (layout == "grid") {
      const overrides = (override === null || override === void 0 ? void 0 : override.overrides) || {};
      const sorted = Object.keys(overrides).sort((r1, r2) => parseInt(r1) - parseInt(r2));
      const last_override_row = sorted.at(-1);
      /** We run this loop up until the last override rule + 1.
      * The last iteration will create styling rules that apply to every row that comes after it.
      * Let's say we have one override rule for row 2.
      * We:
      *  1. Create styling for row 1
      *  2. Create styling for row 2
      *  3. Create styling for row 3 which will apply to the rest of the rows. Every row will be the same from now on.
      */
      const max_row = last_override_row ? parseInt(last_override_row) + 1 : 1;
      for (let row = 1; row <= max_row; row++) {
        const real_n_cols = overrides[row] || n_cols;
        const amount_until_now = $df6d080cba513381$export$3dc5e2383c924ebf(row - 1, options);
        const amount_next_row = $df6d080cba513381$export$3dc5e2383c924ebf(row, options);
        const start = amount_until_now + 1;
        const end = amount_next_row;
        const is_last_iteration = row === max_row;
        let row_selector = selector_beginning;
        if (is_last_iteration) row_selector += ":nth-child(n+".concat(start, ")");else row_selector += ":nth-child(n+".concat(start, "):nth-child(-n+").concat(end, ")");
        if (only_generate_top_margins == undefined) {
          media_query_body += get_width_css(real_n_cols, row_selector, half_spacing);
          media_query_body += get_horizontal_spacing_css(start, end, row_selector, half_spacing);
        }
        media_query_body += get_vertical_spacing_css(row_selector, half_spacing, options);
        if (is_last_iteration && only_generate_top_margins == undefined) media_query_body += get_left_right_0_spacing_rest_of_rows_css(n_cols, start, selector_beginning);
      }
    } else if (layout == "slider") {
      const margin_and_width_of_middle_elements = get_width_css(n_cols, "".concat(selector_beginning, "*"), half_spacing);
      media_query_body += margin_and_width_of_middle_elements;
      const start_and_end_no_margin = "".concat(selector_beginning, ":first-child{margin-left:0}").concat(selector_beginning, ":last-child{margin-right:0}");
      media_query_body += start_and_end_no_margin;
    } else throw new Error("invalid layout");
    const retval = "".concat($df6d080cba513381$export$717f13d9ba00ca19(min, max), "{").concat(media_query_body, "}");
    return retval;
  }).join("");
}
function $df6d080cba513381$var$css_subtract(a, b) {
  if (a.is_fe || b.is_fe || a.u !== b.u) return new $df6d080cba513381$var$CSSMeasurement("calc(".concat(a, " - ").concat(b, ")"));else
    // @ts-ignore
    return new $df6d080cba513381$var$CSSMeasurement(a - b + a.u);
}
function $df6d080cba513381$var$css_add(a, b) {
  if (a.is_fe || b.is_fe || a.u !== b.u) return new $df6d080cba513381$var$CSSMeasurement("calc(".concat(a, " + ").concat(b, ")"));else
    // @ts-ignore
    return new $df6d080cba513381$var$CSSMeasurement(+a + +b + a.u);
}
function $df6d080cba513381$var$css_multiply(a, b) {
  const a_is_num = typeof a === "number";
  const b_is_num = typeof b === "number";
  if (a_is_num && b_is_num) throw new Error("At least one value needs a unit");
  // @ts-ignore
  if (a.is_fe || b !== null && b !== void 0 && b.is_fe || !b_is_num && !a_is_num && a.u !== b.u) return new $df6d080cba513381$var$CSSMeasurement("calc(".concat(a, " * ").concat(b, ")"));else
    // @ts-ignore
    return new $df6d080cba513381$var$CSSMeasurement(a * b + (a.u || b.u));
}
function $df6d080cba513381$var$css_divide(a, b) {
  // @ts-ignore
  if (a.is_fe || b !== null && b !== void 0 && b.is_fe || typeof b !== "number" && a.u !== b.u) return new $df6d080cba513381$var$CSSMeasurement("calc(".concat(a, " / ").concat(b, ")"));else
    // @ts-ignore
    return new $df6d080cba513381$var$CSSMeasurement(a / b + a.u);
}
$df6d080cba513381$var$_Symbol$iterator = Symbol.iterator;
$df6d080cba513381$var$_Symbol$toPrimitive = Symbol.toPrimitive;
class $df6d080cba513381$var$CSSMeasurement {
  valueOf() {
    if (this.is_fe) throw new Error("Cannot convert function expression: " + this.e + " to number");else return this.v;
  }
  toString() {
    if (this.is_fe) return this.e;else return this.v + this.u;
  }
  [$df6d080cba513381$var$_Symbol$toPrimitive](hint) {
    return hint == "number" ? this.valueOf() : this.toString();
  }
  constructor(measurement) {
    $76EG6$babelruntimehelpersdefineProperty(this, $df6d080cba513381$var$_Symbol$iterator, function* () {
      if (this.is_fe) throw new Error("Function expression isn't iterable: " + this.e);
      yield this.v;
      yield this.u;
    });
    if (measurement.includes("(") && measurement.includes(")")) {
      this.is_fe = true;
      this.e = measurement;
      return;
    }
    const number = parseFloat(measurement);
    const unit = measurement.replace("" + number, "");
    if (!unit) throw new Error("CSSValue needs a unit: " + measurement);
    this.v = number;
    this.u = unit;
  }
}
function $b109421811582f8c$export$8cbd8aa1c70f9a13() {
  let interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
  let timer;
  let direction = 1;
  function interval_scroll() {
    timer = setInterval(() => {
      this.scroll_to_rel(this.stepstoslide * direction);
    }, interval);
  }
  function mutation_plugin(_intersections, intersecting_mutations) {
    clearInterval(timer);
    const visible_els = Object.keys(intersecting_mutations).map(v => +v);
    if (visible_els.includes(this.index_of_last_element)) direction = -1;else if (visible_els.includes(0)) direction = 1;
    interval_scroll.call(this);
  }
  return {
    constructor_plugin() {
      const set_scroll_int = interval_scroll.bind(this);
      this.container.addEventListener("click", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
        clearInterval(timer);
        set_scroll_int();
      }));
      this.container.addEventListener("mousedown", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
        clearInterval(timer);
      }));
      set_scroll_int();
    },
    mutation_plugin: mutation_plugin
  };
}
function $090af64928922937$export$80039a49055269fb() {
  const new_arrowimage = () => {
    const img = new Image();
    img.src = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgIDxsaW5lIHgxPSI0IiB5MT0iMTIiIHgyPSIyMCIgeTI9IjEyIi8+CiAgICA8cG9seWxpbmUgcG9pbnRzPSIxNCA2IDIwIDEyIDE0IDE4Ii8+Cjwvc3ZnPg==";
    return img;
  };
  return Object.fromEntries(["left", "right"].map(side => [side, [new_arrowimage()]]));
}
var $66c5b496f7887c00$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<img src=data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHN0eWxlPSJkaXNwbGF5OiBpbmxpbmUtYmxvY2s7IHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7IiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgOCAxNSI+PHBhdGggc3R5bGU9ImZpbGw6IHJnYigwLCAwLCAwKTsiIGQ9Ik0uNjI5LjAwMWMuMTUuMDA4LjI5My4wNzIuMzk4LjE4bDYuNzkyIDYuODlhLjYwMS42MDEgMCAwIDEgMCAuODZsLTYuNzkyIDYuODg4YS41ODYuNTg2IDAgMCAxLS44NDYgMCAuNjAxLjYwMSAwIDAgMSAwLS44Nkw2LjU1NCA3LjUuMjExIDEuMDAxYS42MDEuNjAxIDAgMCAxIDAtLjg2Yy4xMTUtLjEuMjY2LS4xNS40MTgtLjE0Ij48L3BhdGg+PC9zdmc+>`);
function $66c5b496f7887c00$export$af88b4929c2dc86() {
  const img = $76EG6$getNextElement($66c5b496f7887c00$var$_tmpl$);
  return {
    left: [img],
    right: [img.cloneNode()]
  };
}
var $d3c54fdf1bfb087a$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<label class=checkbox_container><input type=radio><span class=checkmark>`);
function $d3c54fdf1bfb087a$export$1d17a045bcc711b1(_ref) {
  let {
    navcont_insertion_fn: navcont_insertion_fn,
    navdot: navdot,
    dontshowonedot = false,
    bitesize: bitesize
  } = _ref;
  const button_states = [];
  const unique_name = Math.round(Math.random() * 1000000);
  function constructor_plugin() {
    // this = slider instance
    const navcont = document.createElement("div");
    navcont.classList.add("navigation_dots");
    this.navcont = navcont;
    if (navcont_insertion_fn) navcont_insertion_fn(this, navcont);else {
      const {
        container: container
      } = this;
      container.append(navcont);
    }
  }
  let amount_of_visible_elements = 4; // 4 is just a number to initialize it. Needs to be here so that the event listener gets an updated amount when the window is resized
  function mutation_plugin(intersections, intersecting_mutations) {
    var _first_child$getBound;
    const only_visible_children = children => [...children].filter(el => el.offsetParent !== null);
    const {
      insert_here: sliding,
      navcont: navcont
    } = this;
    const {
      children: children,
      offsetWidth: width_of_container
    } = sliding;
    const first_child = children[0];
    const amount_of_elements = only_visible_children(children).length;
    const width_of_one_element = (_first_child$getBound = first_child === null || first_child === void 0 ? void 0 : first_child.getBoundingClientRect().width) !== null && _first_child$getBound !== void 0 ? _first_child$getBound : 0;
    const actual_amount_of_visible_elements = width_of_container / width_of_one_element;
    amount_of_visible_elements = bitesize || actual_amount_of_visible_elements; // also bitesize
    const number_of_slides = Math.round(amount_of_elements / amount_of_visible_elements); /* - actual_amount_of_visible_elements + 1*/
    const number_of_radio_buttons = only_visible_children(this.navcont.children).length;
    const first_shown_element = +Object.keys(Object.fromEntries(Object.entries(intersecting_mutations).filter(_ref2 => {
      let [_, v] = _ref2;
      return v.intersectionRatio > 0.1;
    })))[0];
    const position = Math.round(first_shown_element / amount_of_elements * number_of_slides);
    const get_inputs = () => navcont.querySelectorAll("input");
    if (number_of_radio_buttons != number_of_slides) {
      $241f2f02cc612a49$export$de56f1198d121036("Number of buttons doesn't match number of slides, rerendering buttons", button_states);
      navcont.innerHTML = "";
      if (number_of_slides === 1 && dontshowonedot) {
        $241f2f02cc612a49$export$de56f1198d121036("dontshowonedot is on, not rendering any dots");
        return;
      }
      if (number_of_slides == Infinity) {
        $241f2f02cc612a49$export$de56f1198d121036("Infinite number of slides, wtf", number_of_slides);
        return;
      }
      for (let i = 0; i < number_of_slides; i++) {
        const a_navdot = navdot(unique_name, i);
        const input = a_navdot.querySelector("input");
        if (process.env.DEBUG === "true" && !input) throw new Error("You need to provide a navdot that contains an <input> element to slider_dots");
        input.checked = button_states[i];
        input.addEventListener("click", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(e => {
          e.preventDefault();
          e.stopPropagation();
          $241f2f02cc612a49$export$de56f1198d121036("Someone checked a box", e);
          this.scroll_to_abs(Math.round(amount_of_visible_elements * i));
          return false;
        }));
        navcont.append(a_navdot);
      }
    }
    const inputs = get_inputs();
    for (let i = 0; i < number_of_slides; i++) set_input(inputs[i], i, position == i);
  }
  function set_input(input, index, value) {
    if (button_states[index] !== value) {
      input.checked = value;
      button_states[index] = value;
    }
  }
  return {
    constructor_plugin: constructor_plugin,
    mutation_plugin: mutation_plugin
  };
}
function $d3c54fdf1bfb087a$export$a09282b33e69b43f(unique_name) {
  return (() => {
    var _el$ = $76EG6$getNextElement($d3c54fdf1bfb087a$var$_tmpl$),
      _el$2 = _el$.firstChild;
    $76EG6$setAttribute(_el$2, "name", "radio-".concat(unique_name));
    return _el$;
  })();
}

// // You need to do this on all elements you insert into the slider before you insert them:
//
// querySelectorAllElements(rendered_slider, ".rec_outer, img, canvas").forEach(el => {
//   el.draggable = false;
//   el.addEventListener("dragstart", e => {
//     e.preventDefault();
//     return false; // https://stackoverflow.com/questions/26356877/html5-draggable-false-not-working-in-firefox-browser
//   });
// });

function $3ad897e1659ee6d7$export$411b0f20794697ce() {
  function constructor_plugin(slider_options) {
    const {
      insert_here: sliding
    } = this;
    let last_mouse_position = 0;
    let starting_position = 0;
    let block_anchor_clicks = false;
    sliding.addEventListener("mousedown", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(e => {
      sliding.classList.remove("slider_snap");
      const {
        snap_style: snap_style
      } = this;
      if (snap_style) snap_style.remove();
      sliding.classList.add("grabbing");
      last_mouse_position = starting_position = e.clientX;
      sliding.addEventListener("mousemove", scroll_on_mousemove);
    }));
    window.addEventListener("mouseup", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(e => {
      // use window to prevent dragging from getting stuck
      sliding.classList.remove("grabbing");
      sliding.classList.add("slider_snap");
      sliding.removeEventListener("mousemove", scroll_on_mousemove);
      // readd snap css if needed
      const {
        snap_style: snap_style
      } = this;
      if (snap_style) {
        this.container.append(snap_style);
        // make a scroll so the browser snaps
        // it doesn't snap smoothly. Fuck.
        sliding.scrollBy({
          left: 0,
          top: 0,
          behavior: "smooth"
        });
      }
    }));
    sliding.addEventListener("click", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(e => {
      if (block_anchor_clicks) {
        $241f2f02cc612a49$export$de56f1198d121036("Block anchor clicks is true, blocking click", e);
        block_anchor_clicks = false;
        e.preventDefault();
        return false;
      }
    }));
    function scroll_on_mousemove(e) {
      try {
        const {
          clientX: clientX
        } = e;
        if (Math.abs(clientX - starting_position) > 10) block_anchor_clicks = true;
        sliding.scrollBy({
          left: last_mouse_position - clientX
        });
        last_mouse_position = clientX;
      } catch (e) {
        $b000f5ef6ce456d9$export$8048b892d651b310(e);
      }
    }
  }
  function mutation_plugin(intersections, intersecting_mutations) {}
  function instant_post_pro(items) {
    $652300c6621d5500$export$5e63aea0cac01fa0(items, "a, img, canvas").forEach(el => {
      // @ts-ignore
      el.draggable = false;
      el.addEventListener("dragstart", e => {
        e.preventDefault();
        return false; // https://stackoverflow.com/questions/26356877/html5-draggable-false-not-working-in-firefox-browser
      });
    });
  }

  return {
    constructor_plugin: constructor_plugin,
    mutation_plugin: mutation_plugin,
    post_pro_plugin: {
      instant: instant_post_pro
    }
  };
}
function $21afac8db3f98820$export$5129719c04a52f8c() {
  let {
    fade_in_duration_ = 0,
    fade_out_duration_ = 0,
    visible_opacity_ = 1,
    faded_opacity_ = 0.5,
    easing_ = "linear",
    threshold_ = 0.5
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const faded_els = /*@__PURE__*/new WeakSet();
  function mutation_plugin_(entries, _intersecting_mutations) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const {
        target: target
      } = entry;
      const should_be_faded = entry.intersectionRatio <= threshold_;
      if (should_be_faded !== faded_els.has(target)) {
        faded_els[should_be_faded ? "add" : "delete"](target);
        // try to fix https://sentry.io/organizations/depictai-0o/issues/3391798259/?project=5476183&query=is%3Aunresolved+animate&statsPeriod=14d
        target.animate({
          opacity: [should_be_faded ? visible_opacity_ : faded_opacity_, should_be_faded ? faded_opacity_ : visible_opacity_]
        }, {
          fill: "forwards",
          duration: should_be_faded ? fade_out_duration_ : fade_in_duration_,
          easing: easing_
        });
      }
    }
  }
  function constructor_plugin(_slider_options) {
    // Fade in removed elements as they may be added somewhere else in the DOM
    this.on_elements_changed.push(records => {
      for (const {
        removedNodes: removedNodes
      } of records) {
        for (const node of removedNodes) if (faded_els.has(node)) {
          faded_els.delete(node);
          node.animate({
            opacity: [faded_opacity_, visible_opacity_]
          }, {
            fill: "forwards",
            duration: fade_in_duration_,
            easing: easing_
          });
        }
      }
    });
  }
  return {
    mutation_plugin_: mutation_plugin_,
    constructor_plugin: constructor_plugin
  };
}
function $0cbf24ae3e670238$export$5723caf9a8335aa6(_t) {
  let fraction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  let max_steps = arguments.length > 2 ? arguments[2] : undefined;
  let dont_enable_correct_bs_targets = arguments.length > 3 ? arguments[3] : undefined;
  let min_steps = arguments.length > 4 ? arguments[4] : undefined;
  function constructor_plugin(slider_options) {
    const fallback_stepsize = slider_options.stepstoslide || 2;
    const {
      insert_here: sliding
    } = this;
    if (!dont_enable_correct_bs_targets) this.correct_bs_targets = true;
    Object.defineProperty(this, "stepstoslide", {
      configurable: true,
      enumerable: true,
      set(v) {
        $b000f5ef6ce456d9$export$8048b892d651b310(new Error("Cannot set steps to slide manually when using fractional scroll"));
        return v;
      },
      get: $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
        const sliding_width = sliding.getBoundingClientRect().width;
        const first_rec = sliding.firstElementChild;
        if (!first_rec)
          // maybe slider has no elements
          return fallback_stepsize;
        const width_of_first = first_rec.getBoundingClientRect().width;
        const calculated_stepsize = Math.round(Math.floor(sliding_width / width_of_first) * fraction);
        // dlog("calculated stepsize is", calculated_stepsize);
        const stepsize_limited_up = max_steps && calculated_stepsize > max_steps ? max_steps : calculated_stepsize;
        const stepsize_limited_up_and_down = min_steps && stepsize_limited_up < min_steps ? min_steps : stepsize_limited_up;
        const stepby = stepsize_limited_up_and_down || fallback_stepsize;
        if (stepby != calculated_stepsize) $241f2f02cc612a49$export$de56f1198d121036("going by", stepby, "because of max_steps or invalid stepsize");
        return stepby;
      })
    });
  }
  function mutation_plugin(intersections, intersecting_mutations) {}
  return {
    constructor_plugin: constructor_plugin,
    mutation_plugin: mutation_plugin
  };
}
var $4837ebe61ecec421$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div class=depict_slider_scroll_bar>`),
  $4837ebe61ecec421$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<div class=depict_slider_scroll_container>`);
function $4837ebe61ecec421$export$93223e488e7ee078(options) {
  function constructor_plugin(_slider_options) {
    var _options$scroll_bar_c, _options$scroll_conta;
    const scroll_bar = $76EG6$getNextElement($4837ebe61ecec421$var$_tmpl$);
    const scroll_container = $76EG6$getNextElement($4837ebe61ecec421$var$_tmpl$2);
    if ((_options$scroll_bar_c = options.scroll_bar_classes) !== null && _options$scroll_bar_c !== void 0 && _options$scroll_bar_c.length) scroll_bar.classList.add(...options.scroll_bar_classes);
    if ((_options$scroll_conta = options.scroll_container_classes) !== null && _options$scroll_conta !== void 0 && _options$scroll_conta.length) scroll_container.classList.add(...options.scroll_container_classes);
    // Default styles always present
    scroll_container.style.overflowX = "hidden";
    scroll_bar.style.left = "0";
    if (options.add_position_styling) {
      scroll_bar.style.position = "absolute";
      scroll_container.style.position = "relative";
    }
    scroll_container.append(scroll_bar);
    this.container.append(scroll_container);
    this.scroll_bar = scroll_bar;
  }
  function mutation_plugin(_intersections, _intersecting_mutations) {
    const {
      insert_here: slider
    } = this;
    const scrolled = slider.scrollLeft / slider.scrollWidth * 100;
    this.scroll_bar.style.width = "".concat(Math.round(slider.offsetWidth / slider.scrollWidth * 100), "%");
    this.scroll_bar.style.left = "".concat(scrolled, "%");
  }
  return {
    constructor_plugin: constructor_plugin,
    mutation_plugin: mutation_plugin
  };
}
var $ff905d87817a07f4$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div style="position:absolute;width:1em;overflow:scroll;scroll-snap-type:x mandatory;"><div style=scroll-snap-align:start;color:transparent;>test`);
function $ff905d87817a07f4$export$b36d2489a5a16728(_t) {
  let {
    snapEvery: snapEvery,
    align: align
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  function constructor_plugin(_slider_options) {
    const slider_this = this;
    const random_classname = "x" + $6cb4d83127e468ea$export$656831b7e9c341c3().replaceAll(".", "");
    slider_this.insert_here.classList.add(random_classname);
    const style = document.createElement("style");
    style.append(".depict .".concat(random_classname, "{scroll-snap-type:x mandatory}.depict .").concat(random_classname, ">*:nth-child(").concat(snapEvery !== null && snapEvery !== void 0 ? snapEvery : 1, "n + 1){scroll-snap-align:").concat(align || "start", "}"));
    slider_this.snap_style = slider_this.container.appendChild(style);
    $ff905d87817a07f4$export$49b950309ab787ad().then(we_can => {
      if (!we_can) {
        $241f2f02cc612a49$export$de56f1198d121036("Disabling slider snapping due browser where it's impossible to have working buttons and css snapping");
        style.remove();
        delete slider_this["snap_style"];
      }
    }).catch((0, $b000f5ef6ce456d9$export$8048b892d651b310));
  }
  function mutation_plugin(_intersections, intersecting_mutations) {
    // const visible_elems Object.keys(intersecting_mutations).length
  }
  return {
    constructor_plugin: constructor_plugin,
    mutation_plugin: mutation_plugin
  };
}
async function $ff905d87817a07f4$export$49b950309ab787ad() {
  if ("scrollBehavior" in document.documentElement.style) return true;
  const test_div = $76EG6$getNextElement($ff905d87817a07f4$var$_tmpl$);
  const body = await (0, $90fa633a9564f115$export$b6ae1bc530f4c149).wait_for_element("body");
  body.append(test_div);
  test_div.scrollLeft = 1;
  const can_be_scrolled = test_div.scrollLeft === 1;
  test_div.remove();
  return can_be_scrolled;
}
function $e1af55c2112926b7$export$dac64fd35a4805a4() {
  var _options$threshold;
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const threshold = (_options$threshold = options.threshold) !== null && _options$threshold !== void 0 ? _options$threshold : 0.8;
  const ratio_left = {
    ratio: 0,
    element: document.createElement("div") // createElement is just for typescript
  };

  const ratio_right = {
    ratio: 0,
    element: document.createElement("div") // createElement is just for typescript
  };

  const lock_on_element = {
    left: ratio_left.element,
    right: ratio_right.element,
    lock_active: false
  };
  let currently_left = "0";
  function constructor_plugin(slider_options) {
    const {
      insert_here: sliding
    } = this;
    const scroll_abs_no_negative = target => this.scroll_to_abs(target < 0 ? 0 : target); // the slider ignores everything < 0 but we want it to move to the first card
    sliding.addEventListener("mousedown", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
      lock_on_element.lock_active = true;
      const starting_ratio_left = ratio_left.ratio;
      lock_on_element.left = ratio_left.element;
      const starting_ratio_right = ratio_right.ratio;
      lock_on_element.right = ratio_right.element;
      const scroll_left_start = sliding.scrollLeft;
      const mouseup_listener = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(e => {
        lock_on_element.lock_active = false;
        const delta_left = Math.abs(ratio_left.ratio - starting_ratio_left);
        const delta_right = Math.abs(ratio_right.ratio - starting_ratio_right);
        // dlog({ delta_left, delta_right }, "elements", ratio_left.element, ratio_right.element);
        window.removeEventListener("mouseup", mouseup_listener);
        const scrolled_right = sliding.scrollLeft - scroll_left_start > 0;
        if (delta_left > threshold || delta_right > threshold || lock_on_element.left != ratio_left.element || lock_on_element.right != ratio_right.element) {
          let currently_visible;
          try {
            currently_visible = Math.floor(this.insert_here.getBoundingClientRect().width / this.insert_here.firstElementChild.getBoundingClientRect().width);
          } catch (e) {
            $5e1f45affc1d7def$export$f18d5b0af29128b7(e, "warning");
          }
          const stepsize = options.stepsize || currently_visible || 4;
          if (scrolled_right) scroll_abs_no_negative(+currently_left + stepsize);else scroll_abs_no_negative(+currently_left - stepsize);
        } else {
          const max_left = sliding.scrollLeft < 1;
          const max_right = sliding.scrollLeft >= (sliding.scrollLeftMax || sliding.scrollWidth - sliding.clientWidth);
          if (!(max_right || max_left))
            // can't attempt to snap to current position when it's not possible because of an edge card being a half card
            // brought back from the dead from https://gitlab.com/depict-ai/depict.ai/-/blob/f67c67591ab4b3d791a91909dab8fc315c87e64f/browser-tags-v2/src/mq/vasily_rec_bar.ts#L353
            scroll_abs_no_negative(+currently_left);
        }
      });
      window.addEventListener("mouseup", mouseup_listener);
    }));
  }
  function find_intersection_ratio(records, target) {
    var _records$target_index;
    const target_index = records.map(record => record.target).indexOf(target);
    return ((_records$target_index = records[target_index]) === null || _records$target_index === void 0 ? void 0 : _records$target_index.intersectionRatio) || 2; // element is probably no longer visible, return huge ratio
  }

  function mutation_plugin(intersections, intersecting_mutations) {
    const keys = Object.keys(intersecting_mutations);
    if (lock_on_element.lock_active) {
      const records = Object.values(intersecting_mutations);
      ratio_left.ratio = find_intersection_ratio(records, lock_on_element.left);
      ratio_right.ratio = find_intersection_ratio(records, lock_on_element.right);
    } else {
      const [index_of_first_intersection] = keys;
      currently_left = index_of_first_intersection;
      const [index_of_last_intersection] = keys.slice(-1);
      const first_intersection = intersecting_mutations[index_of_first_intersection];
      const last_intersection = intersecting_mutations[index_of_last_intersection];
      if (first_intersection) {
        ratio_left.ratio = first_intersection.intersectionRatio;
        ratio_left.element = first_intersection.target;
      }
      if (last_intersection) {
        ratio_right.ratio = last_intersection.intersectionRatio;
        ratio_right.element = last_intersection.target;
      }
    }
  }
  return {
    constructor_plugin: $5e1f45affc1d7def$export$b3bbfd758f11cfa9(constructor_plugin),
    mutation_plugin: $5e1f45affc1d7def$export$b3bbfd758f11cfa9(mutation_plugin)
  };
}
var $ad1dbddac6af350d$var$_globalThis$window;
const $ad1dbddac6af350d$export$20e9533e68ee72e7 = /*@__PURE__*/$7ca6fdc721083788$export$e806c6c1615a59ae(false);
const $ad1dbddac6af350d$export$a9d39e43ae273d26 = /*@__PURE__*/$7ca6fdc721083788$export$e806c6c1615a59ae();
const $ad1dbddac6af350d$export$7500cdfd37aafd43 = /*@__PURE__*/new Set();
let $ad1dbddac6af350d$var$old_url;
const $ad1dbddac6af350d$var$maybe_navigation = (what_happened, args) => {
  if (typeof location === "undefined") return;
  const new_url = location.href;
  if ($ad1dbddac6af350d$var$old_url !== new_url) {
    $ad1dbddac6af350d$export$a9d39e43ae273d26(new_url);
    if ($ad1dbddac6af350d$var$old_url !== undefined)
      // don't resolve stateless href change ipns with the initial value - it's not a navigation
      $ad1dbddac6af350d$export$20e9533e68ee72e7(new_url);
    $ad1dbddac6af350d$var$old_url = new_url;
  }
  for (const fn of $ad1dbddac6af350d$export$7500cdfd37aafd43) fn(what_happened, args);
};
$ad1dbddac6af350d$export$baccefee4a395d8f((args, what_happened) => $ad1dbddac6af350d$var$maybe_navigation(what_happened, args));
$ad1dbddac6af350d$var$maybe_navigation();
globalThis === null || globalThis === void 0 || ($ad1dbddac6af350d$var$_globalThis$window = globalThis.window) === null || $ad1dbddac6af350d$var$_globalThis$window === void 0 || $ad1dbddac6af350d$var$_globalThis$window.addEventListener("popstate", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(e => $ad1dbddac6af350d$var$maybe_navigation("popstate", e)));
async function $ad1dbddac6af350d$export$1cd22bab0d2c3b0b(callback) {
  const catchified_callback = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(callback);
  for await (const href of $ad1dbddac6af350d$export$20e9533e68ee72e7) {
    catchified_callback(href);
    break;
  }
}
async function $ad1dbddac6af350d$export$baccefee4a395d8f(after_navigation) {
  let replace_replaceState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (typeof History === "undefined") return;
  const {
    prototype: prototype
  } = History;
  const instance = history;
  const polyfill_dance = the_thing => {
    const proxy_the_thing = obj => {
      const orig_pushState = obj[the_thing];
      obj[the_thing] = new Proxy(orig_pushState, {
        apply: (target, this_arg, arguments_list) => {
          const nav_result = Reflect.apply(target, this_arg, arguments_list);
          try {
            after_navigation(arguments_list, the_thing);
          } catch (e) {
            $b000f5ef6ce456d9$export$8048b892d651b310(e);
          }
          return nav_result;
        }
      });
    };
    proxy_the_thing(prototype);
    if (Object.getOwnPropertyNames(instance).includes(the_thing))
      // we don't want to just change the instance because that's not the way to do it, but we don't want to not work because someone else did it wrong
      proxy_the_thing(instance);
  };
  polyfill_dance("pushState");
  if (replace_replaceState) polyfill_dance("replaceState");
}
const $2b6304d4ce419ed5$var$connection_map = /*@__PURE__*/new WeakMap();
function $2b6304d4ce419ed5$export$3d04c40e7acc1a32(initial_value) {
  let subscribed = false;
  const subscriber_array_fns = new Set();
  const template_text_node = document.createTextNode("");
  const current_els = [template_text_node];
  let state;
  const get_state = () => {
    if (subscribed) return subscribed.get_state_();else return state;
  };
  const update_state = new_value => {
    if (subscribed) {
      // break subscription  - we're supposed to get a new value
      subscribed.unsubscribe_();
      subscribed = false;
    }
    const input_as_array = typeof new_value === "object" && typeof (new_value === null || new_value === void 0 ? void 0 : new_value[Symbol.iterator]) === "function" ? [...new_value] : [new_value];
    if (!input_as_array.length) input_as_array.push(template_text_node.cloneNode());
    const array_with_replacewithable_nodes = [];
    for (let i = 0; i < input_as_array.length; i++) {
      const entry = input_as_array[i];
      if (!(entry instanceof Node)) array_with_replacewithable_nodes.push(document.createTextNode(entry));else if (entry instanceof DocumentFragment) array_with_replacewithable_nodes.push(...entry.childNodes);else array_with_replacewithable_nodes.push(entry);
    }
    // we need to remove the overshoot-nodes first since they might contain one of the new nodes in array_with_replacewithable_nodes, in which case we would otherwise first re-insert them and then remove them
    for (let i = 1; i < current_els.length; i++) current_els[i].remove();
    current_els[0].replaceWith(...array_with_replacewithable_nodes);
    while (current_els.length) current_els.pop();
    current_els.push(...array_with_replacewithable_nodes);
    for (const set_fn of subscriber_array_fns) set_fn(array_with_replacewithable_nodes);
    state = new_value;
    // set subscribed and then synchronize here, if should subscribe
    const connection_fn = $2b6304d4ce419ed5$var$connection_map.get(new_value /* if we get updated to the `elements` of another reactive_template it has to be an array */);
    if (connection_fn)
      // merge with reactive_template we got set to
      subscribed = connection_fn(new_state => {
        while (current_els.length) current_els.pop();
        current_els.push(...new_state);
      });
  };
  if (initial_value != null) update_state(initial_value);
  $2b6304d4ce419ed5$var$connection_map.set(current_els, set_template_array => {
    subscriber_array_fns.add(set_template_array);
    set_template_array(current_els);
    return {
      get_state_: get_state,
      unsubscribe_: () => subscriber_array_fns.delete(set_template_array)
    };
  });
  return [current_els, get_state, update_state];
}
function $26dbd7db7fd1bc2c$export$515c3ea4d599b05a(
// inspired by code in houdinisportswear modify script
query, handler) {
  var _window, _window$matchMedia;
  let initial_call = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const catchified_handler = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(handler, "Error in media query listener callback");
  if (typeof window !== "object") {
    // on server call the handler in case nothing is rendered if it isn't called, then do nothing
    catchified_handler({
      matches: false
    });
    return {
      remove() {}
    };
  }
  const media_query = (_window = window) === null || _window === void 0 ? void 0 : (_window$matchMedia = _window.matchMedia) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.call(_window, query);
  if (initial_call && media_query) catchified_handler(media_query);
  let the_function;
  if (the_function = media_query === null || media_query === void 0 ? void 0 : media_query.addEventListener) the_function.call(media_query, "change", catchified_handler);else if (the_function = media_query === null || media_query === void 0 ? void 0 : media_query.addListener) the_function.call(media_query, catchified_handler);
  return {
    remove() {
      let remove_function;
      if (remove_function = media_query === null || media_query === void 0 ? void 0 : media_query.removeEventListener) remove_function.call(media_query, "change", catchified_handler);else if (remove_function = media_query === null || media_query === void 0 ? void 0 : media_query.removeListener) remove_function.call(media_query, catchified_handler);
    }
  };
}
async function $aadc6d9eeb8e8a56$export$417ef0ab13d8b984(_ref) {
  let {
    surface_rendering_functions_: surface_rendering_functions_,
    current_surface_: current_surface_
  } = _ref;
  let resolve_success_promise;
  const success_promise = new Promise(r => resolve_success_promise = r);
  const cache = new Map();
  const [template_els, _get, set_els] = $2b6304d4ce419ed5$export$3d04c40e7acc1a32();
  const catchified_switch_to_surface = $5e1f45affc1d7def$export$b3bbfd758f11cfa9($aadc6d9eeb8e8a56$var$switch_to_surface);
  $5e1f45affc1d7def$export$b3bbfd758f11cfa9(async () => {
    for await (const surface of current_surface_) {
      const rendering_function = surface_rendering_functions_[surface];
      catchified_switch_to_surface(surface, rendering_function, current_surface_, cache, set_els, resolve_success_promise);
    }
  })();
  const fake_surface = {
    elements: template_els,
    should_stay_inserted: success_promise
  };
  return fake_surface;
}
async function $aadc6d9eeb8e8a56$var$switch_to_surface(surface_index, rendering_function, current_surface_ipns, cache, set_els, resolve_success_promise) {
  let rendered_surface = cache.get(surface_index);
  if (!rendered_surface) {
    var _surface_$elements;
    const {
      cache_until_: cache_until_,
      surface_: surface_
    } = await rendering_function().catch(e => ($5e1f45affc1d7def$export$f18d5b0af29128b7([e, "error in rendering"], "warning"), {}));
    if (!surface_ || !(surface_ !== null && surface_ !== void 0 && (_surface_$elements = surface_.elements) !== null && _surface_$elements !== void 0 && _surface_$elements.length)) {
      $241f2f02cc612a49$export$de56f1198d121036("Got no/empty surface, not switching");
      // also tell insert_surface that we didn't get recs so it can revert, dunno if we want this
      resolve_success_promise(false);
      return;
    }
    rendered_surface = surface_;
    if (cache_until_ instanceof Promise) {
      cache.set(surface_index, surface_);
      cache_until_.then($5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => cache.delete(surface_index)));
    }
  }
  if (current_surface_ipns.state !== surface_index) {
    $241f2f02cc612a49$export$de56f1198d121036("Surface switched to", current_surface_ipns.state, "while rendering surface", surface_index, "discarding results");
    return;
  }
  set_els(rendered_surface.elements);
  if (rendered_surface.should_stay_inserted instanceof Promise)
    // if there is promise that says if surface succeeded or not, use that
    rendered_surface.should_stay_inserted.then($5e1f45affc1d7def$export$b3bbfd758f11cfa9(success => {
      resolve_success_promise(success);
    }));else
    // otherwise let's just assume it suceeded since there are elements
    resolve_success_promise(true);
}
function $aadc6d9eeb8e8a56$export$419f84efad7d9fe(surface_per_size, cleanup_promise) {
  let microtask_queued = false;
  const ipns = $7ca6fdc721083788$export$e806c6c1615a59ae();
  const target_indexes = new Set();
  const dedupe_overlapping_queries = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
    microtask_queued = false;
    const first_value = target_indexes[Symbol.iterator]().next().value;
    if (first_value === ipns.latest_call_value) $241f2f02cc612a49$export$de56f1198d121036("surface", first_value, "is already selected");else ipns(first_value);
    if (target_indexes.size > 1) {
      const error_string = "Multiple matching media queries detected, used first one: " + JSON.stringify(surface_per_size.filter(_ref2 => {
        let [index] = _ref2;
        return target_indexes.has(index);
      }));
      target_indexes.clear();
      throw new Error(error_string);
    }
    target_indexes.clear();
  });
  surface_per_size.forEach(_ref3 => {
    let [surface_index, min, max] = _ref3;
    const media_query = $df6d080cba513381$export$717f13d9ba00ca19(min, max).split("@media ").pop();
    const {
      remove: remove
    } = $26dbd7db7fd1bc2c$export$515c3ea4d599b05a(media_query, _ref4 => {
      let {
        matches: matches
      } = _ref4;
      if (!matches) return;
      target_indexes.add(surface_index);
      if (!microtask_queued) {
        queueMicrotask(dedupe_overlapping_queries);
        microtask_queued = true;
      }
    });
    if (cleanup_promise instanceof Promise) cleanup_promise.then(remove);else $ad1dbddac6af350d$export$1cd22bab0d2c3b0b(remove);
  });
  return ipns;
}
function $aadc6d9eeb8e8a56$export$be95cb0e8cfd099e() {
  return new Promise(r => $ad1dbddac6af350d$export$1cd22bab0d2c3b0b(r));
}
function $bd7c9f254946941d$export$82a685f2da2fb027(a_element, product_id, recommendation_id, additional_listener) {
  var _a_element$depict_tra, _a_element$depict_tra2;
  if (!a_element ||
  // @ts-ignore
  !a_element.depict_tracked ||
  // @ts-ignore
  (a_element === null || a_element === void 0 ? void 0 : (_a_element$depict_tra = a_element.depict_tracked) === null || _a_element$depict_tra === void 0 ? void 0 : _a_element$depict_tra.recommendation_id) != recommendation_id ||
  // @ts-ignore
  (a_element === null || a_element === void 0 ? void 0 : (_a_element$depict_tra2 = a_element.depict_tracked) === null || _a_element$depict_tra2 === void 0 ? void 0 : _a_element$depict_tra2.product_id) != product_id) {
    const listener = e => {
      localStorage.setItem("depict_attribution_".concat(product_id), recommendation_id);
      if (additional_listener) additional_listener(e, product_id, recommendation_id);
    };
    // @ts-ignore
    if (a_element.depict_tracked) {
      var _a_element$depict_tra3;
      // @ts-ignore
      a_element.removeEventListener("click", (_a_element$depict_tra3 = a_element.depict_tracked) === null || _a_element$depict_tra3 === void 0 ? void 0 : _a_element$depict_tra3.listener);
    }
    // @ts-ignore
    a_element.depict_tracked = {
      product_id: product_id,
      recommendation_id: recommendation_id,
      listener: listener
    };
    a_element.addEventListener("click", listener);
    return listener;
  }
}
async function $bd7c9f254946941d$export$2c34560c3749dc63(button, get_product_id, tracking_fn, unmatching_tracking, event) {
  // @ts-ignore
  if (!button || button.depict_tracked) return;
  button.addEventListener(event ? event : "click", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(async e => {
    if (!e.isTrusted) {
      $241f2f02cc612a49$export$de56f1198d121036("ignoring event", e, "because it's not user generated");
      return;
    }
    const product_id = await get_product_id(undefined, e);
    if (product_id) {
      const item_name = "depict_attribution_".concat(product_id);
      const recommendation_id = localStorage.getItem(item_name);
      if (recommendation_id) {
        localStorage.removeItem(item_name);
        tracking_fn(product_id, recommendation_id, false, e);
      } else if (unmatching_tracking) tracking_fn(product_id, recommendation_id, true, e);
    }
  }));
  // @ts-ignore
  button.depict_tracked = true;
}
function $799496226e956169$export$edfedd0557ca5a2d(ga_tracker, append_to_url) {
  if (!ga_tracker) return;
  // Docs for analytics.js Tasks:
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/tasks
  const sendHitTask = "sendHitTask";
  const originalSendHitTask = ga_tracker.get(sendHitTask);
  ga_tracker.set(sendHitTask, model => {
    originalSendHitTask(model);
    // console.log('Sent original hit, now sending to depict');
    try {
      const payLoad = model.get("hitPayload");
      const path = (0, $9e4bee2e3b4b5753$export$362abebb4b313340) + "/collect-ga";
      let url = path + "?" + payLoad;
      if (append_to_url) url += append_to_url;
      const n = navigator;
      const sb = "sendBeacon";
      if (n[sb])
        // this is actually smaller, I tested
        n[sb](url);else {
        const xhttp = new XMLHttpRequest();
        xhttp.open("GET", url);
        xhttp.send();
      }
    } catch (e) {
      // console.log('Could not send beacon to /collect-ga', e);
    }
  });
}
function $799496226e956169$export$674d8cd8b6868154() {
  // Snippet to load GA async
  const w = window;
  // @ts-ignore
  w.ga || (w.ga = function () {
    var _w$ga;
    ((_w$ga = w.ga).q || (_w$ga.q = [])).push(arguments);
  });
  w.ga.l = +new Date();
}

/**
 * Elements currently intersecting with the viewport.
 * If they are intersecting for the `has_to_be_intersecting_for` duration, we count it as an impression, and call the callback.
 */
const $20f21bee300687ff$var$current_intersections = /*@__PURE__*/new WeakMap();
/**
 *  Currently watched elements by the intersection observer with their respective callback
 * */
const $20f21bee300687ff$var$watched_elements = /*@__PURE__*/new WeakMap();
const $20f21bee300687ff$var$unwatch_element = element => {
  $20f21bee300687ff$var$intersection_observer === null || $20f21bee300687ff$var$intersection_observer === void 0 || $20f21bee300687ff$var$intersection_observer.unobserve(element);
  $20f21bee300687ff$var$watched_elements.delete(element);
  $20f21bee300687ff$var$current_intersections.delete(element);
};
const $20f21bee300687ff$export$4c51576248bcdf31 = (element, callback) => {
  if ($20f21bee300687ff$var$watched_elements.has(element)) {
    $241f2f02cc612a49$export$de56f1198d121036("Not watching", element, "as it's already being watched");
    return () => {};
  }
  $20f21bee300687ff$var$intersection_observer === null || $20f21bee300687ff$var$intersection_observer === void 0 || $20f21bee300687ff$var$intersection_observer.observe(element);
  /** Calls the given callback and makes sure to stop watching the element  */
  const wrapped_callback = element => {
    callback(element);
    $20f21bee300687ff$var$unwatch_element(element);
  };
  $20f21bee300687ff$var$watched_elements.set(element, wrapped_callback);
  const disconnect_observer = (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onremoved(element, () => {
    // Sometimes it has already rapidly been reinserted. The observer events lag by one tick.
    // For that case, make sure we're really out of the DOM
    if (document.documentElement.contains(element)) return;
    $20f21bee300687ff$var$unwatch_element(element);
  });
  return () => {
    disconnect_observer();
    $20f21bee300687ff$var$unwatch_element(element);
  };
};
const $20f21bee300687ff$var$intersection_observer_callback = entries => {
  for (const record of entries) {
    const {
      target: target
    } = record;
    const callback = $20f21bee300687ff$var$watched_elements.get(target);
    // Skip the element if it's no longer being watched.
    if (!callback) {
      $20f21bee300687ff$var$intersection_observer === null || $20f21bee300687ff$var$intersection_observer === void 0 || $20f21bee300687ff$var$intersection_observer.unobserve(target);
      continue;
    }
    const currently_intersecting = $20f21bee300687ff$var$current_intersections.has(target);
    if (!currently_intersecting && record.intersectionRatio >= (0, $d6c3e2ba045accda$export$135da44d0ba958bc)[0]) {
      // we're intersecting enough and not already in the process of "measuring"
      const started_intersecting_at_ = +new Date(); // save start time
      // Schedule the callback function to be called after the element has been intersecting for the required duration
      const callback_timeout_ = setTimeout(callback, (0, $d6c3e2ba045accda$export$ca8321ea61dc2544), target);
      $20f21bee300687ff$var$current_intersections.set(target, {
        started_intersecting_at_: started_intersecting_at_,
        callback_timeout_: callback_timeout_
      });
    } else if (currently_intersecting && record.intersectionRatio < (0, $d6c3e2ba045accda$export$135da44d0ba958bc)[1]) {
      // we are in the process of "measuring" and went below the threshold
      const {
        started_intersecting_at_: started_intersecting_at_,
        callback_timeout_: callback_timeout_
      } = $20f21bee300687ff$var$current_intersections.get(target);
      const time_elapsed = +new Date() - started_intersecting_at_;
      // If we stopped intersecting too early we want to abort our timeout.
      // if we did not we also want to abort the timeout since it's been lagging and just instantly send the event
      // (the browser can delay setTimeout timers)
      clearTimeout(callback_timeout_);
      if (time_elapsed <= (0, $d6c3e2ba045accda$export$ca8321ea61dc2544)) $20f21bee300687ff$var$current_intersections.delete(target);else {
        // we intersected long enough
        $241f2f02cc612a49$export$de56f1198d121036("intersection_observer: setTimeout lagged", time_elapsed, (0, $d6c3e2ba045accda$export$ca8321ea61dc2544), "ms", target);
        callback(target);
      }
    }
  }
};
/**
 * Global IntersectionObserver used for all impression tracking.
 * It's faster to use one observer for all elements than to create a new one for each element.
 */
const $20f21bee300687ff$var$intersection_observer = typeof window === "object" ? /*@__PURE__*/new IntersectionObserver( /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9($20f21bee300687ff$var$intersection_observer_callback), {
  threshold: /*@__PURE__*/$ab9c3dbf2bb2fbf7$export$f8ea2e7b15b5d129(8)
}) : undefined;
const $c633189b7b69d048$export$d0efd8ed14f5c33 = (items, display, info) => {
  if (!(items !== null && items !== void 0 && items.length)) return items;
  const node_array = Array.isArray(items) ? items : [...items]; // if it's a NodeList convert it to an array
  const first_watchable_el = node_array.find(el => el instanceof Element);
  if (!first_watchable_el) {
    $241f2f02cc612a49$export$de56f1198d121036("Impression tracking: Can't observe", items, display);
    return items;
  }
  if (!info.t) {
    $241f2f02cc612a49$export$de56f1198d121036("Impression tracking: No tenant instance, can't track", items, display);
    return items;
  }
  (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists(first_watchable_el, _ref => {
    let {
      element: element
    } = _ref;
    $20f21bee300687ff$export$4c51576248bcdf31(element, () => {
      const {
        recommendation_id: recommendation_id,
        search_result_id: search_result_id,
        product_listing_result_id: product_listing_result_id,
        suggestions_result_id: suggestions_result_id
      } = display;
      $d6c3e2ba045accda$export$4205dc6835bc0d9f({
        ...$d5f7352b58e0d737$export$8c6f26a5b6921b95(),
        recommendation_type: info.rendering_options.type,
        entity_price: display.sale_price,
        market: info.t.market,
        tenant: info.t.tenant,
        product_id: display.product_id,
        recommendation_id: recommendation_id,
        search_result_id: search_result_id,
        product_listing_result_id: product_listing_result_id,
        suggestions_result_id: suggestions_result_id
      });
    });
  });
  return items;
};
const $e89a1d249db21af0$export$37125ccc5dd98050 = _ref => {
  let {
    element: element,
    data: data,
    wait_for_dom_insertion = true
  } = _ref;
  const disconnectors = [];
  const impression_track = () => {
    const disconnector = $20f21bee300687ff$export$4c51576248bcdf31(element, () => {
      $d6c3e2ba045accda$export$4205dc6835bc0d9f({
        ...$d5f7352b58e0d737$export$8c6f26a5b6921b95(),
        ...data
      });
    });
    disconnectors.push(disconnector);
  };
  if (wait_for_dom_insertion) disconnectors.push((0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists(element, impression_track));else impression_track();
  return () => disconnectors.forEach(disconnector => disconnector());
};
let $d6c3e2ba045accda$export$135da44d0ba958bc = [0.6, 0.5];
const $d6c3e2ba045accda$export$c543ee4cdb0d0964 = (start, end) => $d6c3e2ba045accda$export$135da44d0ba958bc = [start, end];
const $d6c3e2ba045accda$export$ca8321ea61dc2544 = 500;
const $d6c3e2ba045accda$export$4205dc6835bc0d9f = data => {
  data.type = "element_visible"; // Set the type to element_visible as this is optional to pass here.
  $814c3bf8e175fa59$export$28cacbd9b4306ffc([data], true);
};

// https://stackoverflow.com/a/39941616
function $6c8c963618d41bb2$var$invert_promise(promise) {
  return new Promise((res, rej) => promise.then(rej, res));
}
function $6c8c963618d41bb2$export$947a20746936143d(promises) {
  var _Promise$any, _Promise$any2;
  return (_Promise$any = Promise === null || Promise === void 0 ? void 0 : (_Promise$any2 = Promise.any) === null || _Promise$any2 === void 0 ? void 0 : _Promise$any2.call(Promise, promises)) !== null && _Promise$any !== void 0 ? _Promise$any : $6c8c963618d41bb2$var$invert_promise(Promise.all([...promises].map($6c8c963618d41bb2$var$invert_promise)));
}
async function $df87ac5a30f7baac$export$836f70a28c317905(product_id) {
  if (typeof BroadcastChannel != "function") return;
  const bc = new BroadcastChannel("right_click_attribution");
  $241f2f02cc612a49$export$de56f1198d121036("Broadcasting", product_id, "to", bc);
  bc.postMessage(product_id);
  bc.close();
}
function $df87ac5a30f7baac$export$58c56fe2313fdbe3(elements, display, info, get_event_listener_remover) {
  if (typeof BroadcastChannel != "function") return elements;
  const disconnectors = [];
  const handler = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(e => $df87ac5a30f7baac$export$8f66c4c7fb96eda2(e, ("variant_index" in display ? display.variant_displays[display.variant_index] : display).product_id));
  const auxclick_handler = e => e.button === 1 && handler(e);
  for (let i = 0; i < (elements === null || elements === void 0 ? void 0 : elements.length); i++) {
    const element = elements[i];
    element.addEventListener("contextmenu", handler);
    element.addEventListener("auxclick", auxclick_handler); // actual wheel click - some mouses / OS:es also dispatch auxclick on rightclick
    if (get_event_listener_remover) disconnectors.push(() => {
      element.removeEventListener("contextmenu", handler);
      element.removeEventListener("auxclick", auxclick_handler);
    });
  }
  get_event_listener_remover === null || get_event_listener_remover === void 0 || get_event_listener_remover(() => disconnectors.forEach(disconnector => disconnector()));
  return elements;
}
async function $df87ac5a30f7baac$export$8f66c4c7fb96eda2(e, product_id) {
  $241f2f02cc612a49$export$de56f1198d121036("Contextmenu was invoked", e);
  const element = e.currentTarget || e.target;
  const bc = new BroadcastChannel("right_click_attribution");
  const got_wanted_event = await $6c8c963618d41bb2$export$947a20746936143d([new Promise(resolve => {
    bc.addEventListener("message", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(msg => {
      const {
        data: data
      } = msg;
      $241f2f02cc612a49$export$de56f1198d121036("Recieved broadcast channel event", data, msg);
      if (data == product_id) resolve(true);
    }));
  }), new Promise(r => setTimeout(r, 60000, false))]);
  if (got_wanted_event) {
    const click = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
      metaKey: true
    });
    $241f2f02cc612a49$export$de56f1198d121036("Someone broadcasted our product_id! Simulating a click event on the element that was contextmenu'd", element, click);
    element.addEventListener("click", e => (e.preventDefault(), false), {
      once: true
    });
    element.dispatchEvent(click);
  } else $241f2f02cc612a49$export$de56f1198d121036("Our product_id did not get broadcasted, closing channel");
  bc.close();
}
let $0897f35c3b3fbbc4$var$last_page_pageview_sent_for;
async function $0897f35c3b3fbbc4$export$eee4c4d924348b05(data) {
  // Send page view to depict if needed
  try {
    const {
      href: href
    } = location;
    if ($0897f35c3b3fbbc4$var$last_page_pageview_sent_for !== href) {
      $0897f35c3b3fbbc4$var$last_page_pageview_sent_for = href;
      $d5f7352b58e0d737$export$82badda1f9923310({
        ...data,
        type: "page_view"
      });
      if (data.product_id) await $df87ac5a30f7baac$export$836f70a28c317905(data.product_id); // this takes care of right click click attribution - broadcasts the URL of the current page
    }
  } catch (error) {
    $5e1f45affc1d7def$export$f18d5b0af29128b7([error, "Sending page view failed"], "warning");
  }
}
let $0897f35c3b3fbbc4$var$sending_on_navigation = false;
async function $0897f35c3b3fbbc4$export$f7cb1bd47199ec38(data) {
  if (!$0897f35c3b3fbbc4$var$sending_on_navigation) {
    $0897f35c3b3fbbc4$var$sending_on_navigation = true;
    $5e1f45affc1d7def$export$b3bbfd758f11cfa9(async () => {
      for await (const _href of (0, $ad1dbddac6af350d$export$a9d39e43ae273d26)) $0897f35c3b3fbbc4$export$eee4c4d924348b05({
        tenant: data.tenant,
        market: data.market,
        product_id: await data.get_product_id(_href)
      });
    })();
  }
}
function $429b4383ef3d586f$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $429b4383ef3d586f$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $429b4383ef3d586f$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
var $429b4383ef3d586f$var$_et = /*#__PURE__*/new WeakMap();
class $429b4383ef3d586f$export$74108888f38788f3 extends Set {
  constructor() {
    super(...arguments);
    $429b4383ef3d586f$var$_classPrivateFieldInitSpec(this, $429b4383ef3d586f$var$_et, {
      writable: true,
      value: new EventTarget()
    });
  }
  addEventListener(event, callback, options) {
    $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $429b4383ef3d586f$var$_et).addEventListener(event, callback, options);
  }
  removeEventListener(event, callback) {
    $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $429b4383ef3d586f$var$_et).removeEventListener(event, callback);
  }
  add(property) {
    Set.prototype.add.call(this, property);
    $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $429b4383ef3d586f$var$_et).dispatchEvent(new CustomEvent("add", {
      detail: property
    }));
    return this;
  }
  delete(property) {
    const return_value = Set.prototype.delete.call(this, property);
    $76EG6$babelruntimehelpersclassPrivateFieldGet(this, $429b4383ef3d586f$var$_et).dispatchEvent(new CustomEvent("delete", {
      detail: property
    }));
    return return_value;
  }
}

/**
 * This does what you'd think Element.closest does. It finds the closest node in the DOM tree matching a selector. So it starts out with the siblings and then goes upwards in the DOM and checks the siblings and their children of the parent until there's no parent anymore.
 * @param  element                        Element to start out at
 * @param  selector                       Selector to search for
 * @param  start_right=true               In what direction to start: true = right, false = left
 * @return                                The found element or undefined
 */
function $85906d121f53bacd$export$d9fdc6ce2907f95b(element, selector) {
  let start_right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  for (; element; element = element.parentNode) {
    var _element, _element$matches, _element2, _element3, _element3$querySelect, _element4, _element5, _element5$parentNode;
    if ((_element = element) !== null && _element !== void 0 && (_element$matches = (_element2 = _element).matches) !== null && _element$matches !== void 0 && _element$matches.call(_element2, selector)) return element;
    const has_matching_child = (_element3 = element) === null || _element3 === void 0 ? void 0 : (_element3$querySelect = (_element4 = _element3).querySelector) === null || _element3$querySelect === void 0 ? void 0 : _element3$querySelect.call(_element4, selector);
    if (has_matching_child) return has_matching_child;
    const child_nodes = [...(((_element5 = element) === null || _element5 === void 0 ? void 0 : (_element5$parentNode = _element5.parentNode) === null || _element5$parentNode === void 0 ? void 0 : _element5$parentNode.childNodes) || [])];
    const our_index = child_nodes.indexOf(element);
    for (let i = 0; i < Math.ceil(child_nodes.length / 2); i++) for (let j = 2; j--;) {
      var _node_to_test$matches, _node_to_test$querySe;
      const direction = start_right ? j ? 1 : -1 : j ? -1 : 1;
      const node_to_test = child_nodes[our_index + i * direction];
      if (node_to_test !== null && node_to_test !== void 0 && (_node_to_test$matches = node_to_test.matches) !== null && _node_to_test$matches !== void 0 && _node_to_test$matches.call(node_to_test, selector)) return node_to_test;
      const matching_child = node_to_test === null || node_to_test === void 0 ? void 0 : (_node_to_test$querySe = node_to_test.querySelector) === null || _node_to_test$querySe === void 0 ? void 0 : _node_to_test$querySe.call(node_to_test, selector);
      if (matching_child) return matching_child;
    }
  }
}
const $45d268baa2df1ba1$export$6b75200e58bc97d0 = (arr1, arr2, compareFunc) => {
  return arr1.filter(e1 => arr2.every(e2 => !compareFunc(e1, e2)));
};
const $45d268baa2df1ba1$export$9426572bd5645bc1 = (arr1, arr2) => $45d268baa2df1ba1$export$6b75200e58bc97d0(arr1, arr2 || [], (i1, i2) => i1.product_id === i2.product_id);
function $8183c177c3bdf94d$export$82539d9817116aff(e, url) {
  var _window, _window$next;
  if (e.button) {
    $241f2f02cc612a49$export$de56f1198d121036("Not single page navigating because button is not 0", e);
    return;
  }
  if (e.metaKey || e.ctrlKey) {
    $241f2f02cc612a49$export$de56f1198d121036("Someone command-clicked a link, not single page navigating");
    return;
  }
  // single page navigate
  const router = (_window = window) === null || _window === void 0 ? void 0 : (_window$next = _window.next) === null || _window$next === void 0 ? void 0 : _window$next.router;
  if (typeof (router === null || router === void 0 ? void 0 : router.push) == "function") {
    const parsed = new URL(url);
    const path_and_query_params = parsed.pathname + parsed.search;
    router.push(path_and_query_params, path_and_query_params, {
      shallow: false,
      scroll: true
    });
    e.preventDefault();
    return false;
  }
}

/**
 * This module contains utillities for working with ecom sites using shoppify.
 *
 * Shopify cart API reference: https://shopify.dev/api/ajax/reference/cart
 */

async function $201e455525e1fa49$export$85be83e1935d93c2(fetch_proxy_handler) {
  let unsafe_throw_up = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  window.fetch = new Proxy(window.fetch, {
    apply: fetch_apply
  }); // this is the magic
  async function fetch_apply(target, this_arg, arguments_list) {
    var _fetch_proxy_handler, _fetch_proxy_handler$;
    // this wraps fetch_proxy_handler in case it fails
    // the types of the arguments of this function *should* be the same as for fetch_proxy_handler but are written as `any` because someone MIGHT replace fetch and they'd no longer be accurate
    if (unsafe_throw_up) return await fetch_proxy_handler(target, this_arg, arguments_list);
    return (await ((_fetch_proxy_handler = fetch_proxy_handler(target, this_arg, arguments_list)) === null || _fetch_proxy_handler === void 0 ? void 0 : (_fetch_proxy_handler$ = _fetch_proxy_handler.catch) === null || _fetch_proxy_handler$ === void 0 ? void 0 : _fetch_proxy_handler$.call(_fetch_proxy_handler, (0, $b000f5ef6ce456d9$export$8048b892d651b310)))) || (await target.apply(this_arg, arguments_list));
  }
}
class $201e455525e1fa49$export$f8da66bc4f1d059e extends ((globalThis === null || globalThis === void 0 ? void 0 : globalThis.Response) || class {}) {
  // the or here is to not throw on node 16 on the server
  constructor(response_string, url) {
    let headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let override_options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const options = {
      status: 200,
      statusText: "OK",
      headers: {
        "content-type": "application/json; charset=utf-8",
        ...headers
      },
      ...override_options
    };
    super(response_string, options);
    Object.defineProperty(this, "url", {
      value: url,
      configurable: true,
      enumerable: true
    });
    Object.defineProperty(this, "type", {
      value: "basic",
      configurable: true,
      enumerable: true
    });
  }
}
function $f69445e469425bcb$export$ab0f802c05dd969b(on_request) {
  let lenient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  $201e455525e1fa49$export$85be83e1935d93c2(async (target, this_arg, argument_list) => {
    const response_promise = target.apply(this_arg, argument_list);
    try {
      const input = argument_list[0];
      const url = input instanceof Request ? input.url : input instanceof URL ? input.href : input;
      // TODO, doing it like this doesn't feel very robust.
      // And what if the developer wants to override which url's corespond to which events?
      const url_segement_to_type = [["/cart.js", "get_items"], ["/cart/add.js", "add_items"], ["/cart/update.js", "update_items"], ["/cart/change.js", "change_items"], ["/cart/clear.js", "clear_items"]];
      for (const [segment, type] of url_segement_to_type) {
        if (!url.includes(segment) && (!lenient || !url.endsWith(segment.split(".js")[0]))) continue;
        let decoded_body;
        try {
          var _argument_list$;
          const body = (_argument_list$ = argument_list[1]) === null || _argument_list$ === void 0 ? void 0 : _argument_list$.body;
          if (typeof body === "string") decoded_body = JSON.parse(body);
        } catch (e) {}
        const body = decoded_body ? {
          body: decoded_body
        } : {};
        if (type === "clear_items") on_request({
          type: "clear_items",
          response: response_promise.then(() => []),
          ...body
        });else on_request({
          type: type,
          ...body,
          response: response_promise.then(async response => {
            const response_copy = response.clone();
            // The raw untyped shopify response
            const json = await response_copy.json();
            // There wasn't an `items` field, so we assume there was an error
            if (typeof json.items === "undefined") return json;else return json.items;
          })
        });
        break;
      }
    } catch (e) {
      $5e1f45affc1d7def$export$f18d5b0af29128b7([e, "error in shopify interception logic"], "warning");
    }
    return await response_promise;
  }, true);
}
async function $f69445e469425bcb$export$774bc87373c4fc6c(shopify_id, options) {
  var _options$quantity;
  const id = shopify_id;
  const quantity = (_options$quantity = options === null || options === void 0 ? void 0 : options.quantity) !== null && _options$quantity !== void 0 ? _options$quantity : 1;
  const url = "/cart/add.js";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: [{
        id: id,
        quantity: quantity
      }]
    })
  });
  const json = await response.json();
  if (Array.isArray(json.items)) return json.items;else if (typeof json.status === "number") return json;else throw new Error("Shopify ".concat(url, " did not respond as expected"));
}
async function $f69445e469425bcb$export$337197b94b3bd680() {
  const url = "/cart.js";
  const response = await fetch(url, {
    method: "GET"
  });
  const json = await response.json();
  if (Array.isArray(json.items)) return json.items;else if (typeof json.status === "number") return json;else throw new Error("Shopify ".concat(url, " did not respond as expected"));
}
const $f69445e469425bcb$export$783ef16647773b3d = /*@__PURE__*/$9c44a7238815fa47$export$535946eb77c946dd( /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9(async () => {
  const meta = await $2da62df28669a48a$export$2fc1a072736ae2f6(window, "ShopifyAnalytics", "meta");
  return meta === null || meta === void 0 ? void 0 : meta.product;
}));
const $57642e3bf93ac1e7$export$5c069c93d2b7493f = delay => new Promise(resolve => setTimeout(resolve, delay));
async function $c95f8181bad32e8d$export$bcd70d5ed1cf6313(url, options) {
  let max_retries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  let {
    useFetch_ = fetch,
    initialRetryDuration_ = 100
  } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const ONE_MINUTE = 60000;
  const max_backoff_ms = ONE_MINUTE;
  const {
    stack: stack
  } = new Error();
  const calculate_retry = delay => {
    delay *= 2 + Math.random();
    if (delay > max_backoff_ms) delay = max_backoff_ms * (1 + Math.random() / 10);
    return delay;
  };
  let try_again_in_ms = initialRetryDuration_;
  let has_succeeded = false;
  let result = false;
  while (max_retries && !has_succeeded) try {
    const response = await useFetch_(url, options);
    const {
      status: status,
      ok: ok
    } = response;
    if (!response || !ok || status !== 200) {
      if (status >= 400 && status < 500) {
        $5e1f45affc1d7def$export$b3bbfd758f11cfa9($c95f8181bad32e8d$var$send_sentry_4xx)(response, (options === null || options === void 0 ? void 0 : options.body) || {}, stack);
        has_succeeded = true;
      } else if (status === 404) has_succeeded = true;
      $241f2f02cc612a49$export$de56f1198d121036("Response not ok", response);
    } else has_succeeded = true;
    result = response;
  } catch (error) {
    $241f2f02cc612a49$export$de56f1198d121036("Error while fetching: ", error, url, options);
    // Don't retry CORS
    if (error.message.includes("CORS") && error.name.includes("CORS")) has_succeeded = true;
  } finally {
    if (!has_succeeded) await $57642e3bf93ac1e7$export$5c069c93d2b7493f(try_again_in_ms);
    try_again_in_ms = calculate_retry(try_again_in_ms);
    max_retries -= 1;
  }
  return result;
}
async function $c95f8181bad32e8d$var$send_sentry_4xx(response, body, stack) {
  if (process.env.TENANT === "shopify-config" && response.status === 403)
    // Don't send requests in the shopify admin that say we need to re-authorize to sentry
    return;
  const msg = "Validation error: got 4XX from API";
  const text = await response.clone().text();
  $241f2f02cc612a49$export$de56f1198d121036(msg, "body", body, "response", response, "text", text, "stack", stack);
  (0, $17bb552dedcd526c$export$af2e17a20c2ea3c5).withScope(function (scope) {
    scope.setExtra("stack", stack);
    scope.setExtra("request_body", body);
    scope.setExtra("response", response);
    scope.setExtra("serialized_response", $d9aec442b12a1134$export$39d526a1194b6499(response));
    scope.setExtra("response_text", text);
    scope.setLevel("error");
    this.captureException(new Error(msg));
  });
}
function $c1590f86e0eca625$export$2c2f50b30b7b2576(el, attribute_name, async_iterable) {
  let quit_after_navigation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  (async () => {
    const [exit, exitable_iterable] = $fee212025270d5b9$export$927664b47117acb0(async_iterable);
    if (quit_after_navigation) $ad1dbddac6af350d$export$1cd22bab0d2c3b0b(exit);
    for await (const new_value of exitable_iterable) el.setAttribute(attribute_name, new_value);
  })().catch(e => $5e1f45affc1d7def$export$f18d5b0af29128b7([e, "Failed to set attribute"], "error"));
  return el;
}
function $332ef338faf216a4$export$7c081fdbc65b6a2a(async_iterable) {
  let quit_after_navigation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const [template_els, _get, set] = $2b6304d4ce419ed5$export$3d04c40e7acc1a32();
  (async () => {
    const [exit, exitable_iterable] = $fee212025270d5b9$export$927664b47117acb0(async_iterable);
    if (quit_after_navigation) $ad1dbddac6af350d$export$1cd22bab0d2c3b0b(exit);
    for await (const els of exitable_iterable) set(els);
  })().catch(e => $5e1f45affc1d7def$export$f18d5b0af29128b7([e, "Failed to convert AsyncIterable to elements"], "error"));
  return template_els;
}
let $2c22b027931240e6$var$context_counter = 0; // last context that was created (unless 0), to make sure we don't have two of the same
let $2c22b027931240e6$var$current_context;
const $2c22b027931240e6$var$failed_contexts = /*@__PURE__*/new Set();
const $2c22b027931240e6$export$b8d1e1d07a3f3776 = cb => {
  const context = ++$2c22b027931240e6$var$context_counter;
  return function () {
    const prev_context = $2c22b027931240e6$var$current_context;
    $2c22b027931240e6$var$current_context = context;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    if ($2c22b027931240e6$var$failed_contexts.has(context)) {
      const [first_arg] = args;
      if (first_arg instanceof (0, $4f10cdcba0efac85$export$ea60432919e69303)) first_arg.disconnector();
      return;
    }
    const retval = cb(...args);
    $2c22b027931240e6$var$current_context = prev_context;
    return retval;
  };
};
function $2c22b027931240e6$export$f811d2ce0aa6019b(_ref) {
  let {
    surfaces: input_surfaces,
    verb: verb,
    target: target,
    remove_after_navigation = true,
    try_forever = false,
    preserve_elements = false
  } = _ref;
  const surfaces = input_surfaces.map(s => {
    let resolve;
    const promise = new Promise(r => resolve = r);
    return {
      surface_: s,
      resolve_promise_: resolve,
      promise_: promise
    };
  });
  const {
    href: href
  } = location;
  let context = $2c22b027931240e6$var$current_context;
  if (typeof target === "string") {
    var _context;
    (_context = context) !== null && _context !== void 0 ? _context : context = ++$2c22b027931240e6$var$context_counter; // assign a context so that we don't add `undefined` or `null` to failed_contexts
    let disconnect_reinsertion_observers;
    const disconnect_observer = (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists(target, _ref2 => {
      var _disconnect_reinserti;
      let {
        element: element,
        disconnector: disconnector
      } = _ref2;
      if ($2c22b027931240e6$var$failed_contexts.has(context)) {
        disconnector(); // prevent infinite loop
        return;
      }
      (_disconnect_reinserti = disconnect_reinsertion_observers) === null || _disconnect_reinserti === void 0 || _disconnect_reinserti(); // Not sure if necessary? But if we re-insert in the same container and don't disconnect preserve_elements observers before it might lead to two observers acting on one element
      disconnect_reinsertion_observers = $2c22b027931240e6$var$actual_insertion(element, verb, surfaces, try_forever, href, context, remove_after_navigation, preserve_elements);
    });
    if (!try_forever) $ad1dbddac6af350d$export$1cd22bab0d2c3b0b(disconnect_observer);
  } else {
    if (!context && verb !== "replaceChildren") throw new Error("insert_surface, provided an element, may not be called without a context." + (process.env.DEBUG === "true" ? " Please wrap the function calling it into prevent_infinite_loop(). If you have already done that, make sure that there's no `await` before the calling of insert_surface" : ""));
    $5e1f45affc1d7def$export$b3bbfd758f11cfa9($2c22b027931240e6$var$actual_insertion)(target, verb, surfaces, try_forever, href, context, remove_after_navigation, preserve_elements);
  }
  return surfaces.map(_ref3 => {
    let {
      promise_: promise_
    } = _ref3;
    return promise_;
  });
}
const $2c22b027931240e6$export$e3f70ef7e3d00501 = /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9(async (target, should_stay_inserted) => {
  const per_el_fn = (el, disconnect_observer) => {
    const comment_node = document.createComment("Old recs were here // Depict");
    $241f2f02cc612a49$export$de56f1198d121036("Replacing", el, "with", comment_node);
    el.replaceWith(comment_node);
    should_stay_inserted.then(keep => {
      if (!keep) {
        $241f2f02cc612a49$export$de56f1198d121036("Reverting", comment_node, "to", el);
        comment_node.replaceWith(el);
        disconnect_observer === null || disconnect_observer === void 0 || disconnect_observer();
      }
    });
  };
  if (typeof target == "string") {
    const disconnect_observer = (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists(target, _ref4 => {
      let {
        element: element,
        disconnector: disconnector
      } = _ref4;
      return per_el_fn(element, disconnector);
    });
    $ad1dbddac6af350d$export$1cd22bab0d2c3b0b(disconnect_observer);
  } else {
    let did_already_fail = false;
    should_stay_inserted.then(should_stay_inserted => {
      if (!should_stay_inserted) did_already_fail = true;
    });
    await 0;
    if (did_already_fail) {
      $241f2f02cc612a49$export$de56f1198d121036("Not removing", target, should_stay_inserted, "is already resolved to false");
      return;
    }
    if (Array.isArray(target)) for (let i = 0; i < target.length; i++) per_el_fn(target[i]);else per_el_fn(target);
  }
});
function $2c22b027931240e6$var$actual_insertion(target, verb, surfaces, try_forever, starting_href, context, remove_after_navigation, preserve_elements) {
  let failed_surfaces = 0;
  let old_children;
  if (verb === "replaceChildren") old_children = [...target.childNodes];
  const was_replaced = verb == "replaceWith";
  const disconnectors = [];
  const disconnect_all_observers = () => disconnectors.forEach(disconnector => disconnector());
  const check_if_revert_whole = () => {
    if (failed_surfaces !== surfaces.length) return; // we didn't fail
    $241f2f02cc612a49$export$de56f1198d121036("All surfaces", surfaces, "failed. ".concat(was_replaced ? "Reverting to old els" : "removing els"));
    $2c22b027931240e6$var$failed_contexts.add(context);
    disconnect_all_observers();
    const flat_tnodes = template_nodes.flat();
    if (was_replaced) {
      flat_tnodes[0].replaceWith(target);
      for (let i = 1; i < flat_tnodes.length; i++) flat_tnodes[i].remove();
    } else if (old_children) target.replaceChildren(...old_children);else flat_tnodes.forEach(n => n.remove());
  };
  const template_nodes = surfaces.map(_ref5 => {
    let {
      surface_: surface_,
      resolve_promise_: resolve_promise_
    } = _ref5;
    const [template_els, _get, set] = $2b6304d4ce419ed5$export$3d04c40e7acc1a32();
    (async _surface => {
      let surface;
      try {
        surface = await surface_;
      } catch (e) {
        $5e1f45affc1d7def$export$f18d5b0af29128b7([e, "A surface promise rejected" + (process.env.DEBUG === "true" ? " please catch this earlier" : "")], "warning");
      }
      if (!try_forever && location.href !== starting_href)
        // navigated away
        return;
      // @ts-ignore
      if ((_surface = surface) !== null && _surface !== void 0 && _surface.elements) {
        $241f2f02cc612a49$export$de56f1198d121036("insert_surface:", target, "." + verb, surface);
        set(surface.elements);
        if (surface.should_stay_inserted instanceof Promise) surface.should_stay_inserted.then($5e1f45affc1d7def$export$b3bbfd758f11cfa9(keep => {
          if (keep)
            // @ts-ignore
            resolve_promise_({
              surface: surface,
              succeeded: true
            });else {
            $241f2f02cc612a49$export$de56f1198d121036("Removing surface", surface, "because it failed");
            set("");
            // @ts-ignore
            resolve_promise_({
              surface: surface,
              succeeded: false
            });
            failed_surfaces++;
            check_if_revert_whole();
          }
        }));else resolve_promise_({
          surface: surface,
          succeeded: true
        });
      } else {
        // @ts-ignore
        resolve_promise_({
          surface: surface,
          succeeded: false
        });
        failed_surfaces++;
        check_if_revert_whole();
      }
    })().catch(e => $5e1f45affc1d7def$export$f18d5b0af29128b7([e, "insert_surface failed due to technical errors"], "error"));
    return template_els;
  });
  target[verb](...template_nodes.flat());
  if (preserve_elements) for (let i = 0; i < template_nodes.length; i++) {
    const node_array = template_nodes[i];
    const already_observing_nodes = new WeakSet();
    $2c22b027931240e6$var$deal_w_removal_of_node_array(node_array, disconnectors.push.bind(disconnectors), already_observing_nodes);
  }
  if (remove_after_navigation) $ad1dbddac6af350d$export$1cd22bab0d2c3b0b(() => {
    disconnect_all_observers();
    template_nodes.flat().forEach(tn => tn.remove());
    $241f2f02cc612a49$export$de56f1198d121036("Removed", template_nodes, "due to navigation");
  });
  return disconnect_all_observers;
}
function $2c22b027931240e6$var$deal_w_removal_of_node_array(node_array, push_disconnector, already_observing_nodes) {
  let removals_in_last_s = 0;
  for (let j = 0; j < node_array.length; j++) {
    const previous_parent = node_array[j].parentNode;
    const node_to_observe = node_array[j];
    // this function is "recursive"
    // it is possible that the reactive_template switches back to a Node_Array that it has already previously contained or to a new one that contains the same elements
    // there we don't want to re-add an observer
    if (already_observing_nodes.has(node_to_observe)) continue;else already_observing_nodes.add(node_to_observe);
    const disconnect_observer = (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onremoved(node_to_observe, eoe => {
      const mutation_record = eoe.mutation_record; // .onremoved always has a mutation_record
      const {
        element: element
      } = eoe;
      const {
        nextSibling: nextSibling,
        previousSibling: previousSibling,
        target: target
      } = mutation_record;
      if (previous_parent !== target) {
        $241f2f02cc612a49$export$de56f1198d121036(element, "was removed", eoe, "but because a parent got removed we're keeping it that way");
        return;
      }
      if (node_array.every(node => target.contains(node))) {
        // we know that this change was done by updating the reactive_template or a connected/synchronized reactive_template
        // node_array is a reference to an updating array
        // it has always updated once this callback is ran, so we can just check if the new value are currently in the DOM
        // here we don't check the order but I don't think it's going to be an issue?
        $241f2f02cc612a49$export$de56f1198d121036("Ignoring removal of", element, eoe, "because it seems to come from reactive_template change");
        // protect future nodes
        $2c22b027931240e6$var$deal_w_removal_of_node_array(node_array, push_disconnector, already_observing_nodes);
      } else if (!target.contains(element)) {
        // it's possible that the element already was re-inserted at the same time (this callback is executed a tick late), we obv. don't want to attempt to reinsert then
        if (removals_in_last_s > 10) {
          $241f2f02cc612a49$export$de56f1198d121036("More than 10 reinsertions in last second, ignoring");
          return;
        }
        removals_in_last_s++;
        setTimeout(() => removals_in_last_s--, 1000);
        $241f2f02cc612a49$export$de56f1198d121036(element, "was removed from DOM,", eoe, "reinserting");
        const {
          documentElement: documentElement
        } = document;
        // try to get right place, didn't test this
        if (nextSibling && documentElement.contains(nextSibling)) nextSibling.before(element);else if (previousSibling && documentElement.contains(previousSibling)) previousSibling.after(element);else
          // let's hope nobody made the target a textnode or this throws (unlikely since the typing of insert_surface doesn't allow it)
          target.append(element);
      }
    });
    push_disconnector(disconnect_observer);
  }
}
let $1013f2e568f87406$var$existing_style_tag;
let $1013f2e568f87406$var$reactions_in_last_s = 0;
const $1013f2e568f87406$export$59ba1eb2c083f0cd = /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9(async css => {
  const style_tag = await ($1013f2e568f87406$var$existing_style_tag || ($1013f2e568f87406$var$existing_style_tag = (0, $90fa633a9564f115$export$b6ae1bc530f4c149).wait_for_element("head").then(head => {
    const tag = document.createElement("style");
    (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onremoved(
    // reinsertion for next.js's "portable" <head>
    tag, eoe => {
      if (document.head.contains(tag))
        // just make sure to not freak out if it's already been added again
        return;
      if ($1013f2e568f87406$var$reactions_in_last_s >= 10) {
        $5e1f45affc1d7def$export$f18d5b0af29128b7(new Error("Someone removed our styling but insists on it (10 removals in previous second). Giving up \uD83D\uDE2B"), "error");
        return;
      }
      $241f2f02cc612a49$export$de56f1198d121036("Someone removed our styling \uD83D\uDE24, reinserting", eoe);
      $1013f2e568f87406$var$reactions_in_last_s++;
      setTimeout(() => $1013f2e568f87406$var$reactions_in_last_s--, 1000);
      document.head.append(tag); // we're sure that head exists now since we inserted it there previously
    });

    $241f2f02cc612a49$export$de56f1198d121036("inserting", tag, "into", head);
    return head.appendChild(tag);
  })));
  style_tag.append(css);
});
const $1013f2e568f87406$export$a4f97b27a0592e6c = url => {
  var _pathname$split$filte;
  return ((_pathname$split$filte = (url ? new URL(url, window.location.origin) : window.location).pathname.split("/").filter(a => a).pop()) === null || _pathname$split$filte === void 0 ? void 0 : _pathname$split$filte.replace(/\.html?$/i, "")) || "";
};
const $1013f2e568f87406$export$692b606677218a16 = callback => {
  if (document.depictwashere) {
    if (process.env.BUILD_TARGET === "dev") {
      $241f2f02cc612a49$export$de56f1198d121036("HMR tried to rerun us, reloading page");
      /* eslint-disable no-self-assign */
      location.href = location.href;
    }
    $241f2f02cc612a49$export$de56f1198d121036("Script has already ran", document.currentScript, "is exiting");
    return;
  }
  if (process.env.BUILD_TARGET === "dev") /* eslint-disable no-console */console.clear = new Proxy(console.clear, {
      apply(target, this_arg, arg_list) {
        var _Error$stack;
        if ((_Error$stack = new Error().stack) !== null && _Error$stack !== void 0 && _Error$stack.split("\n").filter(Boolean).some(s => s.includes("http://localhost:1234/depict-ai.js"))) {
          /* eslint-disable no-console */console.log("CSS change detected through hack, reloading");
          location.reload();
        }
        return target.apply(this_arg, arg_list);
      }
    });
  document.depictwashere = true;
  callback().catch((0, $b000f5ef6ce456d9$export$8048b892d651b310));
};
function $1013f2e568f87406$export$328e81c44cddf3c0(callback, get_market, supported_markets, unsupported_markets, preferred_demo_market) {
  $1013f2e568f87406$export$692b606677218a16(async () => {
    // Handle override for debug scripts (could be used on demo pages too)
    if (process.env.DEBUG === "true") {
      let localstorage_override;
      const query_param_override = new URLSearchParams(location.search).get("depict-override-market");
      if (query_param_override !== null) {
        $241f2f02cc612a49$export$de56f1198d121036("Found ?depict-override-market=".concat(query_param_override, ". Using that as the market"));
        get_market = () => query_param_override;
        localStorage.setItem("depict-override-market", query_param_override);
      } else if ((localstorage_override = localStorage.getItem("depict-override-market")) !== null) {
        $241f2f02cc612a49$export$de56f1198d121036('Found depict-override-market="'.concat(localstorage_override, '" in localStorage. Using that as the market'));
        get_market = () => localstorage_override;
      }
    }
    const market = await get_market();
    if (supported_markets.includes(market)) {
      $241f2f02cc612a49$export$de56f1198d121036("Initializing with market: ".concat(market));
      return callback(market).catch((0, $b000f5ef6ce456d9$export$8048b892d651b310));
    } else if (unsupported_markets.includes(market)) {
      $241f2f02cc612a49$export$de56f1198d121036("Unsupported market: ".concat(market, ". Exiting..."));
      return;
    } else if (process.env.DEBUG === "true" && location.host.endsWith(".demo.depict.ai") && preferred_demo_market) {
      $241f2f02cc612a49$export$de56f1198d121036("On demosite with default market override. Setting market to ".concat(preferred_demo_market));
      return callback(preferred_demo_market).catch((0, $b000f5ef6ce456d9$export$8048b892d651b310));
    } else {
      $b000f5ef6ce456d9$export$8048b892d651b310(new Error('Unknown market: "'.concat(market, '". Exiting...')));
      return;
    }
  });
}
function $243da8b4990520aa$export$8ec5c86406f333ff() {
  const element_weak_set = new WeakSet();
  Node.prototype.removeChild = new Proxy(Node.prototype.removeChild, {
    apply(target, this_arg, arguments_list) {
      const el = arguments_list[0];
      if (el instanceof Node && element_weak_set.has(el)) {
        try {
          return target.apply(this_arg, arguments_list);
        } catch (e) {
          $241f2f02cc612a49$export$de56f1198d121036("Swallowing error of removal of node that we have removed or created", e, el);
        }
        return el;
      }
      return target.apply(this_arg, arguments_list);
    }
  });
  return element_weak_set;
}

// source: https://davidwalsh.name/detect-native-function
function $735ac9fa5091ab33$export$4fbbab6c30e664d5(value) {
  // Used to resolve the internal `[[Class]]` of values
  const toString = Object.prototype.toString;
  // Used to resolve the decompiled source of functions
  const fnToString = Function.prototype.toString;
  // Used to detect host constructors (Safari > 4; really typed array specific)
  const reHostCtor = /^\[object .+?Constructor\]$/;
  // Compile a regexp using a common native method as a template.
  // We chose `Object#toString` because there's a good chance it is not being mucked with.
  const reNative = RegExp("^" +
  // Coerce `Object#toString` to a string
  String(toString) // Escape any special regexp characters
  .replace(/[.*+?^${}()|[\]\/\\]/g, "\\$&") // Replace mentions of `toString` with `.*?` to keep the template generic.
  // Replace thing like `for ...` to support environments like Rhino which add extra info
  // such as method arity.
  .replace(/toString|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  const type = typeof value;
  return type == "function" ? reNative.test(fnToString.call(value)) : value && type == "object" && reHostCtor.test(toString.call(value)) || false;
}
const $9c0a16930ae6750f$var$promise_as_string = "Promise";
function $9c0a16930ae6750f$export$38e89c688f9d553a() {
  try {
    var _da_promise, _da_promise$prototype;
    const w = window;
    let da_promise = w[$9c0a16930ae6750f$var$promise_as_string];
    let iframe_promise;
    if ((typeof da_promise.allSettled !== "function" || typeof ((_da_promise = da_promise) === null || _da_promise === void 0 ? void 0 : (_da_promise$prototype = _da_promise.prototype) === null || _da_promise$prototype === void 0 ? void 0 : _da_promise$prototype.finally) !== "function") && !$735ac9fa5091ab33$export$4fbbab6c30e664d5(da_promise) && (iframe_promise = $9c0a16930ae6750f$export$e647444ed9403635())) da_promise = iframe_promise;
    if (da_promise) {
      var _Object$getOwnPropert;
      if (((_Object$getOwnPropert = Object.getOwnPropertyDescriptor(w, $9c0a16930ae6750f$var$promise_as_string)) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.configurable) !== false) Object.defineProperty(w, $9c0a16930ae6750f$var$promise_as_string, {
        configurable: false,
        enumerable: true,
        get() {
          return da_promise;
        },
        set(value) {
          return value;
        }
      });else $241f2f02cc612a49$export$de56f1198d121036("Unable to redefine " + $9c0a16930ae6750f$var$promise_as_string + ", it's already nonconfigurable");
    }
  } catch (e) {
    $b000f5ef6ce456d9$export$8048b892d651b310(e);
  }
}
function $9c0a16930ae6750f$export$e647444ed9403635() {
  var _iframe$contentWindow;
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  document.head.appendChild(iframe);
  return iframe === null || iframe === void 0 ? void 0 : (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 ? void 0 : _iframe$contentWindow[$9c0a16930ae6750f$var$promise_as_string];
}
function $24528b2f119d82fb$export$33d1643df63073a8(fetch_handler) {
  fetch_handler = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(fetch_handler);
  const {
    prototype: prototype
  } = XMLHttpRequest;
  prototype.open = new Proxy(prototype.open, {
    apply(target, this_arg, arg_array) {
      if (Array.isArray(arg_array)) {
        const request = this_arg;
        const [method, url] = arg_array;
        $5e1f45affc1d7def$export$b3bbfd758f11cfa9(fetch_handler)(request, method, url, arg_array);
      }
      return target.apply(this_arg, arg_array);
    }
  });
}
function $24528b2f119d82fb$export$f314addd5f976083(handler) {
  $24528b2f119d82fb$export$33d1643df63073a8((req, method, url) => req.addEventListener("load", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(event => handler(req, method, url, event))));
}
async function $24528b2f119d82fb$export$c74578d2cd47a84a(send_callback) {
  const catchified_callback = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(send_callback);
  const requests = new WeakMap();
  $24528b2f119d82fb$export$33d1643df63073a8((request, _method, _url, arg_array) => {
    requests.set(request, arg_array);
  });
  const {
    prototype: prototype
  } = XMLHttpRequest;
  prototype.send = new Proxy(prototype.send, {
    apply(target, this_request, arg_list) {
      try {
        if (requests.has(this_request)) catchified_callback(this_request, requests.get(this_request), arg_list);
      } catch (e) {
        $b000f5ef6ce456d9$export$8048b892d651b310(e);
      }
      return target.apply(this_request, arg_list);
    }
  });
}
async function $24528b2f119d82fb$export$8e16c51fd2b6507(read_callback) {
  const catchified_read_callback = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(read_callback);
  const open_send_arg_map = new WeakMap();
  const {
    prototype: prototype
  } = XMLHttpRequest;
  const proxy_response = n => {
    const prev_desc = Object.getOwnPropertyDescriptor(prototype, n);
    const new_desc = {
      ...prev_desc,
      get: new Proxy(prev_desc.get, {
        apply(target, this_arg, arg_list) {
          const default_value = target.apply(this_arg, arg_list);
          try {
            const stored_args = open_send_arg_map.get(this_arg);
            if (!stored_args)
              // request was sent before we proxied `.send`
              return default_value;
            const [open_args, send_args] = stored_args;
            return catchified_read_callback(this_arg, open_args, send_args, default_value, n) || default_value;
          } catch (e) {
            // in case the weakmaps fail for some reason
            $b000f5ef6ce456d9$export$8048b892d651b310(e);
            return default_value;
          }
        }
      })
    };
    Object.defineProperty(prototype, n, new_desc);
  };
  $24528b2f119d82fb$export$c74578d2cd47a84a(function (request) {
    for (var _len = arguments.length, open_send_args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) open_send_args[_key - 1] = arguments[_key];
    return open_send_arg_map.set(request, open_send_args);
  });
  ["responseText", "response", "responseXML"].forEach(proxy_response);
}
async function $f82333cd2ffc1582$export$83ec13b10b391f13() {
  let orig_url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : process.env.ORIG_URL;
  if (process.env.DEBUG !== "true") return;
  const o_u_u_o = new URL(orig_url || "", location.href);
  const orig_url_with_trailing_slash = o_u_u_o.protocol + "//" + o_u_u_o.host + "/";
  if (orig_url) {
    // change links
    $652300c6621d5500$export$d4bd03f19260ef1c(orig_url_with_trailing_slash, false, location.hostname);
    $f82333cd2ffc1582$export$2a1cc61cffa1f36f(orig_url_with_trailing_slash);
    $f82333cd2ffc1582$export$2a38b176ce969e2c(orig_url_with_trailing_slash);
    $f82333cd2ffc1582$export$f14a775632a826c4(orig_url_with_trailing_slash);
  } else $241f2f02cc612a49$export$de56f1198d121036(new Error("No ORIG_URL env var was set, demo fixes not gonna work."));
}
function $f82333cd2ffc1582$export$f14a775632a826c4(orig_url_with_trailing_slash) {
  // rewrite history.pushState and history.replaceState so that it works if someone calls it with absolute URLs
  const hist_proxy = fn => {
    const history_prototype = History.prototype;
    history_prototype[fn] = new Proxy(history_prototype[fn], {
      apply(target, this_arg, arg_list) {
        if (typeof arg_list[2] == "string") arg_list[2] = arg_list[2].replaceAll(orig_url_with_trailing_slash, "/");
        return target.apply(this_arg, arg_list);
      }
    });
  };
  ["replaceState", "pushState"].forEach(hist_proxy);
}
function $f82333cd2ffc1582$export$2a1cc61cffa1f36f(orig_url_with_trailing_slash) {
  // rewrite fetch requests just in case, maybe we should also rewrite responses
  $201e455525e1fa49$export$85be83e1935d93c2(async (target, this_arg, arg_list) => {
    try {
      const [url] = arg_list;
      if (typeof url == "string") arg_list[0] = url.replaceAll(orig_url_with_trailing_slash, "/");else if (url instanceof Request) {
        if (url.url.includes(orig_url_with_trailing_slash)) arg_list[0] = new Request(url.url.replaceAll(orig_url_with_trailing_slash, "/"), url);
      }
    } catch (e) {
      $b000f5ef6ce456d9$export$8048b892d651b310(e);
    }
    return target.apply(this_arg, arg_list);
  });
}
function $f82333cd2ffc1582$export$2a38b176ce969e2c(orig_url_with_trailing_slash) {
  // rewrite xhr requests just in case
  $24528b2f119d82fb$export$33d1643df63073a8((request, method, url, arg_array) => {
    if (url instanceof URL) url.href = url.href.replaceAll(orig_url_with_trailing_slash, "/");else if (typeof url == "string") arg_array[1] = url.replaceAll(orig_url_with_trailing_slash, "");
  });
}

/**
 * Recursively sorts the keys in an object (NOT in-place, returns a new object). Do not provide objects containing anything other than primitives or other objects. Do not provide objects that have cyclical values.
 */
function $b2c9f99c083a1182$export$12b4c6cbc6b8b4e4(maybe_obj) {
  if (!maybe_obj) return maybe_obj;
  if (typeof maybe_obj != "object") return maybe_obj;
  if (maybe_obj.constructor !== Object) {
    if (Array.isArray(maybe_obj)) return maybe_obj.map(item => $b2c9f99c083a1182$export$12b4c6cbc6b8b4e4(item));
    return maybe_obj;
  }
  const cloned_obj = {};
  const sorted_keys = Object.keys(maybe_obj).sort();
  for (let i = 0; i < sorted_keys.length; i++) {
    const key = sorted_keys[i];
    const value = maybe_obj[key];
    cloned_obj[key] = $b2c9f99c083a1182$export$12b4c6cbc6b8b4e4(value);
  }
  return cloned_obj;
}

/**
 * Tries to figure out the tenant's market (`TwoLetterMarket` for new integrations) through various means.
 *
 * 1. Checks if there is a market in one of the url segments (www.tentant.se/foo/se/bar)
 * 2. Checks if the market is specified in the tenant's domain name (www.tenant-se.com)
 * 3. Checks the toplevel domain (www.tenant.se/foo/bar)
 *
 * @param allowed_markets An array the possible markets for the tenant.
 *    Dont forget to specify the allowed market as const (`["se", "en"] as const`) to get the best typing
 * @param url Specify this to overide the url to check, defaults to the current url
 * @param tenant The tenant's name
 * @returns If a market specified in `allowed_markets`was found that is returned, `undefined` otherwise
 */
function $95b71532fa7f905c$export$a422d714c8cb1a5d(allowed_markets, url) {
  let tenant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : process.env.TENANT;
  const u_o = url ? new URL(url) : location;
  const {
    hostname: hostname
  } = u_o;
  const is_demosite = process.env.DEBUG === "true" && hostname.endsWith("demo.depict.ai");
  // strategy 0: demo sites
  if (is_demosite) {
    const last_in_orig_site = hostname.replace("demo.depict.ai", "").split("-").pop();
    if (allowed_markets.includes(last_in_orig_site)) return last_in_orig_site;
  }
  // strategy 1 pathname startsWith
  const {
    pathname: pathname
  } = u_o;
  const market = allowed_markets.find(v => pathname.startsWith("/" + v + "/") || pathname === "/" + v);
  if (market) return market;
  // strategy 2 <tenant><divider><market>
  if (tenant) {
    const e = new RegExp(tenant + "[.-]" + "(".concat(allowed_markets.join("|"), ")"));
    const matches = hostname.match(e);
    if (matches !== null && matches !== void 0 && matches[1]) return matches[1];
  }
  // strategy 3 top level domain
  const tld = hostname.split(".").pop();
  if (allowed_markets.includes(tld)) return tld;
  // strategy 4 html lang attribute
  const lang_attr = document.documentElement.lang;
  if (lang_attr) {
    const e = new RegExp("".concat(allowed_markets.join("|")));
    const matches = lang_attr.toLowerCase().match(e);
    if (matches !== null && matches !== void 0 && matches[0]) return matches[0];
  }
  if (is_demosite)
    // hail mary attempt to get something to run
    return "se";
}
function $cb3a51d87cbe5eff$export$3427ec8268623f1(listener) {
  if (!$5f31622ffb78bc10$export$b87d7e0da8b5cbe3()) {
    $241f2f02cc612a49$export$de56f1198d121036("Not hooking localStorage as it would freeze it due to lacking Proxy support");
    return;
  }
  const caught_listener = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(listener);
  let changed_instance;
  const update_changed_instance = () => changed_instance = Storage.prototype.setItem !== localStorage.setItem;
  update_changed_instance();
  const orig_storage = localStorage;
  const proxied_set_items = new WeakMap();
  const changed_this_args = new WeakSet();
  const create_setItem_proxy = setItem_fn => {
    if (proxied_set_items.has(setItem_fn)) return proxied_set_items.get(setItem_fn);
    const proxied_fn = new Proxy(setItem_fn, {
      apply(target, this_arg, arg_list) {
        // this function can also run on sessionStorage.setItem, hence this check
        if (this_arg === proxied_localStorage || this_arg === orig_storage) {
          caught_listener(...arg_list);
          return target.apply(orig_storage, arg_list);
        }
        return target.apply(this_arg, arg_list);
      }
    });
    proxied_set_items.set(setItem_fn, proxied_fn);
    return proxied_fn;
  };
  // stolen from src/nordicagolf/repairing_their_cart.ts, which was in turn
  // stolen from stackoverflow but let's give credit to this instead because I didn't find the post again: https://gist.github.com/mynameislau/b7eabfcdc0a17ac41cdc0b974f94d807
  // much adapted after that, probably no longer that similar
  const proxied_localStorage = new Proxy(orig_storage, {
    set(storage, key, value) {
      caught_listener(key, value);
      storage[key] = value;
      if (key === "setItem") update_changed_instance();
      return true;
    },
    get(storage, key) {
      const orig_value = storage[key];
      if (typeof orig_value === "function") {
        if (key === "setItem") {
          if (changed_instance) return create_setItem_proxy(orig_value);else return orig_value; // will have been proxied with create_setItem_proxy in Storage.prototype further down
        }

        if (!changed_this_args.has(orig_value)) return new Proxy(orig_value, {
          // for some reason all functions like getItem throw when called with `this` being a proxied Storage Object
          apply(target, this_arg, arg_list) {
            return target.apply(this_arg === proxied_localStorage ? orig_storage : this_arg, arg_list);
          }
        });
      }
      return orig_value;
    }
  });
  Object.defineProperty(window, "localStorage", {
    configurable: true,
    enumerable: true,
    value: proxied_localStorage
  });
  const storage_prototype = Storage.prototype;
  storage_prototype.setItem = create_setItem_proxy(storage_prototype.setItem);
  for (const key in storage_prototype) try {
    const value = storage_prototype[key];
    if (key !== "setItem" && typeof value === "function") {
      const fn_with_changed_this_arg = new Proxy(value, {
        apply(target, this_arg, arg_list) {
          return target.apply(this_arg === proxied_localStorage ? orig_storage : this_arg, arg_list);
        }
      });
      storage_prototype[key] = fn_with_changed_this_arg;
      changed_this_args.add(fn_with_changed_this_arg);
    }
  } catch (e) {
    if (key !== "length") $241f2f02cc612a49$export$de56f1198d121036(e);
  }
}

/**
 * Timeout a promise after `ms` milliseconds.
 * If the promise is timed out this function will return `undefined` and not throw.
 */
function $26145caeb41f1f7b$export$cd1adfb8059b5fcd(promise, ms) {
  const timeout = new Promise(res => setTimeout(res, ms));
  return Promise.race([promise, timeout]);
}
const $8a812fa4638e2832$var$get_voyado_id = () => {
  var _exec;
  const va = (_exec = /\b_vaI=([^;]+)/.exec(document.cookie)) === null || _exec === void 0 ? void 0 : _exec[1];
  return va || $d5f7352b58e0d737$export$61e7e1f11e96692f();
};
const $8a812fa4638e2832$export$a739d9a07da7f9ce = /*@__PURE__*/$5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
  $d5f7352b58e0d737$export$93ae15b1ae509334($8a812fa4638e2832$var$get_voyado_id);
});
var $c40fc6dc2c22b3c4$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<button>`);
function $c40fc6dc2c22b3c4$export$4a3043e508dd72f0(_ref) {
  let {
    children: children,
    ...attributes
  } = _ref;
  const button = (() => {
    var _el$ = $76EG6$getNextElement($c40fc6dc2c22b3c4$var$_tmpl$);
    $76EG6$spread(_el$, $76EG6$mergeProps(attributes, {
      "type": "button"
    }), false, true);
    $76EG6$insert(_el$, children);
    $76EG6$runHydrationEvents();
    return _el$;
  })();
  button.classList.add("show-more");
  return button;
}
var $a59cde169150d10b$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div class=slidein-backdrop>`),
  $a59cde169150d10b$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<div class=slidein><div class=header><span class=title></span><button class="close minor"></button></div><div class=body>`),
  $a59cde169150d10b$var$_tmpl$3 = /*#__PURE__*/$76EG6$template(`<div class=depict><!$><!/><!$><!/>`);
async function $a59cde169150d10b$export$8a0e4d6f6abf7e90(_ref) {
  let {
    title_: title_,
    children: children,
    CloseIcon: CloseIcon
  } = _ref;
  // TODO: make so once can't accidentally have multiple at once
  let close_;
  const open_promise = new Promise(r => close_ = r);
  const body = await (0, $90fa633a9564f115$export$b6ae1bc530f4c149).wait_for_element("body");
  const backdrop = (() => {
    var _el$ = $76EG6$getNextElement($a59cde169150d10b$var$_tmpl$);
    $76EG6$addEventListener(_el$, "click", close_, true);
    $76EG6$runHydrationEvents();
    return _el$;
  })();
  const [exit_title_iterator, exitable_title_iterator] = $fee212025270d5b9$export$927664b47117acb0(title_);
  const closing_handlers = [exit_title_iterator];
  const slidein = (() => {
    var _el$2 = $76EG6$getNextElement($a59cde169150d10b$var$_tmpl$2),
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.firstChild,
      _el$5 = _el$4.nextSibling,
      _el$6 = _el$3.nextSibling;
    $76EG6$insert(_el$4, () => $332ef338faf216a4$export$7c081fdbc65b6a2a(exitable_title_iterator, false));
    $76EG6$addEventListener(_el$5, "click", close_, true);
    $76EG6$insert(_el$5, CloseIcon);
    $76EG6$insert(_el$6, children);
    $76EG6$runHydrationEvents();
    return _el$2;
  })();
  const elements_in_container = (() => {
    var _el$7 = $76EG6$getNextElement($a59cde169150d10b$var$_tmpl$3),
      _el$8 = _el$7.firstChild,
      [_el$9, _co$] = $76EG6$getNextMarker(_el$8.nextSibling),
      _el$10 = _el$9.nextSibling,
      [_el$11, _co$2] = $76EG6$getNextMarker(_el$10.nextSibling);
    $76EG6$insert(_el$7, backdrop, _el$9, _co$);
    $76EG6$insert(_el$7, slidein, _el$11, _co$2);
    return _el$7;
  })();
  body.append(elements_in_container);
  backdrop.animate({
    opacity: [0, 1]
  }, {
    easing: "ease-in",
    duration: 260
  });
  slidein.animate({
    transform: ["translateX(50%) scaleX(0.6)", "translateX(0) scaleX(1)"],
    opacity: [0, 1]
  }, {
    easing: "ease-in",
    duration: 220
  });
  const handler = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(_ref2 => {
    let {
      key: key
    } = _ref2;
    if (key === "Escape")
      // make pressing escape close the slidein
      close_();
  });
  window.addEventListener("keydown", handler);
  open_promise.then($5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
    window.removeEventListener("keydown", handler);
    backdrop.animate({
      opacity: [1, 0]
    }, {
      easing: "ease-out",
      duration: 200,
      fill: "forwards"
    });
    slidein.animate({
      transform: ["translateX(0) scaleX(1)", "translateX(50%) scaleX(0.6)"],
      opacity: [1, 0]
    }, {
      easing: "ease-out",
      duration: 220
    }).addEventListener("finish", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
      elements_in_container.remove();
      closing_handlers.forEach(handler => handler());
    }));
  }));
  return {
    close_: close_,
    on_close_: fn => closing_handlers.push(fn)
  };
}
$76EG6$delegateEvents(["click"]);
var $24f3fd73864991c0$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div class=option-list>`),
  $24f3fd73864991c0$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<button type=button><span class=size></span><!$><!/>`),
  $24f3fd73864991c0$var$_tmpl$3 = /*#__PURE__*/$76EG6$template(`<span class=sold-out>`);
async function $24f3fd73864991c0$export$c068ad5361be7646(_ref) {
  let {
    title_: title_,
    items_: items_,
    out_of_stock_text_: out_of_stock_text_,
    CloseIcon: CloseIcon
  } = _ref;
  const [exit_oos_iterator, exitable_oos_iterator] = $fee212025270d5b9$export$927664b47117acb0(out_of_stock_text_);
  // eslint-disable-line  no-async-promise-executor
  return new Promise($5e1f45affc1d7def$export$b3bbfd758f11cfa9(async size_selected => {
    const {
      close_: close_,
      on_close_: on_close_
    } = await $a59cde169150d10b$export$8a0e4d6f6abf7e90({
      CloseIcon: CloseIcon,
      title_: title_,
      children: [(() => {
        var _el$ = $76EG6$getNextElement($24f3fd73864991c0$var$_tmpl$);
        $76EG6$insert(_el$, () => items_.map(_ref2 => {
          let {
            size_name_: size_name_,
            is_available_: is_available_,
            id_: id_
          } = _ref2;
          const button = (() => {
            var _el$2 = $76EG6$getNextElement($24f3fd73864991c0$var$_tmpl$2),
              _el$3 = _el$2.firstChild,
              _el$4 = _el$3.nextSibling,
              [_el$5, _co$] = $76EG6$getNextMarker(_el$4.nextSibling);
            _el$2.$$click = () => {
              size_selected(id_);
              close_();
            };
            $76EG6$className(_el$2, "option" + (is_available_ ? " available" : ""));
            $76EG6$insert(_el$3, size_name_);
            $76EG6$insert(_el$2, !is_available_ && (() => {
              var _el$6 = $76EG6$getNextElement($24f3fd73864991c0$var$_tmpl$3);
              $76EG6$insert(_el$6, () => $332ef338faf216a4$export$7c081fdbc65b6a2a(exitable_oos_iterator));
              return _el$6;
            })(), _el$5, _co$);
            $76EG6$runHydrationEvents();
            return _el$2;
          })();
          if (!is_available_) button.disabled = true;
          return button;
        }));
        return _el$;
      })()]
    });
    on_close_(size_selected);
    on_close_(exit_oos_iterator);
  }));
}
$76EG6$delegateEvents(["click"]);
var $aae9878972b17321$exports = {};
$aae9878972b17321$exports = ".depict-placeholder {\n  will-change: mask, -webkit-mask;\n  mask-position-x: 125%;\n  mask-position-y: center;\n  background: #ddd;\n  animation: 1.5s linear infinite depict-placeholder;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n  -webkit-mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) 125% / 300% 100%;\n  -webkit-mask-image: ;\n  mask-image: ;\n  -webkit-mask-size: ;\n  mask-size: ;\n}\n\n@keyframes depict-placeholder {\n  0% {\n    mask-position-x: 125%;\n    -webkit-mask-position-x: 125%;\n  }\n\n  10% {\n    mask-position-x: 125%;\n    -webkit-mask-position-x: 125%;\n  }\n\n  90% {\n    mask-position-x: -25%;\n    -webkit-mask-position-x: -25%;\n  }\n\n  100% {\n    mask-position-x: -25%;\n    -webkit-mask-position-x: -25%;\n  }\n}\n\n";
var $adc0bb548fdb574f$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div>`);
let $adc0bb548fdb574f$var$inserted = false;
const $adc0bb548fdb574f$export$84712d0562a614b8 = _ref => {
  let {
    width: width,
    height = "1em",
    class: extra_classes,
    style = "",
    ...attributes
  } = _ref;
  if (!$adc0bb548fdb574f$var$inserted) {
    // Insert styling on first import
    $1013f2e568f87406$export$59ba1eb2c083f0cd((0, /*@__PURE__*/$parcel$interopDefault($aae9878972b17321$exports)));
    $adc0bb548fdb574f$var$inserted = true;
  }
  return (() => {
    var _el$ = $76EG6$getNextElement($adc0bb548fdb574f$var$_tmpl$);
    $76EG6$className(_el$, "depict-placeholder".concat(extra_classes ? " " + extra_classes : ""));
    $76EG6$spread(_el$, attributes, false, false);
    $76EG6$effect(_$p => $76EG6$style(_el$, style ? style : "width:".concat(width, ";height:").concat(height, ";"), _$p));
    $76EG6$runHydrationEvents();
    return _el$;
  })();
};
const $adc0bb548fdb574f$export$d613f5b6d0a331a8 = _ref2 => {
  let {
    aspect_ratio: aspect_ratio,
    ...attributes
  } = _ref2;
  return $76EG6$createComponent($adc0bb548fdb574f$export$84712d0562a614b8, $76EG6$mergeProps({
    style: "position:relative;width:100%;padding-bottom:".concat(1 / aspect_ratio * 100, "%")
  }, attributes));
};
var $2e6ca552eb0e0b2b$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div class="depict recommendation_container"><!$><!/><div class=grid>`),
  $2e6ca552eb0e0b2b$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<h4 class=recs_header>`);
const $2e6ca552eb0e0b2b$export$97f31f44c68c1d5 = function (title) {
  let surface_classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return $a285401a927e4306$export$eb0b9ed911409b57(e => e.classList.add(...surface_classes), (() => {
    var _el$ = $76EG6$getNextElement($2e6ca552eb0e0b2b$var$_tmpl$),
      _el$3 = _el$.firstChild,
      [_el$4, _co$] = $76EG6$getNextMarker(_el$3.nextSibling),
      _el$2 = _el$4.nextSibling;
    $76EG6$insert(_el$, title && typeof title === "string" ? (() => {
      var _el$5 = $76EG6$getNextElement($2e6ca552eb0e0b2b$var$_tmpl$2);
      $76EG6$insert(_el$5, title);
      return _el$5;
    })() : title, _el$4, _co$);
    return _el$;
  })());
};
var $ad0b2591dac160be$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<svg viewBox="0 0 320 512"><desc>Right arrow</desc><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z">`),
  $ad0b2591dac160be$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<svg viewBox="0 0 320 512"><desc>Left arrow</desc><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">`);
const $ad0b2591dac160be$export$32a55d57d151bc5a = () => $76EG6$getNextElement($ad0b2591dac160be$var$_tmpl$);
const $ad0b2591dac160be$export$ddd70fdae1b350e6 = () => $76EG6$getNextElement($ad0b2591dac160be$var$_tmpl$2);
var $9a74c17d1ef21fdf$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<button class=color-circle-container><div class=outer-circle><div class=inner-circle>`),
  $9a74c17d1ef21fdf$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<div class=color-picker role=form aria-label="Color picker">`);
/**
 * Internal color circle used in ColorPicker
 * @see {createColorPicker}
 */
function $9a74c17d1ef21fdf$var$ColorCircle(_ref) {
  let {
    color: color,
    onClick: onClick,
    onHoverUpdate: onHoverUpdate
  } = _ref;
  const button = (() => {
    var _el$ = $76EG6$getNextElement($9a74c17d1ef21fdf$var$_tmpl$),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild;
    _el$.$$click = e => onClick(e.currentTarget, color);
    $76EG6$effect(_p$ => {
      var _v$ = color.label || "",
        _v$2 = "border-color: ".concat(color.value, ";"),
        _v$3 = "background-color: ".concat(color.value, ";");
      _v$ !== _p$.e && $76EG6$setAttribute(_el$, "title", _p$.e = _v$);
      _p$.t = $76EG6$style(_el$2, _v$2, _p$.t);
      _p$.a = $76EG6$style(_el$3, _v$3, _p$.a);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined
    });
    $76EG6$runHydrationEvents();
    return _el$;
  })();
  button.addEventListener("mouseenter", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => onHoverUpdate(button, color, true)));
  button.addEventListener("mouseleave", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => onHoverUpdate(button, color, false)));
  return button;
}
function $9a74c17d1ef21fdf$export$590326cc34f49e2d(_ref2) {
  let {
    colors: colors,
    initialColor: initialColor,
    onSelect: onSelect,
    selectOnHover = false,
    onHoverUpdate: onHoverUpdate,
    dontSetActiveOnClick: dontSetActiveOnClick,
    onlyCircles: onlyCircles
  } = _ref2;
  let setActiveIndex;
  // Don't actually construct anything if the component we return isn't used
  return {
    setActiveIndex: index => {
      var _setActiveIndex;
      return (_setActiveIndex = setActiveIndex) === null || _setActiveIndex === void 0 ? void 0 : _setActiveIndex(index);
    },
    ColorPicker() {
      /** The currently active ColorCircle */let activeCircle = null;
      /** The currently active color object */
      let activeColor = null;
      /**
      * Update the currently active color object and HTMLElement
      * Toggles the active class.
      */
      const setActive = (e, color) => {
        if (e !== activeCircle) {
          if (activeCircle) activeCircle.classList.remove("active");
          e.classList.add("active");
          activeCircle = e;
          activeColor = color;
        }
      };
      const handleClick = function (clicked, color) {
        if (!dontSetActiveOnClick) setActive(clicked, color);
        onSelect(color);
      };
      /**
      * Handles the preview logic.
      */
      const handleSelectOnHover = (hovered, color, hovering) => {
        // Don't do any selection if the hovered circle is already selected
        if (hovered === activeCircle) return;
        if (hovering) onSelect(color); // mouseenter - select a new color
        else if (activeColor) onSelect(activeColor); // mouseleave - select the last activeColor
      };

      const handleHoverUpdate = function (hovered, color, hovering) {
        // Pass the event up
        if (onHoverUpdate) onHoverUpdate(color, hovering);
        // If enabled, select the hovered color
        if (selectOnHover) handleSelectOnHover(hovered, color, hovering);
      };
      // Create the color circles
      const circles = colors.map(color => $76EG6$createComponent($9a74c17d1ef21fdf$var$ColorCircle, {
        color: color,
        onClick: handleClick,
        onHoverUpdate: handleHoverUpdate
      }));
      // Function to set active color to an index
      setActiveIndex = index => setActive(circles[index], colors[index]);
      // Set the initial color, if any
      const initial_index = initialColor == undefined ? -1 : colors.findIndex(c => typeof initialColor === "string" ? c.value === initialColor : c.value === initialColor.value && c.label === initialColor.label);
      if (initial_index > -1) setActiveIndex(initial_index);
      if (onlyCircles) return circles;
      return (() => {
        var _el$4 = $76EG6$getNextElement($9a74c17d1ef21fdf$var$_tmpl$2);
        $76EG6$insert(_el$4, circles);
        return _el$4;
      })();
    }
  };
}
$76EG6$delegateEvents(["click"]);
var $0f55c2bc0a7b363b$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div>`),
  $0f55c2bc0a7b363b$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<div style=overflow:hidden;height:0px;visibility:hidden aria-hidden=true>`);
const $0f55c2bc0a7b363b$export$237455ad7e59d4e5 = function () {
  let {
    duration = 500,
    delay = 0
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    duration: 500,
    delay: 0
  };
  let outerRef;
  let innerRef;
  let current_animation;
  const child_computed_style = () => {
    if (innerRef.childNodes.length === 1) {
      const [first_child] = innerRef.children;
      if (first_child instanceof Element) return getComputedStyle(first_child);
    }
  };
  const get_height = () => (child_computed_style() ? parseInt(child_computed_style().marginTop) + parseInt(child_computed_style().marginBottom) + parseInt(child_computed_style().height) : innerRef.clientHeight) + "px";
  const get_current_height_possibly_during_transition = () => (child_computed_style() && outerRef.style.overflow !== "hidden" ? parseInt(child_computed_style().marginBottom) + parseInt(child_computed_style().marginTop) // don't ask me why we need to do this 😭 but I'm sure it works
  : 0) + outerRef.clientHeight + "px";
  const ExpandingContainer = _ref => {
    let {
      children: children
    } = _ref;
    if (Array.isArray(children) && children.length === 1) children = children[0];
    innerRef = (() => {
      var _el$ = $76EG6$getNextElement($0f55c2bc0a7b363b$var$_tmpl$);
      $76EG6$insert(_el$, children);
      return _el$;
    })();
    outerRef = (() => {
      var _el$2 = $76EG6$getNextElement($0f55c2bc0a7b363b$var$_tmpl$2);
      $76EG6$insert(_el$2, innerRef);
      return _el$2;
    })();
    return outerRef;
  };
  const expand = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(async function () {
    var _current_animation, _current_animation$ca;
    let expanding_delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : delay;
    let time_to_expand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : duration;
    const start = get_current_height_possibly_during_transition(); // need to read this before cancelling the old animation
    outerRef.style.visibility = "";
    outerRef.removeAttribute("aria-hidden");
    (_current_animation = current_animation) === null || _current_animation === void 0 || (_current_animation$ca = _current_animation.cancel) === null || _current_animation$ca === void 0 || _current_animation$ca.call(_current_animation); // cancel already running animation so it doesn't get a finish event while we're still animating
    const animation = outerRef.animate({
      height: [start, get_height()]
    }, {
      duration: time_to_expand,
      delay: expanding_delay,
      easing: "ease-in"
    });
    current_animation = animation;
    animation.addEventListener("finish", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
      current_animation = undefined;
      outerRef.style.overflow = "";
      outerRef.style.height = "auto";
    }));
    return animation;
  });
  const collapse = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(async function () {
    var _current_animation2, _current_animation2$c;
    let collapsing_delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : delay;
    let time_to_collapse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : duration;
    const start = get_current_height_possibly_during_transition();
    (_current_animation2 = current_animation) === null || _current_animation2 === void 0 || (_current_animation2$c = _current_animation2.cancel) === null || _current_animation2$c === void 0 || _current_animation2$c.call(_current_animation2);
    outerRef.style.overflow = "hidden";
    outerRef.ariaHidden = "true";
    const animation = outerRef.animate({
      height: [start, "0px"]
    }, {
      duration: time_to_collapse,
      delay: collapsing_delay,
      easing: "ease-out"
    });
    current_animation = animation;
    animation.addEventListener("finish", $5e1f45affc1d7def$export$b3bbfd758f11cfa9(() => {
      current_animation = undefined;
      outerRef.style.height = "0";
      outerRef.style.visibility = "hidden";
    }));
    return animation;
  });
  return {
    ExpandingContainer: ExpandingContainer,
    expand: expand,
    collapse: collapse
  };
};
var $5305cfbbfffd9dc8$exports = {};
$5305cfbbfffd9dc8$exports = ".depict-img-cont {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n\n.depict-img-filler {\n  width: 100%;\n  height: auto;\n  display: inline-block;\n}\n\n.depict-img-comp {\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  max-height: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.depict-img-mod {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n";
var $9ef5ce4804a3b61b$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<img>`),
  $9ef5ce4804a3b61b$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<source sizes=0px>`),
  $9ef5ce4804a3b61b$var$_tmpl$3 = /*#__PURE__*/$76EG6$template(`<picture>`);
const $9ef5ce4804a3b61b$export$3d13beba9b52c947 = "https://img.depict.ai/ResizeImage" + (process.env.TENANT ? "/" + process.env.TENANT : "");
const $9ef5ce4804a3b61b$export$a98fc8a2c818d3d8 = /*@__PURE__*/(() => typeof navigator === "undefined" ? false : /^((?!chrome|android).)*safari/i.test(navigator.userAgent))(); // https://stackoverflow.com/a/23522755
function $9ef5ce4804a3b61b$export$f39a7d0667e924a(what_to_watch) {
  let sizes_communicator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7ca6fdc721083788$export$e806c6c1615a59ae();
  let resolution_factor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  let currently_live = false;
  const ro = new ResizeObserver($5e1f45affc1d7def$export$b3bbfd758f11cfa9(records => {
    for (let j = 0; j < records.length; j++) {
      const {
        width: width
      } = records[j].contentRect;
      if (!width) continue;
      // add extra 5% just in case. + safari is (in some cases) acting a bit questionable and needs a third extra to fill the set width
      const new_size = width * 1.05 * ($9ef5ce4804a3b61b$export$a98fc8a2c818d3d8 ? 4 / 3 : 1) * resolution_factor;
      sizes_communicator(Math.round(new_size));
    }
  }));
  // start and stop ResizeObserver to make sure we're not hindering GC
  (0, $90fa633a9564f115$export$b6ae1bc530f4c149).oncreation(what_to_watch, _ref => {
    let {
      element: element
    } = _ref;
    ro.observe(element);
    currently_live = true;
  });
  (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onremoved(what_to_watch, () => {
    ro.disconnect();
    sizes_communicator.exit();
    currently_live = false;
  });
  if (document.documentElement.contains(what_to_watch)) {
    ro.observe(what_to_watch); // if already in DOM, start observing directly
    currently_live = true;
  }
  const start_updating_sizes_of_el = async el_to_resize => {
    for await (const target_size of sizes_communicator) {
      const target_size_in_px = target_size + "px";
      el_to_resize.sizes && (el_to_resize.sizes = target_size_in_px) || el_to_resize.setAttribute("sizes", target_size_in_px);
    }
  };
  return async el_to_resize => {
    const weakrefd_el_to_resize = new WeakRef(el_to_resize);
    // if the watched el exits it will run .exit on the IPNS and exit the iterators.
    // then if it's recreated, the observer below will restart the iterators.
    (0, $90fa633a9564f115$export$b6ae1bc530f4c149).oncreation(what_to_watch, async _ref2 => {
      let {
        disconnector: disconnector
      } = _ref2;
      const el_to_update = weakrefd_el_to_resize.deref();
      if (!el_to_update) {
        disconnector(); // we're useless, el got GCd
        return;
      }
      await start_updating_sizes_of_el(el_to_update);
    });
    if (currently_live) await start_updating_sizes_of_el(el_to_resize);
    // FYI: this will still hold strong references to the els that get their sizes attribute set until the watched el is removed from the DOM and GC'd. I wrote a version before where that's not the case which you can find here: https://gitlab.com/depict-ai/depict.ai/-/merge_requests/1901/diffs?commit_id=111d72c0f58777786dfcc00cc18d76cb0ac96c7c and I didn't end up using because I think it's wasting too many CPU cycles
  };
}

function $9ef5ce4804a3b61b$export$a62825542f1bfcf5() {
  let {
    what_to_watch: what_to_watch,
    set_dataset = true,
    formats = ["webp", "jpeg"],
    resolutions = [64, 128, 256, 300, 400, 512, 1024, 2048, 4096],
    sizes_communicator: sizes_communicator,
    resolution_factor: resolution_factor,
    market_: market_,
    sizes_setter_: sizes_setter_
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  /**
  * We support what_to_watch being optional, meaning we will take the first image we get.
  * For that we need to have created the image before being able to create the sizes setter.
  */
  const local_base_url = market_ ? $9ef5ce4804a3b61b$export$3d13beba9b52c947 + "/" + market_ : $9ef5ce4804a3b61b$export$3d13beba9b52c947;
  return image_options => {
    const raw_src = (image_options === null || image_options === void 0 ? void 0 : image_options.src) || (image_options === null || image_options === void 0 ? void 0 : image_options["data-src"]); // get wanted src
    const src = new URL(raw_src, location.origin).href;
    if (!src) {
      $241f2f02cc612a49$export$de56f1198d121036(image_options, () => {}); // noop function is to allow to get here quickly by "jump to function definition"
      $b000f5ef6ce456d9$export$8048b892d651b310(new Error("no image src provided: " + src));
      return (() => {
        var _el$ = $76EG6$getNextElement($9ef5ce4804a3b61b$var$_tmpl$);
        $76EG6$spread(_el$, image_options, false, false);
        $76EG6$runHydrationEvents();
        return _el$;
      })(); // we don't want everything to fail if someone misused this component
    }
    // Create an array of elements that will get their `sizes` attribute updated when what_to_watch resizes
    const sources = [];
    // Create <source> tags for all wanted formats
    for (let i = 0; i < formats.length; i++) {
      // Much faster than .map and this will run kinda often
      const format = formats[i];
      const srcset = $9ef5ce4804a3b61b$var$make_srcset(src, format, resolutions);
      sources.push((() => {
        var _el$2 = $76EG6$getNextElement($9ef5ce4804a3b61b$var$_tmpl$2);
        $76EG6$setAttribute(_el$2, "type", "image/".concat(format));
        $76EG6$spread(_el$2, set_dataset ? {
          "data-srcset": srcset
        } : {
          srcset: srcset
        }, false, false);
        $76EG6$runHydrationEvents();
        return _el$2;
      })());
    }
    const opts_without_src = {
      ...image_options
    }; // Prevents the image from instantly loading the original source
    delete opts_without_src["src"];
    delete opts_without_src["srcset"];
    const the_image = (() => {
      var _el$3 = $76EG6$getNextElement($9ef5ce4804a3b61b$var$_tmpl$);
      $76EG6$spread(_el$3, opts_without_src, false, false);
      $76EG6$runHydrationEvents();
      return _el$3;
    })(); // create image
    sources.push(the_image); // chrome seems to be the dumbest piece of cake that has ever existed and just load the first source?????
    what_to_watch || (what_to_watch = the_image);
    sizes_setter_ || (sizes_setter_ = $9ef5ce4804a3b61b$export$f39a7d0667e924a(what_to_watch, sizes_communicator, resolution_factor)); // now we can finally create the sizes_setter
    // start a sizes_setter for every source (including fallback image)
    for (let i = 0; i < sources.length; i++) sizes_setter_(sources[i]).catch((0, $b000f5ef6ce456d9$export$8048b892d651b310));
    // embed all sources into a <picture> so that the browser understands they're "together"
    const picture = (() => {
      var _el$4 = $76EG6$getNextElement($9ef5ce4804a3b61b$var$_tmpl$3);
      $76EG6$insert(_el$4, sources);
      return _el$4;
    })();
    // Create src and srcset for fallback image and set it.
    // This is so that the browser doesn't start loading the fallback image for fun (chrome loads very eagerly)
    const fallback_src = $9ef5ce4804a3b61b$var$optimized_img_url_generator("png", src, 400);
    const fallback_srcset = $9ef5ce4804a3b61b$var$make_srcset(src, "png", resolutions, local_base_url);
    if (set_dataset) {
      the_image.dataset.srcset = fallback_srcset;
      the_image.dataset.src = fallback_src;
    } else {
      the_image.setAttribute("srcset", fallback_srcset);
      the_image.src = fallback_src;
    }
    return picture;
  };
}
function $9ef5ce4804a3b61b$export$f7c915448031deac(base, params) {
  // do this so we don't end up in escape hell
  const url_object = new URL(base, location.origin);
  const search = new URLSearchParams(Object.entries(params));
  url_object.search = search.toString();
  return url_object.href;
}
function $9ef5ce4804a3b61b$var$make_srcset(url, format, resolutions) {
  let local_base_url = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $9ef5ce4804a3b61b$export$3d13beba9b52c947;
  return resolutions.map(width => "".concat($9ef5ce4804a3b61b$var$optimized_img_url_generator(format, url, width), " ").concat(width, "w")).join(", ");
}
function $9ef5ce4804a3b61b$var$optimized_img_url_generator(format, url, width) {
  // using make_url_with_query_params takes ~100ms on CDON with 2 surfaces and hover images, we can't afford that when it could be essentially free
  return "".concat($9ef5ce4804a3b61b$export$3d13beba9b52c947, "?format=").concat(format, "&url=").concat(encodeURIComponent(url), "&width=").concat(width);
}
var $c987460cedc0d7ec$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div>`),
  $c987460cedc0d7ec$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<canvas class=depict-img-filler height=3000>`),
  $c987460cedc0d7ec$var$_tmpl$3 = /*#__PURE__*/$76EG6$template(`<div style=position:relative><div class=depict-img-cont></div><!$><!/>`);
const $c987460cedc0d7ec$var$rendering_options_to_sourceset_component = /*@__PURE__*/new WeakMap();
// Add nolazy to placeholders to avoid errors with the stupid lazyfier
const $c987460cedc0d7ec$var$add_nolazy_to_placeholder = type => type === "placeholder" ? "nolazy" : "";
const $c987460cedc0d7ec$export$a4eccf92efefa04d = function (image_width, image_height) {
  let color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "#f6f7f8";
  return "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='".concat(image_width, "' height='").concat(image_height, "' xmlns:v='https://vecta.io/nano'%3e%3cpath d='M0 0h").concat(image_width, ".016v").concat(image_height, ".01H0' fill='").concat(encodeURIComponent(color), "'/%3e%3c/svg%3e");
};
let $c987460cedc0d7ec$var$inserted = false;
const $c987460cedc0d7ec$export$788756b42446dc2d = _ref => {
  let {
    init_with_placeholder: init_with_placeholder,
    ...options
  } = _ref;
  if (!$c987460cedc0d7ec$var$inserted) {
    // Insert styling on first import
    $1013f2e568f87406$export$59ba1eb2c083f0cd((0, /*@__PURE__*/$parcel$interopDefault($5305cfbbfffd9dc8$exports)));
    $c987460cedc0d7ec$var$inserted = true;
  }
  const img = process.env.BUILD_TARGET === "modern" || process.env.BUILD_TARGET === "dev" ? $c987460cedc0d7ec$var$Image(options) : $c987460cedc0d7ec$var$CompatibleImage(options);
  if (init_with_placeholder)
    // 10000 is a magic value, that is just supposed to be bigger than the size of the actual image.
    img.querySelectorAll("img").forEach(i => i.src = $c987460cedc0d7ec$export$a4eccf92efefa04d(10000 * options.aspect_ratio, 10000));
  return img;
};
function $c987460cedc0d7ec$var$Image(_ref2) {
  var _image_options$src;
  let {
    aspect_ratio: aspect_ratio,
    alt: alt,
    remove_on_error: remove_on_error,
    rendering_options: rendering_options,
    srcset_opts: srcset_opts,
    init_with_placeholder: _,
    ...image_options
  } = _ref2;
  const div = (() => {
    var _el$ = $76EG6$getNextElement($c987460cedc0d7ec$var$_tmpl$);
    $76EG6$effect(_$p => $76EG6$style(_el$, "position:relative;width:100%;padding-bottom:".concat(1 / aspect_ratio * 100, "%"), _$p));
    return _el$;
  })();
  const sourceset_component = $c987460cedc0d7ec$var$srcset_comp_from_map_or_new(rendering_options, srcset_opts, div);
  const IMG_tag = (_image_options$src = image_options.src) !== null && _image_options$src !== void 0 && _image_options$src.startsWith("data:") || !sourceset_component ? "img" : sourceset_component;
  div.append($76EG6$createComponent(IMG_tag, $76EG6$mergeProps({
    alt: alt
  }, remove_on_error ? {
    onerror: "this.remove()"
  } : {}, image_options, {
    get ["class"]() {
      return $a285401a927e4306$export$22a65337c1b43b1f(["depict-img-mod ", image_options.class, $c987460cedc0d7ec$var$add_nolazy_to_placeholder(rendering_options === null || rendering_options === void 0 ? void 0 : rendering_options.type)]);
    }
  })));
  return div;
}
function $c987460cedc0d7ec$var$CompatibleImage(_ref3) {
  var _image_options$src2;
  let {
    aspect_ratio: aspect_ratio,
    alt: alt,
    remove_on_error: remove_on_error,
    rendering_options: rendering_options,
    srcset_opts: srcset_opts,
    ...image_options
  } = _ref3;
  const canvas = (() => {
    var _el$2 = $76EG6$getNextElement($c987460cedc0d7ec$var$_tmpl$2);
    $76EG6$setAttribute(_el$2, "width", 3000 * aspect_ratio);
    return _el$2;
  })();
  const sourceset_component = $c987460cedc0d7ec$var$srcset_comp_from_map_or_new(rendering_options, srcset_opts, canvas);
  const IMG_tag = (_image_options$src2 = image_options.src) !== null && _image_options$src2 !== void 0 && _image_options$src2.startsWith("data:") || !sourceset_component ? "img" : sourceset_component;
  return (() => {
    var _el$3 = $76EG6$getNextElement($c987460cedc0d7ec$var$_tmpl$3),
      _el$4 = _el$3.firstChild,
      _el$5 = _el$4.nextSibling,
      [_el$6, _co$] = $76EG6$getNextMarker(_el$5.nextSibling);
    $76EG6$insert(_el$4, $76EG6$createComponent(IMG_tag, $76EG6$mergeProps({
      alt: alt
    }, remove_on_error ? {
      onerror: "this.remove()"
    } : {}, image_options, {
      get ["class"]() {
        return $a285401a927e4306$export$22a65337c1b43b1f(["depict-img-comp", image_options.class, $c987460cedc0d7ec$var$add_nolazy_to_placeholder(rendering_options === null || rendering_options === void 0 ? void 0 : rendering_options.type)]);
      }
    })));
    $76EG6$insert(_el$3, canvas, _el$6, _co$);
    return _el$3;
  })();
}
function $c987460cedc0d7ec$var$srcset_comp_from_map_or_new(rendering_options) {
  let srcset_opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let canvas = arguments.length > 2 ? arguments[2] : undefined;
  let sourceset_component;
  if (typeof rendering_options == "object" && rendering_options) {
    var _rendering_options_to, _rendering_options_to2;
    sourceset_component = (_rendering_options_to = $c987460cedc0d7ec$var$rendering_options_to_sourceset_component.get(rendering_options)) === null || _rendering_options_to === void 0 ? void 0 : (_rendering_options_to2 = _rendering_options_to.deref) === null || _rendering_options_to2 === void 0 ? void 0 : _rendering_options_to2.call(_rendering_options_to);
    if (!sourceset_component) {
      const cloned_opts = {
        ...srcset_opts
      };
      cloned_opts.what_to_watch = canvas;
      sourceset_component = $9ef5ce4804a3b61b$export$a62825542f1bfcf5(cloned_opts);
      $c987460cedc0d7ec$var$rendering_options_to_sourceset_component.set(rendering_options, new WeakRef(sourceset_component));
    }
  }
  return sourceset_component;
}
var $8254bab8001eaa15$exports = {};
$8254bab8001eaa15$exports = ".depict .images-container {\n  position: relative;\n}\n\n.depict .second-image-container {\n  width: 100%;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n}\n\n.depict .hovering .main-image-container {\n  opacity: 0;\n}\n\n.depict .hovering .second-image-container {\n  opacity: 1;\n}\n\n";
var $73f0a7e385687d5d$var$_tmpl$ = /*#__PURE__*/$76EG6$template(`<div class=images-container><!$><!/><div class=main-image-container>`),
  $73f0a7e385687d5d$var$_tmpl$2 = /*#__PURE__*/$76EG6$template(`<div class=second-image-container>`);
// Saving bytez
// Maybe? @Daniel
const $73f0a7e385687d5d$var$TOUCHSTART = "touchstart";
const $73f0a7e385687d5d$var$TOUCHEND = "touchend";
const $73f0a7e385687d5d$var$TOUCHMOVE = "touchmove";
const $73f0a7e385687d5d$var$TOUCHCANCEL = "touchcancel";
const $73f0a7e385687d5d$var$MOUSEOVER = "mouseover";
const $73f0a7e385687d5d$var$MOUSELEAVE = "mouseleave";
const $73f0a7e385687d5d$var$HOVER_CLASS = "hovering";
/** This number represents how many elements are in front of div.images-container
 *  Here are the elements: img.depict-img-mod, div, img.depict-img-mod, div, div.second-image-container, div.main-image-container, div.images-container
 * This number is not very dynamic but much more performant than iterating
 */
const $73f0a7e385687d5d$var$HOVER_IMAGE_DEPTH = 7;
const $73f0a7e385687d5d$var$MAX_COLLISION_DETECTION_RATE = 70; // ms
const $73f0a7e385687d5d$var$touch_hover_elements = /*@__PURE__*/new WeakMap();
let $73f0a7e385687d5d$var$listening_for_mobile_hover = false;
function $73f0a7e385687d5d$var$register_element_for_touch_hover(el, navigation_minimum) {
  $73f0a7e385687d5d$var$touch_hover_elements.set(el, {
    navigation_minimum: navigation_minimum
  });
  if (!$73f0a7e385687d5d$var$listening_for_mobile_hover) {
    $73f0a7e385687d5d$var$start_checking_for_touch_hover();
    $73f0a7e385687d5d$var$listening_for_mobile_hover = true;
  }
}
function $73f0a7e385687d5d$var$start_checking_for_touch_hover() {
  const currently_hovering = new Map();
  const handle_touch_start = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(evt => {
    var _evt$changedTouches;
    const touch = evt === null || evt === void 0 ? void 0 : (_evt$changedTouches = evt.changedTouches) === null || _evt$changedTouches === void 0 ? void 0 : _evt$changedTouches[0];
    if (!touch) return; // Eytys dispatches fake touch events without changedTouches
    const id = touch.identifier;
    const {
      clientX: clientX,
      clientY: clientY
    } = touch;
    const hover_element = get_hover_element_from_coords(clientX, clientY);
    if (hover_element && $73f0a7e385687d5d$var$touch_hover_elements.has(hover_element)) {
      var _touch_hover_elements;
      hover_element.classList.add($73f0a7e385687d5d$var$HOVER_CLASS);
      $73f0a7e385687d5d$var$touch_hover_elements.set(hover_element, {
        navigation_minimum: (_touch_hover_elements = $73f0a7e385687d5d$var$touch_hover_elements.get(hover_element)) === null || _touch_hover_elements === void 0 ? void 0 : _touch_hover_elements.navigation_minimum
      });
      currently_hovering.set(id, {
        element_: hover_element,
        start_time_: +new Date(),
        start_x_: clientX,
        start_y_: clientY
      });
    }
  });
  let last_collision_check = +new Date();
  const handle_touch_move = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(evt => {
    var _evt$changedTouches2;
    const first_touch = evt === null || evt === void 0 ? void 0 : (_evt$changedTouches2 = evt.changedTouches) === null || _evt$changedTouches2 === void 0 ? void 0 : _evt$changedTouches2[0];
    if (!first_touch) return;
    const {
      identifier: identifier,
      clientY: clientY,
      clientX: clientX
    } = first_touch;
    const our_touch_data = currently_hovering.get(identifier);
    if (!our_touch_data) return;
    if (+new Date() - last_collision_check > $73f0a7e385687d5d$var$MAX_COLLISION_DETECTION_RATE) {
      last_collision_check = +new Date();
      // Checking if the finger has left the image
      if (get_hover_element_from_coords(clientX, clientY) !== our_touch_data.element_) clear_hover(identifier, our_touch_data, clientX, clientY);
    }
  });
  const handle_touch_cancel = $5e1f45affc1d7def$export$b3bbfd758f11cfa9(evt => {
    var _evt$changedTouches3;
    const touch = evt === null || evt === void 0 ? void 0 : (_evt$changedTouches3 = evt.changedTouches) === null || _evt$changedTouches3 === void 0 ? void 0 : _evt$changedTouches3[0];
    if (!touch) return;
    const id = touch.identifier;
    const info = currently_hovering.get(id);
    if (info) clear_hover(id, info, touch.clientX, touch.clientY);
  });
  const get_hover_element_from_coords = (clientX, clientY) => {
    const elements = document.elementsFromPoint(clientX, clientY);
    const hover_element = elements[$73f0a7e385687d5d$var$HOVER_IMAGE_DEPTH - 1];
    return hover_element && $73f0a7e385687d5d$var$touch_hover_elements.has(hover_element) ? hover_element : null;
  };
  const clear_hover = $5e1f45affc1d7def$export$b3bbfd758f11cfa9((id, info_about_touch, now_x, now_y) => {
    const {
      element_: element_,
      start_y_: start_y_,
      start_x_: start_x_,
      start_time_: start_time_
    } = info_about_touch;
    const info = $73f0a7e385687d5d$var$touch_hover_elements.get(element_);
    const now = +new Date();
    remove_hover_class: {
      emulate_click: {
        var _element_$closest;
        if (!(info !== null && info !== void 0 && info.navigation_minimum)) break emulate_click;
        const time_touched = now - start_time_;
        if (time_touched >= info.navigation_minimum) break emulate_click;
        // Just above checks led to oversensitive clicks, where a quick swipe in a slider led to product cards being clicked.
        // We're trying to avoid this by not clicking if the mouse moved much or fast
        // We're doing this whole click emulation because MobileSafari doesn't dispatch click events if we listen for touchmove (I *think* it's "move" specifically) so we basically have to emulate clicking heuristics
        // It seems like MobileSafari has a curve based on movement and speed that decides if something counts as a click, but we'll start with something more rudimentary
        const distance_travelled = Math.sqrt(Math.pow(start_x_ - now_x, 2) + Math.pow(start_y_ - now_y, 2)); // https://www.varsitytutors.com/calculus_3-help/distance-between-vectors
        // educated guess that moving the finger 20px will cancel the click regardless
        if (distance_travelled > 20) break emulate_click;
        const swipe_speed = distance_travelled / time_touched; // pixels per millisecond
        if (swipe_speed > 0.2) break emulate_click; // after some testing it feels like a faster swipe than 0.2px/ms would get cancelled by the OS so we cancel that too
        (_element_$closest = element_.closest("a")) === null || _element_$closest === void 0 || _element_$closest.click();
        break remove_hover_class; //we don’t want to see a quick flash of hover if we’re navigating since that looks bad
      }

      element_.classList.remove($73f0a7e385687d5d$var$HOVER_CLASS);
    }
    currently_hovering.delete(id);
  });
  window.addEventListener($73f0a7e385687d5d$var$TOUCHSTART, handle_touch_start);
  window.addEventListener($73f0a7e385687d5d$var$TOUCHMOVE, handle_touch_move);
  window.addEventListener($73f0a7e385687d5d$var$TOUCHEND, handle_touch_cancel);
  window.addEventListener($73f0a7e385687d5d$var$TOUCHCANCEL, handle_touch_cancel);
}
let $73f0a7e385687d5d$var$styling_inserted = false;
const $73f0a7e385687d5d$export$2369f6fc1c911576 = _ref => {
  let {
    second_src: second_src,
    second_srcset: second_srcset,
    second_srcset_opts: second_srcset_opts,
    fade_length_seconds: fade_length_seconds,
    mobile_touch_hover: mobile_touch_hover,
    navigation_minimum_ms = 100,
    ...options
  } = _ref;
  if (!$73f0a7e385687d5d$var$styling_inserted) {
    $1013f2e568f87406$export$59ba1eb2c083f0cd((0, /*@__PURE__*/$parcel$interopDefault($8254bab8001eaa15$exports)));
    $73f0a7e385687d5d$var$styling_inserted = true;
  }
  const main_image = $c987460cedc0d7ec$export$788756b42446dc2d({
    ...options
  });
  const second_image = $c987460cedc0d7ec$export$788756b42446dc2d({
    ...options,
    [(second_srcset_opts === null || second_srcset_opts === void 0 ? void 0 : second_srcset_opts.set_dataset) === false ? "src" : "data-src"]: second_src || "",
    [(second_srcset_opts === null || second_srcset_opts === void 0 ? void 0 : second_srcset_opts.set_dataset) === false ? "srcset" : "data-srcset"]: second_srcset || "",
    srcset_opts: second_srcset_opts || {}
  });
  const no_second_img = !second_src && !second_srcset && !second_srcset_opts;
  const images_container = (() => {
    var _el$ = $76EG6$getNextElement($73f0a7e385687d5d$var$_tmpl$),
      _el$3 = _el$.firstChild,
      [_el$4, _co$] = $76EG6$getNextMarker(_el$3.nextSibling),
      _el$2 = _el$4.nextSibling;
    $76EG6$insert(_el$, !no_second_img && (() => {
      var _el$5 = $76EG6$getNextElement($73f0a7e385687d5d$var$_tmpl$2);
      $76EG6$insert(_el$5, second_image);
      return _el$5;
    })(), _el$4, _co$);
    $76EG6$insert(_el$2, main_image);
    return _el$;
  })();
  if (no_second_img) return images_container;
  const hover_element = images_container;
  const event_handler_mouse = _ref2 => {
    let {
      type: type
    } = _ref2;
    if (type == $73f0a7e385687d5d$var$MOUSEOVER) {
      images_container.classList.add($73f0a7e385687d5d$var$HOVER_CLASS);
      hover_element.addEventListener($73f0a7e385687d5d$var$MOUSELEAVE, event_handler_mouse, {
        once: true
      });
    } else if (type == $73f0a7e385687d5d$var$MOUSELEAVE) images_container.classList.remove($73f0a7e385687d5d$var$HOVER_CLASS);
  };
  hover_element.addEventListener($73f0a7e385687d5d$var$MOUSEOVER, event_handler_mouse);
  if (mobile_touch_hover) $73f0a7e385687d5d$var$register_element_for_touch_hover(hover_element, navigation_minimum_ms);
  if (fade_length_seconds) Array.from(images_container.children).forEach(container => {
    container.style.transition = "opacity ".concat(fade_length_seconds, "s");
  });
  return images_container;
};

/**
 * Shallowly converts all keys in an object from snake_case to camelCase.
 * Does not support symbol keys.
 *
 * @param obj the object. It will be cloned and not modified in-place.
 */
function $c07f1f2ffdcaec61$export$9dc8f3a0aa3efc85(obj) {
  return Object.fromEntries(Object.entries(obj).map(_ref => {
    let [key, value] = _ref;
    return [key.split("_").map((part, index) => index ? part[0].toUpperCase() + part.slice(1) : part).join(""), value];
  }));
}
function $c07f1f2ffdcaec61$export$b481488de1caa85(obj) {
  return Object.fromEntries(Object.entries(obj).map(_ref2 => {
    let [key, value] = _ref2;
    return [key.replace(/[A-Z]/g, match => "_" + match.toLowerCase()), value];
  }));
} // Surce: https://gist.github.com/kuroski/9a7ae8e5e5c9e22985364d1ddbf3389d

/**
 * Converts RGB to HSL
 * Source of function: https://www.30secondsofcode.org/js/s/rgb-to-hsl
 */
function $40a5a98adc907fe0$export$499ef00a6a3417f8(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  const l = Math.max(r, g, b);
  const s = l - Math.min(r, g, b);
  const h = s ? l === r ? (g - b) / s : l === g ? 2 + (b - r) / s : 4 + (r - g) / s : 0;
  return [60 * h < 0 ? 60 * h + 360 : 60 * h, 100 * (s ? l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s)) : 0), 100 * (2 * l - s) / 2];
}
function $40a5a98adc907fe0$export$e4fd3b61e79357a7(h, s, l) {
  s /= 100;
  l /= 100;
  const k = n => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = n => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  return [255 * f(0), 255 * f(8), 255 * f(4)];
}
function $40a5a98adc907fe0$export$486b165479b9284f(h, s, b) {
  s /= 100;
  b /= 100;
  const k = n => (n + h / 60) % 6;
  const f = n => b * (1 - s * Math.max(0, Math.min(k(n), 4 - k(n), 1)));
  return [255 * f(5), 255 * f(3), 255 * f(1)];
}
function $40a5a98adc907fe0$export$98c2b3491e76c1f(R8bit, G8bit, B8bit) {
  // from from http://www.w3.org/TR/WCAG20/#relativeluminancedef
  const RsRGB = R8bit / 255;
  const GsRGB = G8bit / 255;
  const BsRGB = B8bit / 255;
  const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
  const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
  const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
  // For the sRGB colorspace, the relative luminance of a color is defined as:
  const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
  return L;
}
function $40a5a98adc907fe0$export$ca305c142c6fc3cf(hex) {
  var _hex$replace, _hex$replace$substrin, _hex$replace$substrin2;
  const rgb = (_hex$replace = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => "#" + r + r + g + g + b + b)) === null || _hex$replace === void 0 ? void 0 : (_hex$replace$substrin = _hex$replace.substring(1)) === null || _hex$replace$substrin === void 0 ? void 0 : (_hex$replace$substrin2 = _hex$replace$substrin.match(/.{2}/g)) === null || _hex$replace$substrin2 === void 0 ? void 0 : _hex$replace$substrin2.map(x => parseInt(x, 16));
  if (!((rgb === null || rgb === void 0 ? void 0 : rgb.length) === 3 && rgb.every(x => typeof x === "number" && x >= 0 && x <= 255))) return null;
  return rgb;
}
const $5ea81d00eec57744$var$MAX_SYNC_RETRIES = 15;
function $5ea81d00eec57744$export$c3f56a35e076f139(selector, data, opts) {
  const {
    getContent: getContent,
    setContent: setContent
  } = opts || {
    getContent: el => el.textContent,
    setContent: (el, content) => el.textContent = content
  };
  const disconnectors = [];
  $76EG6$createEffect(() => {
    const content = data();
    if (!content) return;
    $76EG6$onCleanup(() => {
      disconnectors.forEach(d => d());
    });
    let retries = 0;
    const sync_data = _ref => {
      let {
        element: element
      } = _ref;
      if (retries++ > $5ea81d00eec57744$var$MAX_SYNC_RETRIES) return $241f2f02cc612a49$export$de56f1198d121036("Failed to sync meta text to element. Hit max retries.", selector, content);
      if (!element || getContent(element) === content) return;
      setContent(element, content);
    };
    disconnectors.push((0, $90fa633a9564f115$export$b6ae1bc530f4c149).onremoved(selector, sync_data), (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onchange(selector, sync_data), (0, $90fa633a9564f115$export$b6ae1bc530f4c149).onexists(selector, sync_data));
  });
}
function $34eb7e26a9a798f2$export$e35115e6d0715f77() {
  const [href, set_href] = $76EG6$createSignal(location.href);
  const handler = () => set_href(location.href);
  (0, $ad1dbddac6af350d$export$7500cdfd37aafd43).add(handler);
  $76EG6$onCleanup(() => (0, $ad1dbddac6af350d$export$7500cdfd37aafd43).delete(handler));
  return href;
}
$ea5707b8e7b350cf$export$2cefb7e61fcbae00("utilishared", (0, $b9e07ce3c67aa344$export$83d89fbfd8236492));
export { $e5da8b4d1e6c12b3$export$a13bb02a27aaa5e6 as setOverrideSentryEnvironment, $c9b2d210d5bbc418$export$2d9dc2897d88588 as findMostFrequentItem, $5c580d87c093cc47$export$a7e53ec3b3fdd030 as base64_decode_unicode, $5c580d87c093cc47$export$a1893782a2a6be0d as base64_encode_unicode, $5f4e0abe3139380e$export$6f051469dd676a8b as make_plp_recommendations_inserted_handler, $ea5707b8e7b350cf$export$60d1d0e3cfc8b9ed as version_info, $ea5707b8e7b350cf$export$fe609f0216e4ebef as add_version_query_params, $cdf4691608b4019f$export$6e7454c733fa1fb2 as cache_args, $bcc7b73f8b96a6f0$export$8582cf3716962dc2 as check_displays, $b000f5ef6ce456d9$export$8048b892d651b310 as err, $a01cf8e3169d2af1$export$16d7c76794a38a4 as require_event_listener, $6a44fa3f1acf7693$export$55621c1ce3cd536b as infinite_promise_creator, $4c6e595091defcd9$export$32ccf3a614c84258 as infinite_promise_no_skip, $e64690bc3a7de2b1$export$c7187bbd1a7a9244 as placeholder, $0342f59060b8a196$export$f1b8b9fd75ddcab1 as insert_styling_into_slider, $03021b39f80fac4b$export$2e2bcd8739ae039 as wpff, $7d82513db34b5d27$export$12e07a2a9f87578a as ElementObserver, $90fa633a9564f115$export$b6ae1bc530f4c149 as observer, $0f650018c3cbc373$export$34b9dba7ce09269b as jsx, $0f650018c3cbc373$export$25062201e9e25d76 as jsxs, $a285401a927e4306$export$eb0b9ed911409b57 as use_element, $a285401a927e4306$export$f63fcc839cb0f734 as use_listener, $a285401a927e4306$export$22a65337c1b43b1f as classlist, $0f650018c3cbc373$export$ffb0004e005737fa as Fragment, $241f2f02cc612a49$export$de56f1198d121036 as dlog, $241f2f02cc612a49$export$997143d41f6a0c9b as derror, $241f2f02cc612a49$export$c2363754d4758444 as dwarn, $241f2f02cc612a49$export$2dd75a6b038dc8cb as set_browser_prefix, $5e1f45affc1d7def$export$b3bbfd758f11cfa9 as catchify, $5e1f45affc1d7def$export$f18d5b0af29128b7 as report, $a5a2bdb4ae93374b$export$55fe61489d2c7417 as is_debug, $c755e2b0d4b18501$export$6038895ac52bd044 as chevronLeft, $c755e2b0d4b18501$export$dc84183312f0c201 as chevronRight, $0fe3923936d40f55$export$68c017fd93791405 as expandingContainer, $5f31622ffb78bc10$export$3be7054c61590ee3 as Lazyfier, $5f31622ffb78bc10$export$b87d7e0da8b5cbe3 as test_array_proxy_support, $be288a83d9eabf2a$export$692b27c28639e5b9 as Amazing_Slider, $20fe9624210ef635$export$16501883f477737a as colorize_elements, $20fe9624210ef635$export$deca40f48c0569f8 as should_colorizeLogics, $df6d080cba513381$export$17c3166a7ebd4688 as n_col_styling_with_dist, $df6d080cba513381$export$c84671f46d6a1ca as Layout, $df6d080cba513381$export$483bdd1f1186de13 as layout_get_visible_recs_without_partial_rows, $df6d080cba513381$export$3dc5e2383c924ebf as layout_get_total_rec_amount_for_row, $df6d080cba513381$export$717f13d9ba00ca19 as layout_media_query_header, $b109421811582f8c$export$8cbd8aa1c70f9a13 as slider_autoscroll_factory, $090af64928922937$export$80039a49055269fb as make_button1, $66c5b496f7887c00$export$af88b4929c2dc86 as make_button2, $d3c54fdf1bfb087a$export$1d17a045bcc711b1 as slider_dots_factory, $d3c54fdf1bfb087a$export$a09282b33e69b43f as navdot, $3ad897e1659ee6d7$export$411b0f20794697ce as slider_draggable_factory, $21afac8db3f98820$export$5129719c04a52f8c as slider_fading_factory, $0cbf24ae3e670238$export$5723caf9a8335aa6 as slider_fractional_factory, $4837ebe61ecec421$export$93223e488e7ee078 as slider_show_scroll, $ff905d87817a07f4$export$b36d2489a5a16728 as slider_snap_css, $ff905d87817a07f4$export$49b950309ab787ad as can_use_snapping_and_still_scroll, $e1af55c2112926b7$export$dac64fd35a4805a4 as slider_snapping_factory, $f340c415f2e1d03a$export$68babfc5be0de5da as Amazing_Lazy_Slider, $aadc6d9eeb8e8a56$export$419f84efad7d9fe as sizes_to_surface, $aadc6d9eeb8e8a56$export$417ef0ab13d8b984 as surface_mixer, $aadc6d9eeb8e8a56$export$be95cb0e8cfd099e as promise_until_next_navigation, $bd7c9f254946941d$export$2c34560c3749dc63 as bind_to_a2c_button, $bd7c9f254946941d$export$82a685f2da2fb027 as bind_tracking_to_link, $d5f7352b58e0d737$export$15f8a0cd5a8c0ebb as depict_click, $d5f7352b58e0d737$export$82badda1f9923310 as depict_prefilled, $d5f7352b58e0d737$export$9028351cb994757e as depict_add_to_cart, $d5f7352b58e0d737$export$93ae15b1ae509334 as set_session_id_fn, $d5f7352b58e0d737$export$61e7e1f11e96692f as get_session_id, $d5f7352b58e0d737$export$622991c71a1f52b3 as get_cookie, $d5f7352b58e0d737$export$8c6f26a5b6921b95 as get_tracking_event_context_data, $814c3bf8e175fa59$export$72036d950e1fae95 as filter_depict_payload, $814c3bf8e175fa59$export$28cacbd9b4306ffc as send_depict, $814c3bf8e175fa59$export$cc3b6ddf805f6156 as foolproof_send_beacon, $814c3bf8e175fa59$export$608478473a3304a0 as send_depict_unfiltered, $814c3bf8e175fa59$export$aa26019042811d4f as send_websocket, $799496226e956169$export$674d8cd8b6868154 as create_ga_queue, $799496226e956169$export$edfedd0557ca5a2d as make_tracker_send_to_depict, $d6c3e2ba045accda$export$4205dc6835bc0d9f as send_impression_event, $e89a1d249db21af0$export$37125ccc5dd98050 as impression_track_element, $c633189b7b69d048$export$d0efd8ed14f5c33 as impression_tracking_post_processor, $d6c3e2ba045accda$export$c543ee4cdb0d0964 as set_impression_threshold, $d6c3e2ba045accda$export$135da44d0ba958bc as impression_threshold, $d6c3e2ba045accda$export$ca8321ea61dc2544 as has_to_be_intersecting_for, $df87ac5a30f7baac$export$58c56fe2313fdbe3 as add_new_tab_listener, $df87ac5a30f7baac$export$836f70a28c317905 as broadcast_product_id, $df87ac5a30f7baac$export$8f66c4c7fb96eda2 as contextmenu_callback, $0897f35c3b3fbbc4$export$eee4c4d924348b05 as send_page_view_if_needed, $0897f35c3b3fbbc4$export$f7cb1bd47199ec38 as send_page_view_on_navigation, $f5a4b8e233f0e1cd$export$1d9c6fddbff3441f as DepictAPIWS, $429b4383ef3d586f$export$74108888f38788f3 as ListenableSet, $9c44a7238815fa47$export$535946eb77c946dd as deparallelize, $9c44a7238815fa47$export$f241be8e610f5c77 as deparallelize_no_drop, $ab9c3dbf2bb2fbf7$export$f8ea2e7b15b5d129 as buildThresholdList, $85906d121f53bacd$export$d9fdc6ce2907f95b as chaotic_closest, $652300c6621d5500$export$cfef5d5c9ac09253 as standard_price_format, $652300c6621d5500$export$9590700a594aef08 as ensure_object_path, $652300c6621d5500$export$925772df9b4d16e5 as ensure_parameter_in_url, $652300c6621d5500$export$44951404cb8d0583 as html2elems, $652300c6621d5500$export$d3e2a0560cbf4787 as html2elem, $652300c6621d5500$export$5e63aea0cac01fa0 as querySelectorAllElements, $652300c6621d5500$export$785f04709990c4ec as querySelectorUpwards, $652300c6621d5500$export$f124e3ee16e6b45d as intl_number_format_with_fallback, $652300c6621d5500$export$d4bd03f19260ef1c as relativify, $45d268baa2df1ba1$export$6b75200e58bc97d0 as deduplicate, $45d268baa2df1ba1$export$9426572bd5645bc1 as dedup_products, $8183c177c3bdf94d$export$82539d9817116aff as navigate_with_next_router, $f69445e469425bcb$export$774bc87373c4fc6c as add_item, $f69445e469425bcb$export$337197b94b3bd680 as get_items_in_cart, $f69445e469425bcb$export$783ef16647773b3d as get_shopify_analytics_meta_product, $f69445e469425bcb$export$ab0f802c05dd969b as intercept, $201e455525e1fa49$export$85be83e1935d93c2 as fetch_replacer, $201e455525e1fa49$export$f8da66bc4f1d059e as FakeResponse, $c95f8181bad32e8d$export$bcd70d5ed1cf6313 as fetch_retry, $ad1dbddac6af350d$export$20e9533e68ee72e7 as stateless_href_change_ipns, $ad1dbddac6af350d$export$a9d39e43ae273d26 as href_change_ipns, $ad1dbddac6af350d$export$baccefee4a395d8f as history_replacer, $ad1dbddac6af350d$export$1cd22bab0d2c3b0b as on_next_navigation, $ad1dbddac6af350d$export$7500cdfd37aafd43 as instant_exec_on_suspect_history_change, $7ca6fdc721083788$export$e806c6c1615a59ae as async_iterable_ipns, $7ca6fdc721083788$export$10c3e52ef388b81b as make_ipns_stateful, $7ca6fdc721083788$export$90740b5bc9c2b3b7 as make_ipns_stateless, $449d6683cecfa078$export$3e42f5078e3abfc0 as make_simple_async_iterable, $449d6683cecfa078$export$e2c811ae0eb35313 as RawObservableInformation, $c1590f86e0eca625$export$2c2f50b30b7b2576 as iterable_to_attribute, $332ef338faf216a4$export$7c081fdbc65b6a2a as iterable_to_elems, $fee212025270d5b9$export$927664b47117acb0 as make_asyncIterable_exiter, $07beada135e5f5e8$export$f8913c8a18f7ca21 as zip_async_iterables, $2c22b027931240e6$export$f811d2ce0aa6019b as insert_surfaces, $2c22b027931240e6$export$b8d1e1d07a3f3776 as prevent_infinite_loop, $2c22b027931240e6$export$e3f70ef7e3d00501 as revertable_remove, $1013f2e568f87406$export$59ba1eb2c083f0cd as insert_styling, $1013f2e568f87406$export$692b606677218a16 as depict_init, $1013f2e568f87406$export$328e81c44cddf3c0 as depict_init_with_market_logic, $1013f2e568f87406$export$a4f97b27a0592e6c as normal_get_product_id, $26dbd7db7fd1bc2c$export$515c3ea4d599b05a as javascript_media_query, $914c6f35222c820d$export$33f937d741e49339 as patched_querySelectorAll, $6c8c963618d41bb2$export$947a20746936143d as Promise_Any, $3a96de5a459d34f9$export$c50e1901e8ed0615 as queueMacroTask, $1cd1e96fe31c935d$export$bb0a9c36cf454ea0 as rand, $6cb4d83127e468ea$export$656831b7e9c341c3 as random_string, $6cb4d83127e468ea$export$a6db784f019668ba as make_random_classname, $2b6304d4ce419ed5$export$3d04c40e7acc1a32 as reactive_template, $243da8b4990520aa$export$8ec5c86406f333ff as removeChild_error_swallowing_factory, $9c0a16930ae6750f$export$38e89c688f9d553a as replace_promise_with_native_if_exists_and_enforce, $9c0a16930ae6750f$export$e647444ed9403635 as get_iframe_promise, $f82333cd2ffc1582$export$2a1cc61cffa1f36f as rp_relativify_fetch, $f82333cd2ffc1582$export$f14a775632a826c4 as rp_relativify_history, $f82333cd2ffc1582$export$2a38b176ce969e2c as rp_relativify_xhr, $f82333cd2ffc1582$export$83ec13b10b391f13 as default_rp_fixes, $d9aec442b12a1134$export$39d526a1194b6499 as serialize_object, $b2c9f99c083a1182$export$12b4c6cbc6b8b4e4 as sort_obj, $95b71532fa7f905c$export$a422d714c8cb1a5d as standard_get_market, $cb3a51d87cbe5eff$export$3427ec8268623f1 as listenToLocalStorage, $26145caeb41f1f7b$export$cd1adfb8059b5fcd as timeout_promise, $2da62df28669a48a$export$79f910a98828378d as variable_setter_to_ipns, $2da62df28669a48a$export$d5062f468a0454f3 as find_descriptor, $2da62df28669a48a$export$2fc1a072736ae2f6 as is_available_in, $8a812fa4638e2832$export$a739d9a07da7f9ce as use_voyado_id, $57642e3bf93ac1e7$export$5c069c93d2b7493f as wait, $24528b2f119d82fb$export$f314addd5f976083 as xhr_load, $24528b2f119d82fb$export$8e16c51fd2b6507 as xhr_read_interceptor, $24528b2f119d82fb$export$c74578d2cd47a84a as xhr_send_interceptor, $24528b2f119d82fb$export$33d1643df63073a8 as xhr_replace, $c40fc6dc2c22b3c4$export$4a3043e508dd72f0 as DefaultViewMoreButton, $a59cde169150d10b$export$8a0e4d6f6abf7e90 as GeneralSideSlidein, $24f3fd73864991c0$export$c068ad5361be7646 as GeneralSizeSelector, $adc0bb548fdb574f$export$84712d0562a614b8 as Placeholder, $adc0bb548fdb574f$export$d613f5b6d0a331a8 as ContainedPlaceholderImage, $2e6ca552eb0e0b2b$export$97f31f44c68c1d5 as RecommendationContainer, $ad0b2591dac160be$export$ddd70fdae1b350e6 as LeftChevron, $ad0b2591dac160be$export$32a55d57d151bc5a as RightChevron, $9a74c17d1ef21fdf$export$590326cc34f49e2d as createColorPicker, $0f55c2bc0a7b363b$export$237455ad7e59d4e5 as useExpandingContainer, $73f0a7e385687d5d$export$2369f6fc1c911576 as ContainedHoverImage, $c987460cedc0d7ec$export$788756b42446dc2d as ContainedImage, $9ef5ce4804a3b61b$export$f39a7d0667e924a as make_sizes_setter, $9ef5ce4804a3b61b$export$a62825542f1bfcf5 as make_sourceset_component, $9ef5ce4804a3b61b$export$a98fc8a2c818d3d8 as is_safari, $9ef5ce4804a3b61b$export$f7c915448031deac as make_url_with_query_params, $9ef5ce4804a3b61b$export$3d13beba9b52c947 as resize_base_url, $9e4bee2e3b4b5753$export$362abebb4b313340 as base_url, $17bb552dedcd526c$export$af2e17a20c2ea3c5 as Sentry, $c07f1f2ffdcaec61$export$9dc8f3a0aa3efc85 as camelCasifyObject, $c07f1f2ffdcaec61$export$b481488de1caa85 as snakeCasifyObject, $40a5a98adc907fe0$export$499ef00a6a3417f8 as rgb_to_hsl, $40a5a98adc907fe0$export$e4fd3b61e79357a7 as hsl_to_rgb, $40a5a98adc907fe0$export$98c2b3491e76c1f as relative_luminance_from_rgb, $40a5a98adc907fe0$export$486b165479b9284f as hsb_to_rgb, $40a5a98adc907fe0$export$ca305c142c6fc3cf as hex_to_rgb, $b9e07ce3c67aa344$export$83d89fbfd8236492 as version, $ea5707b8e7b350cf$export$2cefb7e61fcbae00 as add_to_version_info, $5ea81d00eec57744$export$c3f56a35e076f139 as sync_el_content_with_accessor, $34eb7e26a9a798f2$export$e35115e6d0715f77 as use_href_accessor };